webpackJsonp([14],{

/***/ 1006:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1007);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(516)("29832c47", content, true, {});

/***/ }),

/***/ 1007:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(515)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.resources-assignment-page[data-v-e00fb316]{height:calc(100vh - 80px);overflow-x:hidden;overflow-y:auto;padding-bottom:58px;-webkit-transition:padding-left .22s ease;transition:padding-left .22s ease;scrollbar-color:#9db8d1 #edf2f7;scrollbar-width:thin}.resources-assignment-page[data-v-e00fb316]::-webkit-scrollbar{width:9px}.resources-assignment-page[data-v-e00fb316]::-webkit-scrollbar-track{background:#edf2f7}.resources-assignment-page[data-v-e00fb316]::-webkit-scrollbar-thumb{background:#9db8d1;border:2px solid #edf2f7;border-radius:999px}.resources-assignment-page[data-v-e00fb316]::-webkit-scrollbar-thumb:hover{background:#6f96b8}.resources-assignment-page.has-menu-builder[data-v-e00fb316]{padding-left:230px}.resources-assignment-page.menu-builder-empty[data-v-e00fb316]{padding-left:202px}.resources-assignment-page.menu-builder-empty .menu-preview-panel[data-v-e00fb316]{width:188px}.resources-assignment-page>.modal-filter-footer[data-v-e00fb316]{bottom:34px;z-index:3}.assignment-finish-button[data-v-e00fb316]{background:#1a4338!important;-webkit-box-shadow:0 5px 12px rgba(26,67,56,.2)!important;box-shadow:0 5px 12px rgba(26,67,56,.2)!important;min-width:190px!important}.distribution-question-card[data-v-e00fb316]{background:#fff;border:1px solid rgba(26,67,56,.16);border-radius:16px!important;-webkit-box-shadow:0 22px 55px rgba(25,53,79,.22)!important;box-shadow:0 22px 55px rgba(25,53,79,.22)!important;overflow:hidden;position:relative}.distribution-question-accent[data-v-e00fb316]{background:-webkit-gradient(linear,left top,right top,from(#1a4338),to(#2e6b59));background:linear-gradient(90deg,#1a4338,#2e6b59);height:4px;left:0;position:absolute;right:0;top:0}.distribution-question-title[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:linear-gradient(135deg,#f4f8f6,#eef5f2);border-bottom:1px solid #dfebe7;display:-webkit-box;display:-ms-flexbox;display:flex;gap:14px;padding:23px 24px 19px!important}.distribution-question-heading[data-v-e00fb316]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:0}.distribution-question-heading small[data-v-e00fb316],.distribution-question-heading strong[data-v-e00fb316]{display:block}.distribution-question-heading strong[data-v-e00fb316]{color:#243f57;font-size:18px;line-height:1.25;margin-top:3px}.distribution-question-heading small[data-v-e00fb316]{color:#1a4338;font-size:9px;font-weight:700;letter-spacing:.12em}.distribution-question-close[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:transparent;border:0;border-radius:8px;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;height:32px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:32px}.distribution-question-close .icon[data-v-e00fb316]{color:#7890a3!important;font-size:20px}.distribution-question-close[data-v-e00fb316]:hover{background:rgba(46,107,89,.09)}.distribution-question-icon[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:linear-gradient(135deg,#1a4338,#2e6b59);border-radius:12px;-webkit-box-shadow:0 7px 16px rgba(46,107,89,.24);box-shadow:0 7px 16px rgba(46,107,89,.24);display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;height:46px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:46px}.distribution-question-icon .icon[data-v-e00fb316]{color:#fff!important;font-size:23px}.distribution-question-content[data-v-e00fb316]{padding:22px 24px 8px!important}.distribution-question-content h3[data-v-e00fb316]{color:#29465e;font-size:16px;margin:0 0 7px}.distribution-question-content p[data-v-e00fb316]{color:#6f8395;font-size:12px;line-height:1.55;margin:0}.distribution-question-note[data-v-e00fb316]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;background:#f4f8f6;border:1px solid #dfebe7;border-radius:10px;color:#587086;display:-webkit-box;display:-ms-flexbox;display:flex;font-size:11px;gap:9px;line-height:1.45;margin-top:15px;padding:10px 12px}.distribution-question-note .icon[data-v-e00fb316]{color:#1a4338!important;font-size:18px}.distribution-question-actions[data-v-e00fb316]{display:-webkit-box;display:-ms-flexbox;display:flex;gap:10px;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;padding:16px 24px 22px!important}.distribution-question-actions .btn[data-v-e00fb316]{border-radius:9px;height:38px!important;margin:0!important;text-transform:none}.distribution-secondary-action[data-v-e00fb316]{border:1px solid #d5e1ea!important;color:#526b80!important}.distribution-primary-action[data-v-e00fb316]{-webkit-box-shadow:0 7px 16px rgba(26,67,56,.22)!important;box-shadow:0 7px 16px rgba(26,67,56,.22)!important;min-width:150px}.items-arragnment[data-v-e00fb316]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}.responsive-grid[data-v-e00fb316]{display:grid;grid-gap:9px;grid-template-columns:repeat(auto-fill,minmax(248px,1fr))}.module-section[data-v-e00fb316]{background-color:#fff}.assignment-toolbar[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:-webkit-gradient(linear,left top,right top,from(#f4f8f6),to(#f4f8f6));background:linear-gradient(90deg,#f4f8f6,#f4f8f6);border-bottom:1px solid #e2eaf2;display:-webkit-box;display:-ms-flexbox;display:flex;gap:10px;margin:0!important;min-height:56px;padding-bottom:7px;padding-top:7px}.role-picker[data-v-e00fb316]{-webkit-box-flex:0;-ms-flex:0 1 250px;flex:0 1 250px;max-width:250px}.role-create-action[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;gap:8px;max-width:-webkit-max-content;max-width:-moz-max-content;max-width:max-content}.role-create-action .btn[data-v-e00fb316]{margin:0!important}.create-role-button[data-v-e00fb316]{border-radius:8px;-webkit-box-shadow:0 3px 9px rgba(26,67,56,.2)!important;box-shadow:0 3px 9px rgba(26,67,56,.2)!important;height:36px;margin:0;padding:0 14px;text-transform:none}.create-role-button .icon[data-v-e00fb316]{font-size:19px;margin-left:5px}.assignment-empty-state[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#74879a;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin:auto;max-width:620px;min-height:calc(100vh - 230px);padding:28px 20px 80px;text-align:center}.assignment-empty-state>small[data-v-e00fb316]{color:#1a4338;font-size:9px;font-weight:700;letter-spacing:.14em;margin-top:13px}.assignment-empty-state h2[data-v-e00fb316]{color:#263f57;font-size:23px;margin:5px 0 7px}.assignment-empty-state p[data-v-e00fb316]{font-size:12px;line-height:1.55;margin:0;max-width:430px}.assignment-empty-icon[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:linear-gradient(135deg,#eaf3ef,#dceae4);border:1px solid #c4dbd3;border-radius:16px;-webkit-box-shadow:0 8px 24px rgba(26,67,56,.12);box-shadow:0 8px 24px rgba(26,67,56,.12);display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;height:62px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:62px}.assignment-empty-icon .icon[data-v-e00fb316]{color:#1a4338;font-size:30px}.assignment-empty-steps[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:hsla(0,0%,100%,.72);border:1px solid #e0e9f1;border-radius:12px;display:-webkit-box;display:-ms-flexbox;display:flex;gap:9px;margin-top:20px;padding:8px 12px}.assignment-empty-steps span[data-v-e00fb316]{color:#536b80;font-size:10px;font-weight:600;gap:5px;white-space:nowrap}.assignment-empty-steps i[data-v-e00fb316],.assignment-empty-steps span[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.assignment-empty-steps i[data-v-e00fb316]{background:#eaf3ef;border-radius:50%;color:#1a4338;font-size:9px;font-style:normal;height:20px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:20px}.assignment-empty-steps .icon[data-v-e00fb316]{color:#a6b4c0;font-size:15px}.assignment-panel[data-v-e00fb316]{background:#fff;border:1px solid #dfe7ef;border-radius:12px;-webkit-box-shadow:0 3px 12px rgba(31,56,82,.06);box-shadow:0 3px 12px rgba(31,56,82,.06);margin-top:9px;padding:12px 14px 14px}.assignment-progress[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#fff;border-bottom:1px solid #e5ebf1;display:-webkit-box;display:-ms-flexbox;display:flex;gap:7px;min-height:42px}.assignment-progress>.icon[data-v-e00fb316]{color:#b1bdc8;font-size:17px}.progress-step[data-v-e00fb316]{color:#93a1ae;font-size:11px;font-weight:600;gap:6px}.progress-step[data-v-e00fb316],.progress-step i[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.progress-step i[data-v-e00fb316]{background:#edf1f5;border-radius:50%;font-size:9px;font-style:normal;height:21px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:21px}.progress-step.is-active[data-v-e00fb316]{color:#1a4338}.progress-step.is-active i[data-v-e00fb316]{background:#1a4338;color:#fff}.progress-step.is-complete[data-v-e00fb316]{color:#23834a}.progress-step.is-complete i[data-v-e00fb316]{background:#dff3e7;color:#23834a}.assignment-section-header[data-v-e00fb316]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:10px}.assignment-section-header>div[data-v-e00fb316]:first-child,.assignment-section-header[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex}.assignment-section-header>div[data-v-e00fb316]:first-child{gap:7px}.assignment-section-header h3[data-v-e00fb316]{color:#2b435b;font-family:Opens_semibold;font-size:14px;margin:0}.assignment-section-header .icon[data-v-e00fb316]{font-size:20px}.assignment-summary[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#8191a1;display:-webkit-box;display:-ms-flexbox;display:flex;font-size:10px;gap:7px}.assignment-summary span[data-v-e00fb316]{background:#f0f3f6;border-radius:999px;padding:5px 9px}.assignment-summary .enabled-count[data-v-e00fb316]{background:#e3f6eb;color:#23834a;font-weight:700}.selection-path[data-v-e00fb316]{background:#f4f8f6;border:1px solid #dce9e4;border-radius:10px;gap:10px;margin-top:8px;min-height:48px;padding:5px 9px}.selection-path-item[data-v-e00fb316],.selection-path[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex}.selection-path-item[data-v-e00fb316]{-webkit-box-flex:1;-ms-flex:1 1 0px;flex:1 1 0;min-width:0}.selection-path-item .selection-path-copy[data-v-e00fb316]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:2px;margin-left:10px}.selection-path-item .selection-path-copy small[data-v-e00fb316]{color:#8495a5;font-size:8px;text-transform:uppercase}.selection-path-item .selection-path-copy strong[data-v-e00fb316]{color:#29445e;font-size:12px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.selection-path-item .change-selection-button[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#fff;border:1px solid #cbddeb;border-radius:7px;color:#1a4338;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;font-size:10px;font-weight:600;height:28px;margin-left:auto;min-width:28px;padding:0;width:28px}.selection-path-item .change-selection-button .icon[data-v-e00fb316]{color:#1a4338;font-size:15px}.selection-path-item .change-selection-button[data-v-e00fb316]:hover{background:#f4f8f6}.path-actions[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;margin-left:auto;white-space:nowrap}.path-status[data-v-e00fb316]{background:#e3f6eb;border-radius:999px;color:#23834a;font-size:9px;font-weight:700;margin-right:4px;padding:4px 7px}.path-icon[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-radius:7px;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-flex:0;-ms-flex:0 0 30px;flex:0 0 30px;height:30px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:30px}.path-icon .icon[data-v-e00fb316]{font-size:16px}.path-divider[data-v-e00fb316]{color:#a4b3c1;font-size:18px}.app-selection[data-v-e00fb316]{background:linear-gradient(135deg,#2e6b59,#1a4338)}.module-selection[data-v-e00fb316]{background:linear-gradient(135deg,#35aa6e,#23834a)}.fade-down-enter-active[data-v-e00fb316]{-webkit-transition:all .4s ease;transition:all .4s ease}.fade-down-leave-active[data-v-e00fb316]{-webkit-transition:all .8s cubic-bezier(1,.5,.8,1);transition:all .8s cubic-bezier(1,.5,.8,1)}.fade-down-enter[data-v-e00fb316],.fade-down-leave-to[data-v-e00fb316]{opacity:0;-webkit-transform:translateY(20px);transform:translateY(20px)}.resource-table-card[data-v-e00fb316]{background:#fff;border:1px solid #dfe6ee;border-radius:8px;-webkit-box-shadow:0 4px 14px rgba(31,56,82,.08);box-shadow:0 4px 14px rgba(31,56,82,.08);overflow:hidden}.resource-table-toolbar[data-v-e00fb316]{background:#fff;border-bottom:1px solid #eef2f7;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:10px;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:11px 16px}.resource-search[data-v-e00fb316],.resource-table-toolbar[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex}.resource-search[data-v-e00fb316]{background:#f4f7fa;border:1px solid #e2e9f0;border-radius:9px;-webkit-box-flex:1;-ms-flex:1 1 240px;flex:1 1 240px;gap:7px;height:36px;max-width:380px;padding:0 10px;-webkit-transition:border-color .15s ease,-webkit-box-shadow .15s ease;transition:border-color .15s ease,-webkit-box-shadow .15s ease;transition:border-color .15s ease,box-shadow .15s ease;transition:border-color .15s ease,box-shadow .15s ease,-webkit-box-shadow .15s ease}.resource-search>.icon[data-v-e00fb316]{color:#a9b6c2;font-size:18px}.resource-search input[data-v-e00fb316]{background:transparent;border:0;color:#2b435b;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;font-size:12px;min-width:0;outline:none}.resource-search input[data-v-e00fb316]::-webkit-input-placeholder{color:#a9b6c2}.resource-search input[data-v-e00fb316]::-moz-placeholder{color:#a9b6c2}.resource-search input[data-v-e00fb316]::-ms-input-placeholder{color:#a9b6c2}.resource-search input[data-v-e00fb316]::placeholder{color:#a9b6c2}.resource-search button[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#e2e9f0;border:0;border-radius:50%;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;height:18px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;outline:none;width:18px}.resource-search button .icon[data-v-e00fb316]{color:#6b7c8d;font-size:13px}.resource-search button[data-v-e00fb316]:hover{background:#d3dde7}.resource-search.is-filled[data-v-e00fb316],.resource-search[data-v-e00fb316]:focus-within{background:#fff;border-color:#1a4338;-webkit-box-shadow:0 0 0 3px rgba(26,67,56,.1);box-shadow:0 0 0 3px rgba(26,67,56,.1)}.resource-filter-chips[data-v-e00fb316]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:6px}.resource-filter-chip[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#f4f7fa;border:1px solid #e2e9f0;border-radius:20px;color:#6b7c8d;cursor:pointer;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;font-size:11px;font-weight:700;gap:6px;height:32px;outline:none;padding:0 12px;-webkit-transition:background .15s ease,border-color .15s ease,color .15s ease;transition:background .15s ease,border-color .15s ease,color .15s ease}.resource-filter-chip strong[data-v-e00fb316]{background:#e5ebf1;border-radius:9px;color:#53697d;font-size:10px;min-width:20px;padding:2px 5px;text-align:center}.resource-filter-chip[data-v-e00fb316]:hover{border-color:#c9d6e2}.resource-filter-chip.is-active[data-v-e00fb316]{background:#1a4338;border-color:#1a4338;color:#fff}.resource-filter-chip.is-active strong[data-v-e00fb316]{background:hsla(0,0%,100%,.18);color:#fff}.resource-filter-chip--pending strong[data-v-e00fb316]{background:#fdf1dc;color:#a6711a}.resource-filter-chip--pending.is-active[data-v-e00fb316]{background:#a6711a;border-color:#a6711a}.resource-filter-empty[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#f7f9fc;border-bottom:1px solid #e4eaf0;display:-webkit-box;display:-ms-flexbox;display:flex;gap:11px;padding:13px 16px}.resource-filter-empty>.icon[data-v-e00fb316]{color:#a9b6c2;font-size:22px}.resource-filter-empty strong[data-v-e00fb316]{color:#2b435b;display:block;font-size:13px}.resource-filter-empty small[data-v-e00fb316]{color:#8495a5;font-size:11px}.resource-filter-empty div[data-v-e00fb316]{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}.resource-filter-empty button[data-v-e00fb316]{background:#fff;border:1px solid #d4dee7;border-radius:8px;color:#176fc1;cursor:pointer;font-size:11px;font-weight:700;height:32px;outline:none;padding:0 12px}.resource-filter-empty button[data-v-e00fb316]:hover{background:#f1f5f9}.summary-chip-pending[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#fdf1dc;color:#a6711a;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;gap:5px}.summary-chip-pending .icon[data-v-e00fb316]{color:#e19a18;font-size:15px}.position-control[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;gap:4px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.position-steppers[data-v-e00fb316]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:2px}.position-steppers button[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#f1f5f9;border:1px solid #e2e9f0;border-radius:5px;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;height:15px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;outline:none;padding:0;width:22px}.position-steppers button .icon[data-v-e00fb316]{color:#53697d;font-size:14px}.position-steppers button[data-v-e00fb316]:hover:not(:disabled){background:#e2e9f0}.position-steppers button[data-v-e00fb316]:disabled{cursor:default;opacity:.4}.position-steppers button:disabled .icon[data-v-e00fb316]{color:#a9b6c2}.resource-table-guide[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#f7f9fc;border-bottom:1px solid #e4eaf0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;min-height:52px;padding:8px 16px}.resource-table-guide-text[data-v-e00fb316],.resource-table-summary[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;gap:8px}.resource-table-guide-text[data-v-e00fb316]{color:#526271}.summary-chip[data-v-e00fb316]{background:#e8edf2;border-radius:12px;color:#536473;font-size:12px;font-weight:600;padding:4px 10px}.summary-chip-active[data-v-e00fb316]{background:#dff3e6;color:#23834a}.menu-preview-trigger[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#f4f8f6;border:1px solid #c4dbd3;border-radius:8px;color:#1a4338;cursor:pointer;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;font-size:11px;font-weight:700;gap:6px;height:32px;padding:0 8px 0 10px;white-space:nowrap}.menu-preview-trigger .icon[data-v-e00fb316]{color:#1a4338;font-size:18px}.menu-preview-trigger strong[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#1a4338;border-radius:999px;color:#fff;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;font-size:10px;height:20px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;min-width:20px;padding:0 5px}.menu-preview-trigger[data-v-e00fb316]:hover{background:#e4f0eb;border-color:#70a997}.menu-preview-backdrop[data-v-e00fb316]{background:rgba(20,39,58,.32);border:0;bottom:0;cursor:default;left:0;padding:0;position:fixed;right:0;top:56px;z-index:8;display:none}.menu-preview-panel[data-v-e00fb316]{background:#f8fafc;border-right:1px solid #dbe5ee;bottom:0;-webkit-box-shadow:12px 0 30px rgba(27,51,75,.18);box-shadow:12px 0 30px rgba(27,51,75,.18);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;left:0;position:fixed;top:56px;width:230px;z-index:9}.menu-preview-header[data-v-e00fb316]{background:#fff;border-bottom:1px solid #e1e9f0;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;min-height:74px;padding:12px 16px}.menu-preview-header>div[data-v-e00fb316],.menu-preview-header[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex}.menu-preview-header>div[data-v-e00fb316]{gap:10px}.menu-preview-header small[data-v-e00fb316]{color:#6f8294;display:block;font-size:9px;font-weight:700;letter-spacing:.1em}.menu-preview-header h3[data-v-e00fb316]{color:#20394f;font-size:17px;line-height:1.25;margin:3px 0 0}.menu-preview-header>button[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#f0f4f7;border:0;border-radius:7px;cursor:pointer;display:none;height:30px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:30px}.menu-preview-header>button .icon[data-v-e00fb316]{color:#53697d;font-size:18px}.menu-preview-mobile-trigger[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#f4f8f6;border:1px solid #c8ddd5;border-radius:7px;cursor:pointer;display:none;height:28px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-left:4px;width:28px}.menu-preview-mobile-trigger .icon[data-v-e00fb316]{color:#1a4338;font-size:16px}.menu-preview-icon[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:linear-gradient(135deg,#2e6b59,#1a4338);border-radius:9px;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;height:42px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:42px}.menu-preview-icon .icon[data-v-e00fb316]{font-size:22px}.menu-preview-context[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#f4f8f6;border-bottom:1px solid #d7e6e0;display:-webkit-box;display:-ms-flexbox;display:flex;gap:8px;padding:9px 14px}.menu-preview-context>.icon[data-v-e00fb316]{color:#1a4338;font-size:18px}.menu-preview-context>div[data-v-e00fb316]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1;flex:1;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;min-width:0}.menu-preview-context small[data-v-e00fb316]{color:#74889a;font-size:8px;text-transform:uppercase}.menu-preview-context strong[data-v-e00fb316]{color:#29445e;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.menu-preview-context>span[data-v-e00fb316]{color:#53718c;font-size:9px;white-space:nowrap}.menu-preview-list[data-v-e00fb316]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1;flex:1;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:6px;min-height:0;overflow-y:auto;padding:10px}.menu-preview-group[data-v-e00fb316]{background:#fff;border:1px solid #dfe7ef;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;overflow:hidden;-webkit-transition:border-color .15s ease,-webkit-box-shadow .15s ease;transition:border-color .15s ease,-webkit-box-shadow .15s ease;transition:border-color .15s ease,box-shadow .15s ease;transition:border-color .15s ease,box-shadow .15s ease,-webkit-box-shadow .15s ease}.menu-preview-group[data-v-e00fb316]:hover{border-color:#70a997;-webkit-box-shadow:0 3px 9px rgba(26,67,56,.1);box-shadow:0 3px 9px rgba(26,67,56,.1)}.menu-preview-group.is-current[data-v-e00fb316]{background:#edf8f2;border-color:#74c99a}.menu-preview-group.is-current .menu-preview-position[data-v-e00fb316]{background:#27945a}.menu-preview-group.is-current .menu-preview-item>.icon[data-v-e00fb316]{color:#27945a}.menu-preview-item[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:transparent;border:0;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;gap:10px;min-height:52px;padding:6px 9px;text-align:left;-webkit-transition:background .15s ease;transition:background .15s ease;width:100%}.menu-preview-item>.icon[data-v-e00fb316]{color:#91a1af;font-size:18px}.menu-preview-item[data-v-e00fb316]:hover{background:rgba(26,67,56,.05)}.menu-preview-module-row[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex}.menu-preview-module-row .menu-preview-item[data-v-e00fb316]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:0}.menu-preview-delete-module[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:rgba(232,73,73,.12);border:0;border-radius:7px;cursor:pointer;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-flex:0;-ms-flex:0 0 30px;flex:0 0 30px;height:30px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-right:7px;-webkit-transition:background .15s ease;transition:background .15s ease}.menu-preview-delete-module .icon[data-v-e00fb316]{color:#ffb3b3!important;font-size:17px}.menu-preview-delete-module[data-v-e00fb316]:hover{background:rgba(232,73,73,.3)}.menu-preview-position[data-v-e00fb316]{background:#1a4338;border-radius:8px;font-size:12px;font-weight:700;height:34px;-ms-flex-pack:center;min-width:34px}.menu-entry-icon[data-v-e00fb316],.menu-preview-position[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-pack:center;justify-content:center}.menu-entry-icon[data-v-e00fb316]{background:#edf3f8;border:1px solid #d6e2ec;border-radius:7px;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;-ms-flex-pack:center;overflow:hidden;position:relative}.menu-entry-icon .icon[data-v-e00fb316]{color:#6e879b}.menu-entry-icon img[data-v-e00fb316]{background:inherit;height:78%;-o-object-fit:contain;object-fit:contain;position:absolute;width:78%}.menu-entry-icon img.is-hidden[data-v-e00fb316]{display:none}.module-menu-icon[data-v-e00fb316]{height:32px;width:32px}.module-menu-icon .icon[data-v-e00fb316]{font-size:17px}.resource-menu-icon[data-v-e00fb316]{border-radius:5px;height:23px;width:23px}.resource-menu-icon .icon[data-v-e00fb316]{font-size:14px!important}.menu-preview-name[data-v-e00fb316]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1;flex:1;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;min-width:0}.menu-preview-name strong[data-v-e00fb316]{color:#2d465d;font-size:12px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.menu-preview-name small[data-v-e00fb316]{color:#8393a2;font-size:9px;margin-top:2px}.menu-preview-submenu[data-v-e00fb316]{border-top:1px solid #e8eef3;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin:0 9px 7px 52px;padding-top:4px}.menu-preview-submenu button[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:transparent;border:0;border-radius:6px;color:#526b80;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;gap:5px;min-height:30px;padding:3px 5px;text-align:left;width:100%}.menu-preview-submenu button[data-v-e00fb316]:hover{background:#eaf3ef;color:#1a4338}.menu-preview-submenu button>span[data-v-e00fb316]{color:#90a0ae;font-size:9px;min-width:13px}.menu-preview-submenu button>.icon[data-v-e00fb316]{color:#668f82;font-size:14px}.menu-preview-submenu button strong[data-v-e00fb316]{font-size:10px;font-weight:600;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.menu-preview-no-submenu[data-v-e00fb316]{border-top:1px solid #e8eef3;color:#9aa7b3;font-size:9px;font-style:italic;margin:0 9px 7px 52px;padding:7px 5px 2px}.menu-preview-empty[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#8191a1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1;flex:1;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:24px;text-align:center}.menu-preview-empty .icon[data-v-e00fb316]{color:#82a69a;font-size:42px}.menu-preview-empty strong[data-v-e00fb316]{color:#415c74;font-size:13px;margin:8px 0 4px}.menu-preview-empty span[data-v-e00fb316]{font-size:11px;line-height:1.45}.add-module-button[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#f4f8f6;border:1px dashed #70a997;border-radius:10px;color:#1a4338;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;gap:9px;margin:8px 10px;min-height:48px;padding:6px 9px;text-align:left;-webkit-transition:background .15s ease,border-color .15s ease,-webkit-transform .15s ease;transition:background .15s ease,border-color .15s ease,-webkit-transform .15s ease;transition:background .15s ease,border-color .15s ease,transform .15s ease;transition:background .15s ease,border-color .15s ease,transform .15s ease,-webkit-transform .15s ease;width:calc(100% - 20px)}.add-module-button>span[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#1a4338;border-radius:8px;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;height:32px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:32px}.add-module-button>span .icon[data-v-e00fb316]{color:#fff;font-size:19px}.add-module-button>div[data-v-e00fb316]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1;flex:1;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;min-width:0}.add-module-button strong[data-v-e00fb316]{color:#1a4338;font-size:11px}.add-module-button small[data-v-e00fb316]{color:#71889c;font-size:9px;margin-top:1px}.add-module-button>.icon[data-v-e00fb316]{color:#5d8f7f;font-size:18px}.add-module-button[data-v-e00fb316]:hover{background:#eaf3ef;border-color:#1a4338;-webkit-transform:translateY(-1px);transform:translateY(-1px)}.menu-preview-panel footer[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#fff;border-top:1px solid #e1e9f0;color:#758697;display:-webkit-box;display:-ms-flexbox;display:flex;font-size:9px;gap:6px;min-height:38px;padding:7px 12px}.menu-preview-panel footer .icon[data-v-e00fb316]{color:#1a4338;font-size:16px}.menu-preview-panel[data-v-e00fb316]{background:radial-gradient(circle at 15% 5%,rgba(70,135,114,.26),transparent 28%),-webkit-gradient(linear,left top,left bottom,from(#1a4b3e),color-stop(48%,#163d33),to(#0d2a23));background:radial-gradient(circle at 15% 5%,rgba(70,135,114,.26),transparent 28%),linear-gradient(180deg,#1a4b3e,#163d33 48%,#0d2a23);border-right-color:hsla(0,0%,100%,.15);-webkit-box-shadow:12px 0 32px rgba(8,36,29,.28);box-shadow:12px 0 32px rgba(8,36,29,.28)}.menu-preview-header[data-v-e00fb316]{background:rgba(8,39,31,.34);border-bottom-color:hsla(0,0%,100%,.13);-webkit-backdrop-filter:blur(8px);backdrop-filter:blur(8px)}.menu-preview-header small[data-v-e00fb316]{color:#b5d7cb}.menu-preview-header h3[data-v-e00fb316]{color:#fff}.menu-preview-header>button[data-v-e00fb316]{background:hsla(0,0%,100%,.12)}.menu-preview-header>button .icon[data-v-e00fb316]{color:#fff}.menu-preview-icon[data-v-e00fb316]{background:hsla(0,0%,100%,.16);border:1px solid hsla(0,0%,100%,.25);-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.14);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.14)}.menu-preview-context[data-v-e00fb316]{background:rgba(8,36,29,.25);border-bottom-color:hsla(0,0%,100%,.11)}.menu-preview-context>.icon[data-v-e00fb316]{color:#fff}.menu-preview-context small[data-v-e00fb316]{color:#9fc2b6}.menu-preview-context strong[data-v-e00fb316]{color:#fff}.menu-preview-context>span[data-v-e00fb316]{color:#c2dbd2}.menu-preview-list[data-v-e00fb316]{scrollbar-color:hsla(0,0%,100%,.34) transparent;scrollbar-width:thin}.menu-preview-list[data-v-e00fb316]::-webkit-scrollbar{width:6px}.menu-preview-list[data-v-e00fb316]::-webkit-scrollbar-track{background:transparent}.menu-preview-list[data-v-e00fb316]::-webkit-scrollbar-thumb{background:hsla(0,0%,100%,.3);border-radius:999px}.menu-preview-group[data-v-e00fb316]{background:hsla(0,0%,100%,.08);border-color:hsla(0,0%,100%,.15);-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.05);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.05)}.menu-preview-group[data-v-e00fb316]:hover{background:hsla(0,0%,100%,.13);border-color:rgba(139,194,175,.65);-webkit-box-shadow:0 7px 18px rgba(5,28,22,.2);box-shadow:0 7px 18px rgba(5,28,22,.2)}.menu-preview-group.is-current[data-v-e00fb316]{background:linear-gradient(135deg,rgba(46,107,89,.96),rgba(26,67,56,.96));border-color:rgba(190,222,211,.78);-webkit-box-shadow:0 8px 22px rgba(5,31,25,.28),inset 0 1px 0 hsla(0,0%,100%,.2);box-shadow:0 8px 22px rgba(5,31,25,.28),inset 0 1px 0 hsla(0,0%,100%,.2)}.menu-preview-group.is-current .menu-preview-position[data-v-e00fb316]{color:#1a4338}.menu-preview-group.is-current .menu-preview-item>.icon[data-v-e00fb316]{color:#fff}.menu-preview-item[data-v-e00fb316]:hover{background:hsla(0,0%,100%,.06)}.menu-preview-item>.icon[data-v-e00fb316]{color:#cbe2da}.menu-preview-position[data-v-e00fb316]{background:hsla(0,0%,100%,.16);border:1px solid hsla(0,0%,100%,.22);color:#fff}.menu-preview-name strong[data-v-e00fb316]{color:#fff}.menu-preview-name small[data-v-e00fb316]{color:#c2dbd2}.menu-entry-icon[data-v-e00fb316]{background:hsla(0,0%,100%,.12);border-color:hsla(0,0%,100%,.2)}.menu-entry-icon .icon[data-v-e00fb316]{color:#fff}.menu-entry-icon img[data-v-e00fb316]{background:transparent;-webkit-filter:grayscale(1) brightness(0) invert(1);filter:grayscale(1) brightness(0) invert(1)}.menu-preview-submenu[data-v-e00fb316]{border-top-color:hsla(0,0%,100%,.14)}.menu-preview-submenu button[data-v-e00fb316]{color:#f4f8f6}.menu-preview-submenu button[data-v-e00fb316]:hover{background:hsla(0,0%,100%,.12);color:#fff}.menu-preview-submenu button>span[data-v-e00fb316]{color:#b2d0c6}.menu-preview-submenu button strong[data-v-e00fb316]{color:#fff}.menu-preview-no-submenu[data-v-e00fb316]{border-top-color:hsla(0,0%,100%,.13);color:#b2d0c6}.menu-preview-empty[data-v-e00fb316]{color:#bdd7ce}.menu-preview-empty .icon[data-v-e00fb316]{color:#b5d7cb}.menu-preview-empty strong[data-v-e00fb316]{color:#fff}.add-module-button[data-v-e00fb316]{background:hsla(0,0%,100%,.09);border-color:rgba(139,194,175,.7)}.add-module-button>span[data-v-e00fb316]{background:#fff}.add-module-button>span .icon[data-v-e00fb316]{color:#245b4c}.add-module-button strong[data-v-e00fb316]{color:#fff}.add-module-button small[data-v-e00fb316]{color:#c2dbd2}.add-module-button>.icon[data-v-e00fb316]{color:#d8e9e3}.add-module-button[data-v-e00fb316]:hover{background:hsla(0,0%,100%,.16);border-color:#fff}.menu-preview-panel footer[data-v-e00fb316]{background:rgba(7,31,25,.38);border-top-color:hsla(0,0%,100%,.12);color:#bdd7ce}.menu-preview-panel footer .icon[data-v-e00fb316]{color:#fff}.menu-preview-panel[data-v-e00fb316]{background:-webkit-gradient(linear,left top,left bottom,from(#1a4338),color-stop(52%,#153a31),to(#102f28));background:linear-gradient(180deg,#1a4338,#153a31 52%,#102f28);-webkit-box-shadow:10px 0 28px rgba(7,31,25,.22);box-shadow:10px 0 28px rgba(7,31,25,.22)}.menu-preview-header[data-v-e00fb316]{background:transparent;min-height:68px;padding:10px 16px}.menu-preview-header small[data-v-e00fb316]{color:rgba(205,226,219,.7);font-size:8px}.menu-preview-header h3[data-v-e00fb316]{font-size:16px;font-weight:600}.menu-preview-icon[data-v-e00fb316]{background:hsla(0,0%,100%,.1);border-color:hsla(0,0%,100%,.16);border-radius:10px;height:38px;width:38px}.menu-preview-icon .icon[data-v-e00fb316]{color:#fff!important;font-size:20px}.menu-preview-context[data-v-e00fb316]{background:hsla(0,0%,100%,.035);min-height:48px;padding:7px 16px}.menu-preview-context>.icon[data-v-e00fb316]{color:#cbe2da!important;font-size:17px}.menu-preview-context small[data-v-e00fb316]{color:rgba(211,231,224,.62)}.menu-preview-context strong[data-v-e00fb316]{font-size:11px;font-weight:600}.menu-preview-context>span[data-v-e00fb316]{color:rgba(218,235,229,.72)}.menu-preview-list[data-v-e00fb316]{gap:4px;padding:8px}.menu-preview-group[data-v-e00fb316]{background:transparent;border-color:transparent;border-radius:9px;-webkit-box-shadow:none;box-shadow:none}.menu-preview-group[data-v-e00fb316]:hover{background:hsla(0,0%,100%,.065);border-color:transparent;-webkit-box-shadow:none;box-shadow:none}.menu-preview-group.is-current[data-v-e00fb316]{background:rgba(46,107,89,.48);border-color:rgba(139,194,175,.48);-webkit-box-shadow:inset 3px 0 0 #8bc2af;box-shadow:inset 3px 0 0 #8bc2af}.menu-preview-group.is-current .menu-preview-position[data-v-e00fb316]{background:#fff;border-color:#fff;color:#245b4c}.menu-preview-group.is-current .menu-preview-item>.icon[data-v-e00fb316]{color:#fff!important}.menu-preview-item[data-v-e00fb316]{gap:8px;min-height:46px;padding:5px 9px}.menu-preview-item>.icon[data-v-e00fb316]{color:rgba(226,240,235,.75)!important;font-size:17px}.menu-preview-position[data-v-e00fb316]{background:hsla(0,0%,100%,.1);border-color:transparent;border-radius:7px;font-size:10px;height:27px;min-width:27px}.module-menu-icon[data-v-e00fb316]{background:transparent;border:0;height:28px;width:28px}.module-menu-icon .icon[data-v-e00fb316]{color:#fff!important;font-size:18px}.module-menu-icon img[data-v-e00fb316]{height:88%;width:88%}.menu-preview-name strong[data-v-e00fb316]{font-size:11px;font-weight:600}.menu-preview-name small[data-v-e00fb316]{color:rgba(211,231,224,.62);font-size:8px}.menu-preview-submenu[data-v-e00fb316]{border-left:1px solid rgba(159,194,182,.25);border-top:0;gap:1px;margin:0 8px 6px 50px;padding:1px 0 2px 9px}.menu-preview-submenu button[data-v-e00fb316]{min-height:27px;padding:2px 4px}.menu-preview-submenu button>span[data-v-e00fb316]:first-child{color:rgba(194,219,210,.62);min-width:11px}.menu-preview-submenu button strong[data-v-e00fb316]{font-size:9px;font-weight:500}.resource-menu-icon[data-v-e00fb316]{background:transparent!important;border:0!important;border-radius:0;-webkit-box-shadow:none;box-shadow:none;height:20px;overflow:visible;width:20px}.resource-menu-icon .icon[data-v-e00fb316]{color:#fff!important;font-size:13px!important}.resource-menu-icon img[data-v-e00fb316]{background:transparent!important;border:0;border-radius:0;-webkit-box-shadow:none;box-shadow:none;-webkit-filter:grayscale(1) brightness(0) invert(1);filter:grayscale(1) brightness(0) invert(1);height:16px;width:16px}.add-module-button[data-v-e00fb316]{background:hsla(0,0%,100%,.045);border-color:rgba(178,208,198,.42);border-radius:9px;margin:7px 9px;min-height:44px}.add-module-button>span[data-v-e00fb316]{background:hsla(0,0%,100%,.12);height:29px;width:29px}.add-module-button>span .icon[data-v-e00fb316]{color:#fff!important}.add-module-button>.icon[data-v-e00fb316]{color:rgba(225,239,234,.75)!important}.add-module-button[data-v-e00fb316]:hover{background:hsla(0,0%,100%,.09)}.menu-preview-panel footer[data-v-e00fb316]{background:rgba(6,27,22,.24);color:rgba(208,228,221,.7)}.menu-preview-panel footer .icon[data-v-e00fb316]{color:rgba(226,240,235,.78)!important}.menu-preview-fade-enter-active[data-v-e00fb316],.menu-preview-fade-leave-active[data-v-e00fb316],.menu-preview-slide-enter-active[data-v-e00fb316],.menu-preview-slide-leave-active[data-v-e00fb316]{-webkit-transition:all .2s ease;transition:all .2s ease}.menu-preview-slide-enter[data-v-e00fb316],.menu-preview-slide-leave-to[data-v-e00fb316]{-webkit-transform:translateX(-100%);transform:translateX(-100%)}.menu-preview-fade-enter[data-v-e00fb316],.menu-preview-fade-leave-to[data-v-e00fb316]{opacity:0}.resource-languages-cell[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;gap:6px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.language-chip[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#f0f2f5;border:1px solid #dde3ea;border-radius:11px;color:#8495a5;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;font-size:11px;font-weight:700;gap:3px;line-height:1;padding:3px 8px 3px 6px}.language-chip .icon[data-v-e00fb316]{color:#b4bfca;font-size:14px}.language-chip-filled[data-v-e00fb316]{background:#dff3e6;border-color:#bde3cb;color:#23834a}.language-chip-filled .icon[data-v-e00fb316]{color:#2eaa64}.resource-icon-preview[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:#dfe5eb;background-image:linear-gradient(45deg,#cbd3da 25%,transparent 0),linear-gradient(-45deg,#cbd3da 25%,transparent 0),linear-gradient(45deg,transparent 75%,#cbd3da 0),linear-gradient(-45deg,transparent 75%,#cbd3da 0);background-position:0 0,0 4px,4px -4px,-4px 0;background-size:8px 8px;border:1px solid #bcc6cf;border-radius:4px;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;height:34px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;position:relative;width:34px}.resource-icon-preview img[data-v-e00fb316]{height:28px;-o-object-fit:contain;object-fit:contain;position:absolute;width:28px}.resource-icon-preview img.is-hidden[data-v-e00fb316]{display:none}.resource-icon-empty[data-v-e00fb316]{color:#667684;font-size:16px;font-weight:700}.resource-position-cell[data-v-e00fb316]{padding-bottom:3px!important;padding-top:3px!important}@media(max-width:1100px){.resources-assignment-page.has-menu-builder[data-v-e00fb316]{padding-left:0}.menu-preview-panel[data-v-e00fb316]{-webkit-transform:translateX(-105%);transform:translateX(-105%);-webkit-transition:-webkit-transform .2s ease;transition:-webkit-transform .2s ease;transition:transform .2s ease;transition:transform .2s ease,-webkit-transform .2s ease;width:min(84vw,240px)}.menu-preview-panel.is-open[data-v-e00fb316]{-webkit-transform:translateX(0);transform:translateX(0)}.menu-preview-backdrop[data-v-e00fb316]{display:block}.menu-preview-header>button[data-v-e00fb316],.menu-preview-mobile-trigger[data-v-e00fb316]{display:-webkit-box;display:-ms-flexbox;display:flex}}@media(max-width:700px){.resources-assignment-page[data-v-e00fb316]{height:calc(100vh - 133px);padding-bottom:66px}.assignment-toolbar[data-v-e00fb316]{-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:8px;padding-left:12px!important;padding-right:12px!important}.assignment-toolbar .flex[data-v-e00fb316]{margin-right:0!important;width:100%}.role-create-action[data-v-e00fb316],.role-picker[data-v-e00fb316]{max-width:100%}.assignment-empty-state[data-v-e00fb316]{min-height:calc(100vh - 310px);padding-bottom:40px}.assignment-empty-steps[data-v-e00fb316]{-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.assignment-panel[data-v-e00fb316]{margin-left:12px!important;margin-right:12px!important}.assignment-progress[data-v-e00fb316]{overflow-x:auto;padding-left:12px!important;padding-right:12px!important;white-space:nowrap}.selection-path[data-v-e00fb316]{-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin-left:12px!important;margin-right:12px!important}.selection-path-item[data-v-e00fb316]{width:100%}.path-divider[data-v-e00fb316]{-ms-flex-item-align:center;align-self:center;-webkit-transform:rotate(90deg);transform:rotate(90deg)}.assignment-section-header[data-v-e00fb316]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:8px}.responsive-grid[data-v-e00fb316]{grid-template-columns:1fr}.resource-table-guide[data-v-e00fb316]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.resource-table-guide[data-v-e00fb316],.resource-table-toolbar[data-v-e00fb316]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.resource-table-toolbar[data-v-e00fb316]{-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch}.resource-search[data-v-e00fb316]{max-width:none}.menu-preview-backdrop[data-v-e00fb316],.menu-preview-panel[data-v-e00fb316]{bottom:0;top:56px}.menu-preview-panel[data-v-e00fb316]{width:min(92vw,340px)}.menu-preview-trigger span[data-v-e00fb316]{display:none}}", "", {"version":3,"sources":["/opt/build/repo/src/pages/template/page-resources-assignment.vue"],"names":[],"mappings":"AACA,WAAW,yBAA2B,0CAA0C,gBAAmB,iBAAiB,CACnH,AACD,WAAW,sBAAwB,uCAAuC,gBAAmB,iBAAiB,CAC7G,AACD,WAAW,uBAAyB,wCAAwC,gBAAmB,iBAAiB,CAC/G,AACD,WAAW,0BAA4B,8CAA8C,gBAAmB,iBAAiB,CACxH,AACD,WAAW,uBAAyB,2CAA2C,gBAAmB,iBAAiB,CAClH,AACD,WAAW,2BAA6B,+CAA+C,gBAAmB,iBAAiB,CAC1H,AACD,WAAW,wBAA0B,4CAA4C,gBAAmB,iBAAiB,CACpH,AACD,4CAA4C,0BAA0B,kBAAkB,gBAAgB,oBAAoB,0CAA0C,kCAAkC,gCAAgC,oBAAoB,CAC3P,AACD,+DAA+D,SAAS,CACvE,AACD,qEAAqE,kBAAkB,CACtF,AACD,qEAAqE,mBAAmB,yBAAyB,mBAAmB,CACnI,AACD,2EAA2E,kBAAkB,CAC5F,AACD,6DAA6D,kBAAkB,CAC9E,AACD,+DAA+D,kBAAkB,CAChF,AACD,mFAAmF,WAAW,CAC7F,AACD,iEAAiE,YAAY,SAAS,CACrF,AACD,2CAA2C,6BAA8B,0DAA2D,kDAAmD,yBAA0B,CAChN,AACD,6CAA6C,gBAAgB,oCAAoC,6BAA8B,4DAA6D,oDAAqD,gBAAgB,iBAAiB,CACjR,AACD,+CAA+C,iFAAqF,kDAAoD,WAAW,OAAO,kBAAkB,QAAQ,KAAK,CACxO,AACD,8CAA8C,yBAAyB,sBAAsB,mBAAmB,mDAAqD,gCAAgC,oBAAoB,oBAAoB,aAAa,SAAS,gCAAiC,CACnS,AACD,gDAAgD,mBAAmB,WAAW,OAAO,WAAW,CAC/F,AACD,6GAA6G,aAAa,CACzH,AACD,uDAAuD,cAAc,eAAe,iBAAiB,cAAc,CAClH,AACD,sDAAsD,cAAc,cAAc,gBAAgB,oBAAoB,CACrH,AACD,8CAA8C,yBAAyB,sBAAsB,mBAAmB,uBAAyB,SAAS,kBAAkB,eAAe,oBAAoB,oBAAoB,aAAa,YAAY,wBAAwB,qBAAqB,uBAAuB,UAAU,CACjU,AACD,oDAAoD,wBAAyB,cAAc,CAC1F,AACD,oDAAoD,8BAA8B,CACjF,AACD,6CAA6C,yBAAyB,sBAAsB,mBAAmB,mDAAqD,mBAAmB,kDAAkD,0CAA0C,2BAA2B,2BAA2B,oBAAoB,YAAY,wBAAwB,qBAAqB,uBAAuB,UAAU,CACtb,AACD,mDAAmD,qBAAsB,cAAc,CACtF,AACD,gDAAgD,+BAAgC,CAC/E,AACD,mDAAmD,cAAc,eAAe,cAAc,CAC7F,AACD,kDAAkD,cAAc,eAAe,iBAAiB,QAAQ,CACvG,AACD,6CAA6C,wBAAwB,qBAAqB,uBAAuB,mBAAmB,yBAAyB,mBAAmB,cAAc,oBAAoB,oBAAoB,aAAa,eAAe,QAAQ,iBAAiB,gBAAgB,iBAAiB,CAC3T,AACD,mDAAmD,wBAAyB,cAAc,CACzF,AACD,gDAAgD,oBAAoB,oBAAoB,aAAa,SAAS,qBAAqB,kBAAkB,yBAAyB,gCAAiC,CAC9M,AACD,qDAAqD,kBAAkB,sBAAuB,mBAAoB,mBAAmB,CACpI,AACD,gDAAgD,mCAAoC,uBAAwB,CAC3G,AACD,8CAA8C,2DAA4D,mDAAoD,eAAe,CAC5K,AACD,mCAAmC,oBAAoB,oBAAoB,aAAa,mBAAmB,cAAc,CACxH,AACD,kCAAkC,aAAa,aAAa,yDAA2D,CACtH,AACD,iCAAiC,qBAAqB,CACrD,AACD,qCAAqC,yBAAyB,sBAAsB,mBAAmB,iFAAqF,kDAA4D,gCAAgC,oBAAoB,oBAAoB,aAAa,SAAS,mBAAoB,gBAAgB,mBAAmB,eAAe,CAC3Z,AACD,8BAA8B,mBAAmB,mBAAmB,eAAe,eAAe,CACjG,AACD,qCAAqC,yBAAyB,sBAAsB,mBAAmB,oBAAoB,oBAAoB,aAAa,mBAAmB,kBAAkB,cAAc,QAAQ,8BAA8B,2BAA2B,qBAAqB,CACpS,AACD,0CAA0C,kBAAmB,CAC5D,AACD,qCAAqC,kBAAkB,yDAA0D,iDAAkD,YAAY,SAAS,eAAe,mBAAmB,CACzN,AACD,2CAA2C,eAAe,eAAe,CACxE,AACD,yCAAyC,yBAAyB,sBAAsB,mBAAmB,cAAc,oBAAoB,oBAAoB,aAAa,4BAA4B,6BAA6B,0BAA0B,sBAAsB,wBAAwB,qBAAqB,uBAAuB,YAAY,gBAAgB,+BAA+B,uBAAuB,iBAAiB,CAC7b,AACD,+CAA+C,cAAc,cAAc,gBAAgB,qBAAqB,eAAe,CAC9H,AACD,4CAA4C,cAAc,eAAe,gBAAgB,CACxF,AACD,2CAA2C,eAAe,iBAAiB,SAAS,eAAe,CAClG,AACD,wCAAwC,yBAAyB,sBAAsB,mBAAmB,mDAAqD,yBAAyB,mBAAmB,iDAAiD,yCAAyC,2BAA2B,2BAA2B,oBAAoB,YAAY,wBAAwB,qBAAqB,uBAAuB,UAAU,CACxc,AACD,8CAA8C,cAAc,cAAc,CACzE,AACD,yCAAyC,yBAAyB,sBAAsB,mBAAmB,+BAAiC,yBAAyB,mBAAmB,oBAAoB,oBAAoB,aAAa,QAAQ,gBAAgB,gBAAgB,CACpR,AACD,8CAAgH,cAAc,AAA0E,eAAe,gBAAgB,QAAQ,kBAAkB,CAChQ,AACD,yFAF8C,yBAAyB,sBAAsB,mBAAmB,AAAc,2BAA2B,2BAA2B,mBAAoB,CAGvM,AADD,2CAA6G,mBAAmB,kBAAkB,cAAc,AAA0E,cAAc,kBAAkB,YAAY,wBAAwB,qBAAqB,uBAAuB,UAAU,CACnW,AACD,+CAA+C,cAAc,cAAc,CAC1E,AACD,mCAAmC,gBAAgB,yBAAyB,mBAAmB,iDAAiD,yCAAyC,eAAe,sBAAsB,CAC7N,AACD,sCAAsC,yBAAyB,sBAAsB,mBAAmB,gBAAgB,gCAAgC,oBAAoB,oBAAoB,aAAa,QAAQ,eAAe,CACnO,AACD,4CAA4C,cAAc,cAAc,CACvE,AACD,gCAAkG,cAAc,AAA0E,eAAe,gBAAgB,OAAO,CAC/N,AACD,kEAFgC,yBAAyB,sBAAsB,mBAAmB,AAAc,2BAA2B,2BAA2B,mBAAoB,CAGzL,AADD,kCAAoG,mBAAmB,kBAAkB,AAA0E,cAAc,kBAAkB,YAAY,wBAAwB,qBAAqB,uBAAuB,UAAU,CAC5U,AACD,0CAA0C,aAAa,CACtD,AACD,4CAA4C,mBAAmB,UAAU,CACxE,AACD,4CAA4C,aAAa,CACxD,AACD,8CAA8C,mBAAmB,aAAa,CAC7E,AACD,4CAAmK,yBAAyB,sBAAsB,8BAA8B,kBAAkB,CACjQ,AACD,wGAF4C,yBAAyB,sBAAsB,mBAAmB,oBAAoB,oBAAoB,YAAa,CAGlK,AADD,4DAAmL,OAAO,CACzL,AACD,+CAA+C,cAAc,2BAA6B,eAAe,QAAQ,CAChH,AACD,kDAAkD,cAAc,CAC/D,AACD,qCAAqC,yBAAyB,sBAAsB,mBAAmB,cAAc,oBAAoB,oBAAoB,aAAa,eAAe,OAAO,CAC/L,AACD,0CAA0C,mBAAmB,oBAAoB,eAAe,CAC/F,AACD,oDAAoD,mBAAmB,cAAc,eAAe,CACnG,AACD,iCAAmG,mBAAmB,yBAAyB,mBAAmB,AAAqD,SAAS,eAAe,gBAAgB,eAAe,CAC7Q,AACD,uEAFiC,yBAAyB,sBAAsB,mBAAmB,AAA+D,oBAAoB,oBAAoB,YAAa,CAGtN,AADD,sCAA6J,mBAAmB,iBAAiB,WAAW,WAAW,CACtN,AACD,2DAA2D,oBAAoB,oBAAoB,aAAa,4BAA4B,6BAA6B,0BAA0B,sBAAsB,QAAQ,gBAAgB,CAChP,AACD,iEAAiE,cAAc,cAAc,wBAAwB,CACpH,AACD,kEAAkE,cAAc,eAAe,gBAAgB,uBAAuB,kBAAkB,CACvJ,AACD,+DAA+D,yBAAyB,sBAAsB,mBAAmB,gBAAgB,yBAAyB,kBAAkB,cAAc,eAAe,oBAAoB,oBAAoB,aAAa,eAAe,gBAAgB,YAAY,iBAAiB,eAAe,UAAU,UAAU,CAC5W,AACD,qEAAqE,cAAc,cAAc,CAChG,AACD,qEAAqE,kBAAkB,CACtF,AACD,+BAA+B,yBAAyB,sBAAsB,mBAAmB,oBAAoB,oBAAoB,aAAa,iBAAiB,kBAAkB,CACxL,AACD,8BAA8B,mBAAmB,oBAAoB,cAAc,cAAc,gBAAgB,iBAAiB,eAAe,CAChJ,AACD,4BAA4B,yBAAyB,sBAAsB,mBAAmB,kBAAkB,2BAA2B,2BAA2B,oBAAoB,mBAAmB,kBAAkB,cAAc,YAAY,wBAAwB,qBAAqB,uBAAuB,UAAU,CACtU,AACD,kCAAkC,cAAc,CAC/C,AACD,+BAA+B,cAAc,cAAc,CAC1D,AACD,gCAAgC,kDAAoD,CACnF,AACD,mCAAmC,kDAAoD,CACtF,AACD,yCAAyC,gCAAgC,uBAAuB,CAC/F,AACD,yCAAyC,mDAAwD,0CAA+C,CAC/I,AACD,uEAAuE,UAAU,mCAAmC,0BAA0B,CAC7I,AACD,sCAAsC,gBAAgB,yBAAyB,kBAAkB,iDAAiD,yCAAyC,eAAe,CACzM,AACD,yCAA2G,gBAAgB,gCAAgC,AAAqD,mBAAmB,eAAe,SAAS,yBAAyB,sBAAsB,8BAA8B,iBAAiB,CACxV,AACD,2EAFyC,yBAAyB,sBAAsB,mBAAmB,AAAgD,oBAAoB,oBAAoB,YAAa,CAG/M,AADD,kCAAoG,mBAAmB,yBAAyB,kBAAkB,AAAqD,mBAAmB,mBAAmB,eAAe,QAAQ,YAAY,gBAAgB,eAAe,uEAAuE,+DAA+D,uDAAuD,mFAAmF,CAC9kB,AACD,wCAAwC,cAAc,cAAc,CACnE,AACD,wCAAwC,uBAAyB,SAAS,cAAc,mBAAmB,kBAAkB,cAAc,eAAe,YAAY,YAAY,CACjL,AACD,mEAAmE,aAAa,CAC/E,AACD,0DAA0D,aAAa,CACtE,AACD,+DAA+D,aAAa,CAC3E,AACD,qDAAqD,aAAa,CACjE,AACD,yCAAyC,yBAAyB,sBAAsB,mBAAmB,mBAAmB,SAAS,kBAAkB,eAAe,oBAAoB,oBAAoB,aAAa,YAAY,wBAAwB,qBAAqB,uBAAuB,aAAa,UAAU,CACnU,AACD,+CAA+C,cAAc,cAAc,CAC1E,AACD,+CAA+C,kBAAkB,CAChE,AACD,2FAA2F,gBAAgB,qBAAqB,+CAA+C,sCAAsC,CACpN,AACD,wCAAwC,oBAAoB,oBAAoB,aAAa,mBAAmB,eAAe,OAAO,CACrI,AACD,uCAAuC,yBAAyB,sBAAsB,mBAAmB,mBAAmB,yBAAyB,mBAAmB,cAAc,eAAe,2BAA2B,2BAA2B,oBAAoB,eAAe,gBAAgB,QAAQ,YAAY,aAAa,eAAe,+EAA+E,sEAAsE,CAClf,AACD,8CAA8C,mBAAmB,kBAAkB,cAAc,eAAe,eAAe,gBAAgB,iBAAiB,CAC/J,AACD,6CAA6C,oBAAoB,CAChE,AACD,iDAAiD,mBAAmB,qBAAqB,UAAU,CAClG,AACD,wDAAwD,+BAAiC,UAAU,CAClG,AACD,uDAAuD,mBAAmB,aAAa,CACtF,AACD,0DAA0D,mBAAmB,oBAAoB,CAChG,AACD,wCAAwC,yBAAyB,sBAAsB,mBAAmB,mBAAmB,gCAAgC,oBAAoB,oBAAoB,aAAa,SAAS,iBAAiB,CAC3O,AACD,8CAA8C,cAAc,cAAc,CACzE,AACD,+CAA+C,cAAc,cAAc,cAAc,CACxF,AACD,8CAA8C,cAAc,cAAc,CACzE,AACD,4CAA4C,mBAAmB,kBAAkB,aAAa,CAC7F,AACD,+CAA+C,gBAAgB,yBAAyB,kBAAkB,cAAc,eAAe,eAAe,gBAAgB,YAAY,aAAa,cAAc,CAC5M,AACD,qDAAqD,kBAAkB,CACtE,AACD,uCAAuC,yBAAyB,sBAAsB,mBAAmB,mBAAmB,cAAc,2BAA2B,2BAA2B,oBAAoB,OAAO,CAC1N,AACD,6CAA6C,cAAc,cAAc,CACxE,AACD,mCAAmC,yBAAyB,sBAAsB,mBAAmB,oBAAoB,oBAAoB,aAAa,QAAQ,wBAAwB,qBAAqB,sBAAsB,CACpO,AACD,oCAAoC,oBAAoB,oBAAoB,aAAa,4BAA4B,6BAA6B,0BAA0B,sBAAsB,OAAO,CACxM,AACD,2CAA2C,yBAAyB,sBAAsB,mBAAmB,mBAAmB,yBAAyB,kBAAkB,eAAe,oBAAoB,oBAAoB,aAAa,YAAY,wBAAwB,qBAAqB,uBAAuB,aAAa,UAAU,UAAU,CAC/V,AACD,iDAAiD,cAAc,cAAc,CAC5E,AACD,gEAAgE,kBAAkB,CACjF,AACD,oDAAoD,eAAe,UAAU,CAC5E,AACD,0DAA0D,aAAa,CACtE,AACD,uCAAuC,yBAAyB,sBAAsB,mBAAmB,mBAAmB,gCAAgC,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,8BAA8B,gBAAgB,gBAAgB,CAC7T,AACD,qFAAqF,yBAAyB,sBAAsB,mBAAmB,oBAAoB,oBAAoB,aAAa,OAAO,CAClN,AACD,4CAA4C,aAAa,CACxD,AACD,+BAA+B,mBAAmB,mBAAmB,cAAc,eAAe,gBAAgB,gBAAgB,CACjI,AACD,sCAAsC,mBAAmB,aAAa,CACrE,AACD,uCAAuC,yBAAyB,sBAAsB,mBAAmB,mBAAmB,yBAAyB,kBAAkB,cAAc,eAAe,2BAA2B,2BAA2B,oBAAoB,eAAe,gBAAgB,QAAQ,YAAY,qBAAqB,kBAAkB,CACvW,AACD,6CAA6C,cAAc,cAAc,CACxE,AACD,8CAA8C,yBAAyB,sBAAsB,mBAAmB,mBAAmB,oBAAoB,WAAW,2BAA2B,2BAA2B,oBAAoB,eAAe,YAAY,wBAAwB,qBAAqB,uBAAuB,eAAe,aAAa,CACtW,AACD,6CAA6C,mBAAmB,oBAAoB,CACnF,AACD,wCAAwC,8BAA8B,SAAS,SAAS,eAAe,OAAO,UAAU,eAAe,QAAQ,SAAS,UAAU,YAAY,CAC7K,AACD,qCAAqC,mBAAmB,+BAA+B,SAAS,kDAAkD,0CAA0C,oBAAoB,oBAAoB,aAAa,4BAA4B,6BAA6B,0BAA0B,sBAAsB,OAAO,eAAe,SAAS,YAAY,SAAS,CAC7Y,AACD,sCAAwG,gBAAgB,gCAAgC,AAAqD,yBAAyB,sBAAsB,8BAA8B,gBAAgB,iBAAiB,CAC1T,AACD,gFAFsC,yBAAyB,sBAAsB,mBAAmB,AAAgD,oBAAoB,oBAAoB,YAAa,CAG5M,AADD,0CAAiK,QAAQ,CACxK,AACD,4CAA4C,cAAc,cAAc,cAAc,gBAAgB,mBAAmB,CACxH,AACD,yCAAyC,cAAc,eAAe,iBAAiB,cAAc,CACpG,AACD,6CAA6C,yBAAyB,sBAAsB,mBAAmB,mBAAmB,SAAS,kBAAkB,eAAe,aAAa,YAAY,wBAAwB,qBAAqB,uBAAuB,UAAU,CAClR,AACD,mDAAmD,cAAc,cAAc,CAC9E,AACD,8CAA8C,yBAAyB,sBAAsB,mBAAmB,mBAAmB,yBAAyB,kBAAkB,eAAe,aAAa,YAAY,wBAAwB,qBAAqB,uBAAuB,gBAAgB,UAAU,CACnT,AACD,oDAAoD,cAAc,cAAc,CAC/E,AACD,oCAAoC,yBAAyB,sBAAsB,mBAAmB,mDAAqD,kBAAkB,2BAA2B,2BAA2B,oBAAoB,YAAY,wBAAwB,qBAAqB,uBAAuB,UAAU,CAChV,AACD,0CAA0C,cAAc,CACvD,AACD,uCAAuC,yBAAyB,sBAAsB,mBAAmB,mBAAmB,gCAAgC,oBAAoB,oBAAoB,aAAa,QAAQ,gBAAgB,CACxO,AACD,6CAA6C,cAAc,cAAc,CACxE,AACD,2CAA2C,oBAAoB,oBAAoB,aAAa,mBAAmB,WAAW,OAAO,4BAA4B,6BAA6B,0BAA0B,sBAAsB,WAAW,CACxP,AACD,6CAA6C,cAAc,cAAc,wBAAwB,CAChG,AACD,8CAA8C,cAAc,AAAe,gBAAgB,uBAAuB,kBAAkB,CACnI,AACD,4CAA4C,cAAc,cAAc,kBAAkB,CACzF,AACD,oCAAoC,oBAAoB,oBAAoB,aAAa,mBAAmB,WAAW,OAAO,4BAA4B,6BAA6B,0BAA0B,sBAAsB,QAAQ,aAAa,gBAAgB,YAAY,CACvR,AACD,qCAAqC,gBAAgB,yBAAyB,AAAkB,mBAAmB,kBAAkB,cAAc,gBAAgB,uEAAuE,+DAA+D,uDAAuD,mFAAmF,CAClb,AACD,2CAA2C,qBAAqB,+CAA+C,sCAAsC,CACpJ,AACD,gDAAgD,mBAAmB,oBAAoB,CACtF,AACD,uEAAuE,kBAAkB,CACxF,AACD,yEAAyE,aAAa,CACrF,AACD,oCAAoC,yBAAyB,sBAAsB,mBAAmB,uBAAyB,SAAS,eAAe,oBAAoB,oBAAoB,aAAa,SAAS,gBAAgB,gBAAgB,gBAAgB,wCAAwC,gCAAgC,UAAU,CACtV,AACD,0CAA0C,cAAc,cAAc,CACrE,AACD,0CAA0C,6BAA6B,CACtE,AACD,0CAA0C,yBAAyB,sBAAsB,mBAAmB,oBAAoB,oBAAoB,YAAY,CAC/J,AACD,6DAA6D,mBAAmB,WAAW,OAAO,WAAW,CAC5G,AACD,6CAA6C,yBAAyB,sBAAsB,mBAAmB,+BAA+B,SAAS,kBAAkB,eAAe,2BAA2B,2BAA2B,oBAAoB,mBAAmB,kBAAkB,cAAc,YAAY,wBAAwB,qBAAqB,uBAAuB,iBAAiB,wCAAwC,+BAA+B,CAC5d,AACD,mDAAmD,wBAAyB,cAAc,CACzF,AACD,mDAAmD,6BAA6B,CAC/E,AACD,wCAA0G,mBAAmB,kBAAkB,AAAqF,eAAe,gBAAgB,YAAY,AAAwB,qBAAqB,AAAuB,cAAc,CAChW,AACD,0EAFwC,yBAAyB,sBAAsB,mBAAmB,AAAgD,2BAA2B,2BAA2B,oBAAoB,AAA2C,wBAAwB,AAAqB,sBAAuB,CAGlV,AADD,kCAAoG,mBAAmB,yBAAyB,kBAAkB,AAA0E,mBAAmB,kBAAkB,cAAc,AAAwB,qBAAqB,AAAuB,gBAAgB,iBAAiB,CACnY,AACD,wCAAwC,aAAa,CACpD,AACD,sCAAsC,mBAAmB,WAAW,sBAAsB,mBAAmB,kBAAkB,SAAS,CACvI,AACD,gDAAgD,YAAY,CAC3D,AACD,mCAAmC,YAAY,UAAU,CACxD,AACD,yCAAyC,cAAc,CACtD,AACD,qCAAqC,kBAAkB,YAAY,UAAU,CAC5E,AACD,2CAA2C,wBAAyB,CACnE,AACD,oCAAoC,oBAAoB,oBAAoB,aAAa,mBAAmB,WAAW,OAAO,4BAA4B,6BAA6B,0BAA0B,sBAAsB,WAAW,CACjP,AACD,2CAA2C,cAAc,eAAe,gBAAgB,uBAAuB,kBAAkB,CAChI,AACD,0CAA0C,cAAc,cAAc,cAAc,CACnF,AACD,uCAAuC,6BAA6B,oBAAoB,oBAAoB,aAAa,4BAA4B,6BAA6B,0BAA0B,sBAAsB,sBAAsB,eAAe,CACtQ,AACD,8CAA8C,yBAAyB,sBAAsB,mBAAmB,uBAAyB,SAAS,kBAAkB,cAAc,eAAe,oBAAoB,oBAAoB,aAAa,QAAQ,gBAAgB,gBAAgB,gBAAgB,UAAU,CACvT,AACD,oDAAoD,mBAAmB,aAAa,CACnF,AACD,mDAAmD,cAAc,cAAc,cAAc,CAC5F,AACD,oDAAoD,cAAc,cAAc,CAC/E,AACD,qDAAqD,eAAe,gBAAgB,gBAAgB,uBAAuB,kBAAkB,CAC5I,AACD,0CAA0C,6BAA6B,cAAc,cAAc,kBAAkB,sBAAsB,mBAAmB,CAC7J,AACD,qCAAqC,yBAAyB,sBAAsB,mBAAmB,cAAc,oBAAoB,oBAAoB,aAAa,mBAAmB,WAAW,OAAO,4BAA4B,6BAA6B,0BAA0B,sBAAsB,wBAAwB,qBAAqB,uBAAuB,aAAa,iBAAiB,CACzZ,AACD,2CAA2C,cAAc,cAAc,CACtE,AACD,4CAA4C,cAAc,eAAe,gBAAgB,CACxF,AACD,0CAA0C,eAAe,gBAAgB,CACxE,AACD,oCAAoC,yBAAyB,sBAAsB,mBAAmB,mBAAmB,0BAA0B,mBAAmB,cAAc,eAAe,oBAAoB,oBAAoB,aAAa,mBAAmB,kBAAkB,cAAc,QAAQ,gBAAgB,gBAAgB,gBAAgB,gBAAgB,2FAA2F,mFAAmF,2EAA2E,uGAAuG,uBAAuB,CACzuB,AACD,yCAAyC,yBAAyB,sBAAsB,mBAAmB,mBAAmB,kBAAkB,2BAA2B,2BAA2B,oBAAoB,YAAY,wBAAwB,qBAAqB,uBAAuB,UAAU,CACnT,AACD,+CAA+C,WAAW,cAAc,CACvE,AACD,wCAAwC,oBAAoB,oBAAoB,aAAa,mBAAmB,WAAW,OAAO,4BAA4B,6BAA6B,0BAA0B,sBAAsB,WAAW,CACrP,AACD,2CAA2C,cAAc,cAAc,CACtE,AACD,0CAA0C,cAAc,cAAc,cAAc,CACnF,AACD,0CAA0C,cAAc,cAAc,CACrE,AACD,0CAA0C,mBAAmB,qBAAqB,mCAAmC,0BAA0B,CAC9I,AACD,4CAA4C,yBAAyB,sBAAsB,mBAAmB,gBAAgB,6BAA6B,cAAc,oBAAoB,oBAAoB,aAAa,cAAc,QAAQ,gBAAgB,gBAAgB,CACnR,AACD,kDAAkD,cAAc,cAAc,CAC7E,AACD,qCAAqC,kLAA8L,sIAAuJ,uCAAyC,iDAAiD,wCAAwC,CAC3f,AACD,sCAAsC,6BAA6B,wCAA0C,kCAAkC,yBAAyB,CACvK,AACD,4CAA4C,aAAa,CACxD,AACD,yCAAyC,UAAU,CAClD,AACD,6CAA6C,8BAAgC,CAC5E,AACD,mDAAmD,UAAU,CAC5D,AACD,oCAAoC,+BAAiC,qCAAuC,qDAAuD,4CAA8C,CAChN,AACD,uCAAuC,6BAA6B,uCAAyC,CAC5G,AACD,6CAA6C,UAAU,CACtD,AACD,6CAA6C,aAAa,CACzD,AACD,8CAA8C,UAAU,CACvD,AACD,4CAA4C,aAAa,CACxD,AACD,oCAAoC,gDAAoD,oBAAoB,CAC3G,AACD,uDAAuD,SAAS,CAC/D,AACD,6DAA6D,sBAAwB,CACpF,AACD,6DAA6D,8BAAgC,mBAAmB,CAC/G,AACD,qCAAqC,+BAAiC,iCAAmC,qDAAuD,4CAA8C,CAC7M,AACD,2CAA2C,+BAAiC,mCAAmC,+CAA+C,sCAAsC,CACnM,AACD,gDAAgD,0EAAoF,mCAAmC,iFAAmF,wEAA0E,CACnU,AACD,uEAAuF,aAAa,CACnG,AACD,yEAAyE,UAAU,CAClF,AACD,0CAA0C,8BAAgC,CACzE,AACD,0CAA0C,aAAa,CACtD,AACD,wCAAwC,+BAAiC,qCAAuC,UAAU,CACzH,AACD,2CAA2C,UAAU,CACpD,AACD,0CAA0C,aAAa,CACtD,AACD,kCAAkC,+BAAiC,+BAAiC,CACnG,AACD,wCAAwC,UAAU,CACjD,AACD,sCAAsC,uBAAyB,oDAAoD,2CAA2C,CAC7J,AACD,uCAAuC,oCAAsC,CAC5E,AACD,8CAA8C,aAAa,CAC1D,AACD,oDAAoD,+BAAiC,UAAU,CAC9F,AACD,mDAAmD,aAAa,CAC/D,AACD,qDAAqD,UAAU,CAC9D,AACD,0CAA0C,qCAAuC,aAAa,CAC7F,AACD,qCAAqC,aAAa,CACjD,AACD,2CAA2C,aAAa,CACvD,AACD,4CAA4C,UAAU,CACrD,AACD,oCAAoC,+BAAiC,iCAAiC,CACrG,AACD,yCAAyC,eAAe,CACvD,AACD,+CAA+C,aAAa,CAC3D,AACD,2CAA2C,UAAU,CACpD,AACD,0CAA0C,aAAa,CACtD,AACD,0CAA0C,aAAa,CACtD,AACD,0CAA0C,+BAAiC,iBAAiB,CAC3F,AACD,4CAA4C,6BAA6B,qCAAuC,aAAa,CAC5H,AACD,kDAAkD,UAAU,CAC3D,AACD,qCAAqC,2GAAiH,+DAA0E,iDAAiD,wCAAwC,CACxT,AACD,sCAAsC,uBAAyB,gBAAgB,iBAAiB,CAC/F,AACD,4CAA4C,2BAA2B,aAAa,CACnF,AACD,yCAAyC,eAAe,eAAe,CACtE,AACD,oCAAoC,8BAAgC,iCAAmC,mBAAmB,YAAY,UAAU,CAC/I,AACD,0CAA0C,qBAAsB,cAAc,CAC7E,AACD,uCAAuC,gCAAkC,gBAAgB,gBAAgB,CACxG,AACD,6CAA6C,wBAAyB,cAAc,CACnF,AACD,6CAA6C,2BAA2B,CACvE,AACD,8CAA8C,eAAe,eAAe,CAC3E,AACD,4CAA4C,2BAA2B,CACtE,AACD,oCAAoC,QAAQ,WAAW,CACtD,AACD,qCAAqC,uBAAyB,yBAA2B,kBAAkB,wBAAwB,eAAe,CACjJ,AACD,2CAA2C,gCAAkC,yBAA2B,wBAAwB,eAAe,CAC9I,AACD,gDAAgD,+BAA+B,mCAAmC,yCAAyC,gCAAgC,CAC1L,AACD,uEAAuE,gBAAgB,kBAAkB,aAAa,CACrH,AACD,yEAAyE,oBAAqB,CAC7F,AACD,oCAAoC,QAAQ,gBAAgB,eAAe,CAC1E,AACD,0CAA0C,sCAAuC,cAAc,CAC9F,AACD,wCAAwC,8BAAgC,yBAA2B,kBAAkB,eAAe,YAAY,cAAc,CAC7J,AACD,mCAAmC,uBAAyB,SAAS,YAAY,UAAU,CAC1F,AACD,yCAAyC,qBAAsB,cAAc,CAC5E,AACD,uCAAuC,WAAW,SAAS,CAC1D,AACD,2CAA2C,eAAe,eAAe,CACxE,AACD,0CAA0C,4BAA4B,aAAa,CAClF,AACD,uCAAuC,4CAA4C,aAAa,QAAQ,sBAAsB,qBAAqB,CAClJ,AACD,8CAA8C,gBAAgB,eAAe,CAC5E,AACD,+DAA+D,4BAA4B,cAAc,CACxG,AACD,qDAAqD,cAAc,eAAe,CACjF,AACD,qCAAqC,iCAAoC,mBAAoB,gBAAgB,wBAAwB,gBAAgB,YAAY,iBAAiB,UAAU,CAC3L,AACD,2CAA2C,qBAAsB,wBAAyB,CACzF,AACD,yCAAyC,iCAAoC,SAAS,gBAAgB,wBAAwB,gBAAgB,oDAAoD,4CAA4C,YAAY,UAAU,CACnQ,AACD,oCAAoC,gCAAkC,mCAAmC,kBAAkB,eAAe,eAAe,CACxJ,AACD,yCAAyC,+BAAiC,YAAY,UAAU,CAC/F,AACD,+CAA+C,oBAAqB,CACnE,AACD,0CAA0C,qCAAsC,CAC/E,AACD,0CAA0C,8BAAgC,CACzE,AACD,4CAA4C,6BAA6B,0BAA0B,CAClG,AACD,kDAAkD,qCAAsC,CACvF,AACD,sMAAsM,gCAAgC,uBAAuB,CAC5P,AACD,yFAAyF,oCAAoC,2BAA2B,CACvJ,AACD,uFAAuF,SAAS,CAC/F,AACD,0CAA0C,yBAAyB,sBAAsB,mBAAmB,oBAAoB,oBAAoB,aAAa,QAAQ,wBAAwB,qBAAqB,sBAAsB,CAC3O,AACD,gCAAgC,yBAAyB,sBAAsB,mBAAmB,mBAAmB,yBAAyB,mBAAmB,cAAc,2BAA2B,2BAA2B,oBAAoB,eAAe,gBAAgB,QAAQ,cAAc,uBAAuB,CACpU,AACD,sCAAsC,cAAc,cAAc,CACjE,AACD,uCAAuC,mBAAmB,qBAAqB,aAAa,CAC3F,AACD,6CAA6C,aAAa,CACzD,AACD,wCAAwC,yBAAyB,sBAAsB,mBAAmB,yBAAyB,uNAAuO,8CAA8C,wBAAwB,yBAAyB,kBAAkB,2BAA2B,2BAA2B,oBAAoB,YAAY,wBAAwB,qBAAqB,uBAAuB,kBAAkB,UAAU,CAChpB,AACD,4CAA4C,YAAY,sBAAsB,mBAAmB,kBAAkB,UAAU,CAC5H,AACD,sDAAsD,YAAY,CACjE,AACD,sCAAsC,cAAc,eAAe,eAAgB,CAClF,AACD,yCAAyC,6BAA8B,yBAA0B,CAChG,AACD,yBACA,6DAA6D,cAAc,CAC1E,AACD,qCAAqC,oCAAoC,4BAA4B,8CAA8C,sCAAsC,8BAA8B,yDAA0D,qBAAqB,CACrS,AACD,6CAA6C,gCAAgC,uBAAuB,CACnG,AACD,wCAAwC,aAAa,CACpD,AAGD,2FAA8C,oBAAoB,oBAAoB,YAAY,CACjG,CACA,AACD,wBACA,4CAA4C,2BAA2B,mBAAmB,CACzF,AACD,qCAAqC,0BAA0B,uBAAuB,oBAAoB,4BAA4B,6BAA6B,0BAA0B,sBAAsB,QAAQ,4BAA6B,4BAA6B,CACpR,AACD,2CAA2C,yBAA0B,UAAU,CAC9E,AACD,mEAAmE,cAAc,CAChF,AACD,yCAAyC,+BAA+B,mBAAmB,CAC1F,AACD,yCAAyC,mBAAmB,eAAe,wBAAwB,qBAAqB,sBAAsB,CAC7I,AACD,mCAAmC,2BAA4B,2BAA4B,CAC1F,AACD,sCAAsC,gBAAgB,4BAA6B,6BAA8B,kBAAkB,CAClI,AACD,iCAAiC,0BAA0B,uBAAuB,oBAAoB,4BAA4B,6BAA6B,0BAA0B,sBAAsB,2BAA4B,2BAA4B,CACtQ,AACD,sCAAsC,UAAU,CAC/C,AACD,+BAA+B,2BAA2B,kBAAkB,gCAAgC,uBAAuB,CAClI,AACD,4CAA4C,wBAAwB,qBAAqB,uBAAuB,4BAA4B,6BAA6B,0BAA0B,sBAAsB,OAAO,CAC/N,AACD,kCAAkC,yBAAyB,CAC1D,AACD,uCAAuC,wBAAwB,qBAAqB,sBAAuB,CAC1G,AACD,gFAF2G,4BAA4B,6BAA6B,0BAA0B,qBAAqB,CAGlN,AADD,yCAAyC,0BAA0B,uBAAuB,mBAAoB,CAC7G,AACD,kCAAkC,cAAc,CAC/C,AACD,6EAA6E,SAAS,QAAQ,CAC7F,AACD,qCAAqC,qBAAqB,CACzD,AACD,4CAA4C,YAAY,CACvD,CACA","file":"page-resources-assignment.vue","sourcesContent":["\n@font-face{font-family:\"Lato_regular\";src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_bold\";src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_light\";src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_regular\";src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_bold\";src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_semibold\";src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_light\";src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:normal;font-style:normal\n}\n.resources-assignment-page[data-v-e00fb316]{height:calc(100vh - 80px);overflow-x:hidden;overflow-y:auto;padding-bottom:58px;-webkit-transition:padding-left .22s ease;transition:padding-left .22s ease;scrollbar-color:#9db8d1 #edf2f7;scrollbar-width:thin\n}\n.resources-assignment-page[data-v-e00fb316]::-webkit-scrollbar{width:9px\n}\n.resources-assignment-page[data-v-e00fb316]::-webkit-scrollbar-track{background:#edf2f7\n}\n.resources-assignment-page[data-v-e00fb316]::-webkit-scrollbar-thumb{background:#9db8d1;border:2px solid #edf2f7;border-radius:999px\n}\n.resources-assignment-page[data-v-e00fb316]::-webkit-scrollbar-thumb:hover{background:#6f96b8\n}\n.resources-assignment-page.has-menu-builder[data-v-e00fb316]{padding-left:230px\n}\n.resources-assignment-page.menu-builder-empty[data-v-e00fb316]{padding-left:202px\n}\n.resources-assignment-page.menu-builder-empty .menu-preview-panel[data-v-e00fb316]{width:188px\n}\n.resources-assignment-page>.modal-filter-footer[data-v-e00fb316]{bottom:34px;z-index:3\n}\n.assignment-finish-button[data-v-e00fb316]{background:#1a4338 !important;-webkit-box-shadow:0 5px 12px rgba(26,67,56,.2) !important;box-shadow:0 5px 12px rgba(26,67,56,.2) !important;min-width:190px !important\n}\n.distribution-question-card[data-v-e00fb316]{background:#fff;border:1px solid rgba(26,67,56,.16);border-radius:16px !important;-webkit-box-shadow:0 22px 55px rgba(25,53,79,.22) !important;box-shadow:0 22px 55px rgba(25,53,79,.22) !important;overflow:hidden;position:relative\n}\n.distribution-question-accent[data-v-e00fb316]{background:-webkit-gradient(linear, left top, right top, from(#1A4338), to(#2E6B59));background:linear-gradient(90deg, #1A4338, #2E6B59);height:4px;left:0;position:absolute;right:0;top:0\n}\n.distribution-question-title[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:linear-gradient(135deg, #F4F8F6, #EEF5F2);border-bottom:1px solid #dfebe7;display:-webkit-box;display:-ms-flexbox;display:flex;gap:14px;padding:23px 24px 19px !important\n}\n.distribution-question-heading[data-v-e00fb316]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:0\n}\n.distribution-question-heading strong[data-v-e00fb316],.distribution-question-heading small[data-v-e00fb316]{display:block\n}\n.distribution-question-heading strong[data-v-e00fb316]{color:#243f57;font-size:18px;line-height:1.25;margin-top:3px\n}\n.distribution-question-heading small[data-v-e00fb316]{color:#1a4338;font-size:9px;font-weight:700;letter-spacing:.12em\n}\n.distribution-question-close[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:rgba(0,0,0,0);border:0;border-radius:8px;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;height:32px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:32px\n}\n.distribution-question-close .icon[data-v-e00fb316]{color:#7890a3 !important;font-size:20px\n}\n.distribution-question-close[data-v-e00fb316]:hover{background:rgba(46,107,89,.09)\n}\n.distribution-question-icon[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:linear-gradient(135deg, #1A4338, #2E6B59);border-radius:12px;-webkit-box-shadow:0 7px 16px rgba(46,107,89,.24);box-shadow:0 7px 16px rgba(46,107,89,.24);display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;height:46px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:46px\n}\n.distribution-question-icon .icon[data-v-e00fb316]{color:#fff !important;font-size:23px\n}\n.distribution-question-content[data-v-e00fb316]{padding:22px 24px 8px !important\n}\n.distribution-question-content h3[data-v-e00fb316]{color:#29465e;font-size:16px;margin:0 0 7px\n}\n.distribution-question-content p[data-v-e00fb316]{color:#6f8395;font-size:12px;line-height:1.55;margin:0\n}\n.distribution-question-note[data-v-e00fb316]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;background:#f4f8f6;border:1px solid #dfebe7;border-radius:10px;color:#587086;display:-webkit-box;display:-ms-flexbox;display:flex;font-size:11px;gap:9px;line-height:1.45;margin-top:15px;padding:10px 12px\n}\n.distribution-question-note .icon[data-v-e00fb316]{color:#1a4338 !important;font-size:18px\n}\n.distribution-question-actions[data-v-e00fb316]{display:-webkit-box;display:-ms-flexbox;display:flex;gap:10px;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;padding:16px 24px 22px !important\n}\n.distribution-question-actions .btn[data-v-e00fb316]{border-radius:9px;height:38px !important;margin:0 !important;text-transform:none\n}\n.distribution-secondary-action[data-v-e00fb316]{border:1px solid #d5e1ea !important;color:#526b80 !important\n}\n.distribution-primary-action[data-v-e00fb316]{-webkit-box-shadow:0 7px 16px rgba(26,67,56,.22) !important;box-shadow:0 7px 16px rgba(26,67,56,.22) !important;min-width:150px\n}\n.items-arragnment[data-v-e00fb316]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap\n}\n.responsive-grid[data-v-e00fb316]{display:grid;grid-gap:9px;grid-template-columns:repeat(auto-fill, minmax(248px, 1fr))\n}\n.module-section[data-v-e00fb316]{background-color:#fff\n}\n.assignment-toolbar[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:-webkit-gradient(linear, left top, right top, from(#F4F8F6), to(#F4F8F6));background:linear-gradient(90deg, #F4F8F6 0%, #F4F8F6 100%);border-bottom:1px solid #e2eaf2;display:-webkit-box;display:-ms-flexbox;display:flex;gap:10px;margin:0 !important;min-height:56px;padding-bottom:7px;padding-top:7px\n}\n.role-picker[data-v-e00fb316]{-webkit-box-flex:0;-ms-flex:0 1 250px;flex:0 1 250px;max-width:250px\n}\n.role-create-action[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;gap:8px;max-width:-webkit-max-content;max-width:-moz-max-content;max-width:max-content\n}\n.role-create-action .btn[data-v-e00fb316]{margin:0 !important\n}\n.create-role-button[data-v-e00fb316]{border-radius:8px;-webkit-box-shadow:0 3px 9px rgba(26,67,56,.2) !important;box-shadow:0 3px 9px rgba(26,67,56,.2) !important;height:36px;margin:0;padding:0 14px;text-transform:none\n}\n.create-role-button .icon[data-v-e00fb316]{font-size:19px;margin-left:5px\n}\n.assignment-empty-state[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#74879a;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin:auto;max-width:620px;min-height:calc(100vh - 230px);padding:28px 20px 80px;text-align:center\n}\n.assignment-empty-state>small[data-v-e00fb316]{color:#1a4338;font-size:9px;font-weight:700;letter-spacing:.14em;margin-top:13px\n}\n.assignment-empty-state h2[data-v-e00fb316]{color:#263f57;font-size:23px;margin:5px 0 7px\n}\n.assignment-empty-state p[data-v-e00fb316]{font-size:12px;line-height:1.55;margin:0;max-width:430px\n}\n.assignment-empty-icon[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:linear-gradient(135deg, #EAF3EF, #DCEAE4);border:1px solid #c4dbd3;border-radius:16px;-webkit-box-shadow:0 8px 24px rgba(26,67,56,.12);box-shadow:0 8px 24px rgba(26,67,56,.12);display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;height:62px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:62px\n}\n.assignment-empty-icon .icon[data-v-e00fb316]{color:#1a4338;font-size:30px\n}\n.assignment-empty-steps[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:rgba(255,255,255,.72);border:1px solid #e0e9f1;border-radius:12px;display:-webkit-box;display:-ms-flexbox;display:flex;gap:9px;margin-top:20px;padding:8px 12px\n}\n.assignment-empty-steps span[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#536b80;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;font-size:10px;font-weight:600;gap:5px;white-space:nowrap\n}\n.assignment-empty-steps i[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#eaf3ef;border-radius:50%;color:#1a4338;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;font-size:9px;font-style:normal;height:20px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:20px\n}\n.assignment-empty-steps .icon[data-v-e00fb316]{color:#a6b4c0;font-size:15px\n}\n.assignment-panel[data-v-e00fb316]{background:#fff;border:1px solid #dfe7ef;border-radius:12px;-webkit-box-shadow:0 3px 12px rgba(31,56,82,.06);box-shadow:0 3px 12px rgba(31,56,82,.06);margin-top:9px;padding:12px 14px 14px\n}\n.assignment-progress[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#fff;border-bottom:1px solid #e5ebf1;display:-webkit-box;display:-ms-flexbox;display:flex;gap:7px;min-height:42px\n}\n.assignment-progress>.icon[data-v-e00fb316]{color:#b1bdc8;font-size:17px\n}\n.progress-step[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#93a1ae;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;font-size:11px;font-weight:600;gap:6px\n}\n.progress-step i[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#edf1f5;border-radius:50%;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;font-size:9px;font-style:normal;height:21px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:21px\n}\n.progress-step.is-active[data-v-e00fb316]{color:#1a4338\n}\n.progress-step.is-active i[data-v-e00fb316]{background:#1a4338;color:#fff\n}\n.progress-step.is-complete[data-v-e00fb316]{color:#23834a\n}\n.progress-step.is-complete i[data-v-e00fb316]{background:#dff3e7;color:#23834a\n}\n.assignment-section-header[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:10px\n}\n.assignment-section-header>div[data-v-e00fb316]:first-child{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;gap:7px\n}\n.assignment-section-header h3[data-v-e00fb316]{color:#2b435b;font-family:\"Opens_semibold\";font-size:14px;margin:0\n}\n.assignment-section-header .icon[data-v-e00fb316]{font-size:20px\n}\n.assignment-summary[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#8191a1;display:-webkit-box;display:-ms-flexbox;display:flex;font-size:10px;gap:7px\n}\n.assignment-summary span[data-v-e00fb316]{background:#f0f3f6;border-radius:999px;padding:5px 9px\n}\n.assignment-summary .enabled-count[data-v-e00fb316]{background:#e3f6eb;color:#23834a;font-weight:700\n}\n.selection-path[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#f4f8f6;border:1px solid #dce9e4;border-radius:10px;display:-webkit-box;display:-ms-flexbox;display:flex;gap:10px;margin-top:8px;min-height:48px;padding:5px 9px\n}\n.selection-path-item[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1 1 0px;flex:1 1 0;min-width:0\n}\n.selection-path-item .selection-path-copy[data-v-e00fb316]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:2px;margin-left:10px\n}\n.selection-path-item .selection-path-copy small[data-v-e00fb316]{color:#8495a5;font-size:8px;text-transform:uppercase\n}\n.selection-path-item .selection-path-copy strong[data-v-e00fb316]{color:#29445e;font-size:12px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap\n}\n.selection-path-item .change-selection-button[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#fff;border:1px solid #cbddeb;border-radius:7px;color:#1a4338;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;font-size:10px;font-weight:600;height:28px;margin-left:auto;min-width:28px;padding:0;width:28px\n}\n.selection-path-item .change-selection-button .icon[data-v-e00fb316]{color:#1a4338;font-size:15px\n}\n.selection-path-item .change-selection-button[data-v-e00fb316]:hover{background:#f4f8f6\n}\n.path-actions[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;margin-left:auto;white-space:nowrap\n}\n.path-status[data-v-e00fb316]{background:#e3f6eb;border-radius:999px;color:#23834a;font-size:9px;font-weight:700;margin-right:4px;padding:4px 7px\n}\n.path-icon[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-radius:7px;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-flex:0;-ms-flex:0 0 30px;flex:0 0 30px;height:30px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:30px\n}\n.path-icon .icon[data-v-e00fb316]{font-size:16px\n}\n.path-divider[data-v-e00fb316]{color:#a4b3c1;font-size:18px\n}\n.app-selection[data-v-e00fb316]{background:linear-gradient(135deg, #2E6B59, #1A4338)\n}\n.module-selection[data-v-e00fb316]{background:linear-gradient(135deg, #35aa6e, #23834a)\n}\n.fade-down-enter-active[data-v-e00fb316]{-webkit-transition:all .4s ease;transition:all .4s ease\n}\n.fade-down-leave-active[data-v-e00fb316]{-webkit-transition:all .8s cubic-bezier(1, 0.5, 0.8, 1);transition:all .8s cubic-bezier(1, 0.5, 0.8, 1)\n}\n.fade-down-enter[data-v-e00fb316],.fade-down-leave-to[data-v-e00fb316]{opacity:0;-webkit-transform:translateY(20px);transform:translateY(20px)\n}\n.resource-table-card[data-v-e00fb316]{background:#fff;border:1px solid #dfe6ee;border-radius:8px;-webkit-box-shadow:0 4px 14px rgba(31,56,82,.08);box-shadow:0 4px 14px rgba(31,56,82,.08);overflow:hidden\n}\n.resource-table-toolbar[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#fff;border-bottom:1px solid #eef2f7;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:10px;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:11px 16px\n}\n.resource-search[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#f4f7fa;border:1px solid #e2e9f0;border-radius:9px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1 1 240px;flex:1 1 240px;gap:7px;height:36px;max-width:380px;padding:0 10px;-webkit-transition:border-color .15s ease,-webkit-box-shadow .15s ease;transition:border-color .15s ease,-webkit-box-shadow .15s ease;transition:border-color .15s ease,box-shadow .15s ease;transition:border-color .15s ease,box-shadow .15s ease,-webkit-box-shadow .15s ease\n}\n.resource-search>.icon[data-v-e00fb316]{color:#a9b6c2;font-size:18px\n}\n.resource-search input[data-v-e00fb316]{background:rgba(0,0,0,0);border:0;color:#2b435b;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;font-size:12px;min-width:0;outline:none\n}\n.resource-search input[data-v-e00fb316]::-webkit-input-placeholder{color:#a9b6c2\n}\n.resource-search input[data-v-e00fb316]::-moz-placeholder{color:#a9b6c2\n}\n.resource-search input[data-v-e00fb316]::-ms-input-placeholder{color:#a9b6c2\n}\n.resource-search input[data-v-e00fb316]::placeholder{color:#a9b6c2\n}\n.resource-search button[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#e2e9f0;border:0;border-radius:50%;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;height:18px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;outline:none;width:18px\n}\n.resource-search button .icon[data-v-e00fb316]{color:#6b7c8d;font-size:13px\n}\n.resource-search button[data-v-e00fb316]:hover{background:#d3dde7\n}\n.resource-search[data-v-e00fb316]:focus-within,.resource-search.is-filled[data-v-e00fb316]{background:#fff;border-color:#1a4338;-webkit-box-shadow:0 0 0 3px rgba(26,67,56,.1);box-shadow:0 0 0 3px rgba(26,67,56,.1)\n}\n.resource-filter-chips[data-v-e00fb316]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:6px\n}\n.resource-filter-chip[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#f4f7fa;border:1px solid #e2e9f0;border-radius:20px;color:#6b7c8d;cursor:pointer;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;font-size:11px;font-weight:700;gap:6px;height:32px;outline:none;padding:0 12px;-webkit-transition:background .15s ease,border-color .15s ease,color .15s ease;transition:background .15s ease,border-color .15s ease,color .15s ease\n}\n.resource-filter-chip strong[data-v-e00fb316]{background:#e5ebf1;border-radius:9px;color:#53697d;font-size:10px;min-width:20px;padding:2px 5px;text-align:center\n}\n.resource-filter-chip[data-v-e00fb316]:hover{border-color:#c9d6e2\n}\n.resource-filter-chip.is-active[data-v-e00fb316]{background:#1a4338;border-color:#1a4338;color:#fff\n}\n.resource-filter-chip.is-active strong[data-v-e00fb316]{background:rgba(255,255,255,.18);color:#fff\n}\n.resource-filter-chip--pending strong[data-v-e00fb316]{background:#fdf1dc;color:#a6711a\n}\n.resource-filter-chip--pending.is-active[data-v-e00fb316]{background:#a6711a;border-color:#a6711a\n}\n.resource-filter-empty[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#f7f9fc;border-bottom:1px solid #e4eaf0;display:-webkit-box;display:-ms-flexbox;display:flex;gap:11px;padding:13px 16px\n}\n.resource-filter-empty>.icon[data-v-e00fb316]{color:#a9b6c2;font-size:22px\n}\n.resource-filter-empty strong[data-v-e00fb316]{color:#2b435b;display:block;font-size:13px\n}\n.resource-filter-empty small[data-v-e00fb316]{color:#8495a5;font-size:11px\n}\n.resource-filter-empty div[data-v-e00fb316]{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto\n}\n.resource-filter-empty button[data-v-e00fb316]{background:#fff;border:1px solid #d4dee7;border-radius:8px;color:#176fc1;cursor:pointer;font-size:11px;font-weight:700;height:32px;outline:none;padding:0 12px\n}\n.resource-filter-empty button[data-v-e00fb316]:hover{background:#f1f5f9\n}\n.summary-chip-pending[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#fdf1dc;color:#a6711a;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;gap:5px\n}\n.summary-chip-pending .icon[data-v-e00fb316]{color:#e19a18;font-size:15px\n}\n.position-control[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;gap:4px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center\n}\n.position-steppers[data-v-e00fb316]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:2px\n}\n.position-steppers button[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#f1f5f9;border:1px solid #e2e9f0;border-radius:5px;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;height:15px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;outline:none;padding:0;width:22px\n}\n.position-steppers button .icon[data-v-e00fb316]{color:#53697d;font-size:14px\n}\n.position-steppers button[data-v-e00fb316]:hover:not(:disabled){background:#e2e9f0\n}\n.position-steppers button[data-v-e00fb316]:disabled{cursor:default;opacity:.4\n}\n.position-steppers button:disabled .icon[data-v-e00fb316]{color:#a9b6c2\n}\n.resource-table-guide[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#f7f9fc;border-bottom:1px solid #e4eaf0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;min-height:52px;padding:8px 16px\n}\n.resource-table-guide-text[data-v-e00fb316],.resource-table-summary[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;gap:8px\n}\n.resource-table-guide-text[data-v-e00fb316]{color:#526271\n}\n.summary-chip[data-v-e00fb316]{background:#e8edf2;border-radius:12px;color:#536473;font-size:12px;font-weight:600;padding:4px 10px\n}\n.summary-chip-active[data-v-e00fb316]{background:#dff3e6;color:#23834a\n}\n.menu-preview-trigger[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#f4f8f6;border:1px solid #c4dbd3;border-radius:8px;color:#1a4338;cursor:pointer;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;font-size:11px;font-weight:700;gap:6px;height:32px;padding:0 8px 0 10px;white-space:nowrap\n}\n.menu-preview-trigger .icon[data-v-e00fb316]{color:#1a4338;font-size:18px\n}\n.menu-preview-trigger strong[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#1a4338;border-radius:999px;color:#fff;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;font-size:10px;height:20px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;min-width:20px;padding:0 5px\n}\n.menu-preview-trigger[data-v-e00fb316]:hover{background:#e4f0eb;border-color:#70a997\n}\n.menu-preview-backdrop[data-v-e00fb316]{background:rgba(20,39,58,.32);border:0;bottom:0;cursor:default;left:0;padding:0;position:fixed;right:0;top:56px;z-index:8;display:none\n}\n.menu-preview-panel[data-v-e00fb316]{background:#f8fafc;border-right:1px solid #dbe5ee;bottom:0;-webkit-box-shadow:12px 0 30px rgba(27,51,75,.18);box-shadow:12px 0 30px rgba(27,51,75,.18);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;left:0;position:fixed;top:56px;width:230px;z-index:9\n}\n.menu-preview-header[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#fff;border-bottom:1px solid #e1e9f0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;min-height:74px;padding:12px 16px\n}\n.menu-preview-header>div[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;gap:10px\n}\n.menu-preview-header small[data-v-e00fb316]{color:#6f8294;display:block;font-size:9px;font-weight:700;letter-spacing:.1em\n}\n.menu-preview-header h3[data-v-e00fb316]{color:#20394f;font-size:17px;line-height:1.25;margin:3px 0 0\n}\n.menu-preview-header>button[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#f0f4f7;border:0;border-radius:7px;cursor:pointer;display:none;height:30px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:30px\n}\n.menu-preview-header>button .icon[data-v-e00fb316]{color:#53697d;font-size:18px\n}\n.menu-preview-mobile-trigger[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#f4f8f6;border:1px solid #c8ddd5;border-radius:7px;cursor:pointer;display:none;height:28px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-left:4px;width:28px\n}\n.menu-preview-mobile-trigger .icon[data-v-e00fb316]{color:#1a4338;font-size:16px\n}\n.menu-preview-icon[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:linear-gradient(135deg, #2E6B59, #1A4338);border-radius:9px;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;height:42px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:42px\n}\n.menu-preview-icon .icon[data-v-e00fb316]{font-size:22px\n}\n.menu-preview-context[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#f4f8f6;border-bottom:1px solid #d7e6e0;display:-webkit-box;display:-ms-flexbox;display:flex;gap:8px;padding:9px 14px\n}\n.menu-preview-context>.icon[data-v-e00fb316]{color:#1a4338;font-size:18px\n}\n.menu-preview-context>div[data-v-e00fb316]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1;flex:1;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;min-width:0\n}\n.menu-preview-context small[data-v-e00fb316]{color:#74889a;font-size:8px;text-transform:uppercase\n}\n.menu-preview-context strong[data-v-e00fb316]{color:#29445e;font-size:11px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap\n}\n.menu-preview-context>span[data-v-e00fb316]{color:#53718c;font-size:9px;white-space:nowrap\n}\n.menu-preview-list[data-v-e00fb316]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1;flex:1;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:6px;min-height:0;overflow-y:auto;padding:10px\n}\n.menu-preview-group[data-v-e00fb316]{background:#fff;border:1px solid #dfe7ef;border-radius:9px;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;overflow:hidden;-webkit-transition:border-color .15s ease,-webkit-box-shadow .15s ease;transition:border-color .15s ease,-webkit-box-shadow .15s ease;transition:border-color .15s ease,box-shadow .15s ease;transition:border-color .15s ease,box-shadow .15s ease,-webkit-box-shadow .15s ease\n}\n.menu-preview-group[data-v-e00fb316]:hover{border-color:#70a997;-webkit-box-shadow:0 3px 9px rgba(26,67,56,.1);box-shadow:0 3px 9px rgba(26,67,56,.1)\n}\n.menu-preview-group.is-current[data-v-e00fb316]{background:#edf8f2;border-color:#74c99a\n}\n.menu-preview-group.is-current .menu-preview-position[data-v-e00fb316]{background:#27945a\n}\n.menu-preview-group.is-current .menu-preview-item>.icon[data-v-e00fb316]{color:#27945a\n}\n.menu-preview-item[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:rgba(0,0,0,0);border:0;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;gap:10px;min-height:52px;padding:6px 9px;text-align:left;-webkit-transition:background .15s ease;transition:background .15s ease;width:100%\n}\n.menu-preview-item>.icon[data-v-e00fb316]{color:#91a1af;font-size:18px\n}\n.menu-preview-item[data-v-e00fb316]:hover{background:rgba(26,67,56,.05)\n}\n.menu-preview-module-row[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex\n}\n.menu-preview-module-row .menu-preview-item[data-v-e00fb316]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:0\n}\n.menu-preview-delete-module[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:rgba(232,73,73,.12);border:0;border-radius:7px;cursor:pointer;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-flex:0;-ms-flex:0 0 30px;flex:0 0 30px;height:30px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-right:7px;-webkit-transition:background .15s ease;transition:background .15s ease\n}\n.menu-preview-delete-module .icon[data-v-e00fb316]{color:#ffb3b3 !important;font-size:17px\n}\n.menu-preview-delete-module[data-v-e00fb316]:hover{background:rgba(232,73,73,.3)\n}\n.menu-preview-position[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#1a4338;border-radius:8px;color:#fff;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;font-size:12px;font-weight:700;height:34px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;min-width:34px\n}\n.menu-entry-icon[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#edf3f8;border:1px solid #d6e2ec;border-radius:7px;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;overflow:hidden;position:relative\n}\n.menu-entry-icon .icon[data-v-e00fb316]{color:#6e879b\n}\n.menu-entry-icon img[data-v-e00fb316]{background:inherit;height:78%;-o-object-fit:contain;object-fit:contain;position:absolute;width:78%\n}\n.menu-entry-icon img.is-hidden[data-v-e00fb316]{display:none\n}\n.module-menu-icon[data-v-e00fb316]{height:32px;width:32px\n}\n.module-menu-icon .icon[data-v-e00fb316]{font-size:17px\n}\n.resource-menu-icon[data-v-e00fb316]{border-radius:5px;height:23px;width:23px\n}\n.resource-menu-icon .icon[data-v-e00fb316]{font-size:14px !important\n}\n.menu-preview-name[data-v-e00fb316]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1;flex:1;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;min-width:0\n}\n.menu-preview-name strong[data-v-e00fb316]{color:#2d465d;font-size:12px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap\n}\n.menu-preview-name small[data-v-e00fb316]{color:#8393a2;font-size:9px;margin-top:2px\n}\n.menu-preview-submenu[data-v-e00fb316]{border-top:1px solid #e8eef3;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin:0 9px 7px 52px;padding-top:4px\n}\n.menu-preview-submenu button[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:rgba(0,0,0,0);border:0;border-radius:6px;color:#526b80;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;gap:5px;min-height:30px;padding:3px 5px;text-align:left;width:100%\n}\n.menu-preview-submenu button[data-v-e00fb316]:hover{background:#eaf3ef;color:#1a4338\n}\n.menu-preview-submenu button>span[data-v-e00fb316]{color:#90a0ae;font-size:9px;min-width:13px\n}\n.menu-preview-submenu button>.icon[data-v-e00fb316]{color:#668f82;font-size:14px\n}\n.menu-preview-submenu button strong[data-v-e00fb316]{font-size:10px;font-weight:600;overflow:hidden;text-overflow:ellipsis;white-space:nowrap\n}\n.menu-preview-no-submenu[data-v-e00fb316]{border-top:1px solid #e8eef3;color:#9aa7b3;font-size:9px;font-style:italic;margin:0 9px 7px 52px;padding:7px 5px 2px\n}\n.menu-preview-empty[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#8191a1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1;flex:1;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:24px;text-align:center\n}\n.menu-preview-empty .icon[data-v-e00fb316]{color:#82a69a;font-size:42px\n}\n.menu-preview-empty strong[data-v-e00fb316]{color:#415c74;font-size:13px;margin:8px 0 4px\n}\n.menu-preview-empty span[data-v-e00fb316]{font-size:11px;line-height:1.45\n}\n.add-module-button[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#f4f8f6;border:1px dashed #70a997;border-radius:10px;color:#1a4338;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;gap:9px;margin:8px 10px;min-height:48px;padding:6px 9px;text-align:left;-webkit-transition:background .15s ease,border-color .15s ease,-webkit-transform .15s ease;transition:background .15s ease,border-color .15s ease,-webkit-transform .15s ease;transition:background .15s ease,border-color .15s ease,transform .15s ease;transition:background .15s ease,border-color .15s ease,transform .15s ease,-webkit-transform .15s ease;width:calc(100% - 20px)\n}\n.add-module-button>span[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#1a4338;border-radius:8px;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;height:32px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:32px\n}\n.add-module-button>span .icon[data-v-e00fb316]{color:#fff;font-size:19px\n}\n.add-module-button>div[data-v-e00fb316]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1;flex:1;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;min-width:0\n}\n.add-module-button strong[data-v-e00fb316]{color:#1a4338;font-size:11px\n}\n.add-module-button small[data-v-e00fb316]{color:#71889c;font-size:9px;margin-top:1px\n}\n.add-module-button>.icon[data-v-e00fb316]{color:#5d8f7f;font-size:18px\n}\n.add-module-button[data-v-e00fb316]:hover{background:#eaf3ef;border-color:#1a4338;-webkit-transform:translateY(-1px);transform:translateY(-1px)\n}\n.menu-preview-panel footer[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#fff;border-top:1px solid #e1e9f0;color:#758697;display:-webkit-box;display:-ms-flexbox;display:flex;font-size:9px;gap:6px;min-height:38px;padding:7px 12px\n}\n.menu-preview-panel footer .icon[data-v-e00fb316]{color:#1a4338;font-size:16px\n}\n.menu-preview-panel[data-v-e00fb316]{background:radial-gradient(circle at 15% 5%, rgba(70, 135, 114, 0.26), transparent 28%),-webkit-gradient(linear, left top, left bottom, from(#1A4B3E), color-stop(48%, #163D33), to(#0D2A23));background:radial-gradient(circle at 15% 5%, rgba(70, 135, 114, 0.26), transparent 28%),linear-gradient(180deg, #1A4B3E 0%, #163D33 48%, #0D2A23 100%);border-right-color:rgba(255,255,255,.15);-webkit-box-shadow:12px 0 32px rgba(8,36,29,.28);box-shadow:12px 0 32px rgba(8,36,29,.28)\n}\n.menu-preview-header[data-v-e00fb316]{background:rgba(8,39,31,.34);border-bottom-color:rgba(255,255,255,.13);-webkit-backdrop-filter:blur(8px);backdrop-filter:blur(8px)\n}\n.menu-preview-header small[data-v-e00fb316]{color:#b5d7cb\n}\n.menu-preview-header h3[data-v-e00fb316]{color:#fff\n}\n.menu-preview-header>button[data-v-e00fb316]{background:rgba(255,255,255,.12)\n}\n.menu-preview-header>button .icon[data-v-e00fb316]{color:#fff\n}\n.menu-preview-icon[data-v-e00fb316]{background:rgba(255,255,255,.16);border:1px solid rgba(255,255,255,.25);-webkit-box-shadow:inset 0 1px 0 rgba(255,255,255,.14);box-shadow:inset 0 1px 0 rgba(255,255,255,.14)\n}\n.menu-preview-context[data-v-e00fb316]{background:rgba(8,36,29,.25);border-bottom-color:rgba(255,255,255,.11)\n}\n.menu-preview-context>.icon[data-v-e00fb316]{color:#fff\n}\n.menu-preview-context small[data-v-e00fb316]{color:#9fc2b6\n}\n.menu-preview-context strong[data-v-e00fb316]{color:#fff\n}\n.menu-preview-context>span[data-v-e00fb316]{color:#c2dbd2\n}\n.menu-preview-list[data-v-e00fb316]{scrollbar-color:rgba(255,255,255,.34) rgba(0,0,0,0);scrollbar-width:thin\n}\n.menu-preview-list[data-v-e00fb316]::-webkit-scrollbar{width:6px\n}\n.menu-preview-list[data-v-e00fb316]::-webkit-scrollbar-track{background:rgba(0,0,0,0)\n}\n.menu-preview-list[data-v-e00fb316]::-webkit-scrollbar-thumb{background:rgba(255,255,255,.3);border-radius:999px\n}\n.menu-preview-group[data-v-e00fb316]{background:rgba(255,255,255,.08);border-color:rgba(255,255,255,.15);-webkit-box-shadow:inset 0 1px 0 rgba(255,255,255,.05);box-shadow:inset 0 1px 0 rgba(255,255,255,.05)\n}\n.menu-preview-group[data-v-e00fb316]:hover{background:rgba(255,255,255,.13);border-color:rgba(139,194,175,.65);-webkit-box-shadow:0 7px 18px rgba(5,28,22,.2);box-shadow:0 7px 18px rgba(5,28,22,.2)\n}\n.menu-preview-group.is-current[data-v-e00fb316]{background:linear-gradient(135deg, rgba(46, 107, 89, 0.96), rgba(26, 67, 56, 0.96));border-color:rgba(190,222,211,.78);-webkit-box-shadow:0 8px 22px rgba(5,31,25,.28),inset 0 1px 0 rgba(255,255,255,.2);box-shadow:0 8px 22px rgba(5,31,25,.28),inset 0 1px 0 rgba(255,255,255,.2)\n}\n.menu-preview-group.is-current .menu-preview-position[data-v-e00fb316]{background:#fff;color:#1a4338\n}\n.menu-preview-group.is-current .menu-preview-item>.icon[data-v-e00fb316]{color:#fff\n}\n.menu-preview-item[data-v-e00fb316]:hover{background:rgba(255,255,255,.06)\n}\n.menu-preview-item>.icon[data-v-e00fb316]{color:#cbe2da\n}\n.menu-preview-position[data-v-e00fb316]{background:rgba(255,255,255,.16);border:1px solid rgba(255,255,255,.22);color:#fff\n}\n.menu-preview-name strong[data-v-e00fb316]{color:#fff\n}\n.menu-preview-name small[data-v-e00fb316]{color:#c2dbd2\n}\n.menu-entry-icon[data-v-e00fb316]{background:rgba(255,255,255,.12);border-color:rgba(255,255,255,.2)\n}\n.menu-entry-icon .icon[data-v-e00fb316]{color:#fff\n}\n.menu-entry-icon img[data-v-e00fb316]{background:rgba(0,0,0,0);-webkit-filter:grayscale(1) brightness(0) invert(1);filter:grayscale(1) brightness(0) invert(1)\n}\n.menu-preview-submenu[data-v-e00fb316]{border-top-color:rgba(255,255,255,.14)\n}\n.menu-preview-submenu button[data-v-e00fb316]{color:#f4f8f6\n}\n.menu-preview-submenu button[data-v-e00fb316]:hover{background:rgba(255,255,255,.12);color:#fff\n}\n.menu-preview-submenu button>span[data-v-e00fb316]{color:#b2d0c6\n}\n.menu-preview-submenu button strong[data-v-e00fb316]{color:#fff\n}\n.menu-preview-no-submenu[data-v-e00fb316]{border-top-color:rgba(255,255,255,.13);color:#b2d0c6\n}\n.menu-preview-empty[data-v-e00fb316]{color:#bdd7ce\n}\n.menu-preview-empty .icon[data-v-e00fb316]{color:#b5d7cb\n}\n.menu-preview-empty strong[data-v-e00fb316]{color:#fff\n}\n.add-module-button[data-v-e00fb316]{background:rgba(255,255,255,.09);border-color:rgba(139,194,175,.7)\n}\n.add-module-button>span[data-v-e00fb316]{background:#fff\n}\n.add-module-button>span .icon[data-v-e00fb316]{color:#245b4c\n}\n.add-module-button strong[data-v-e00fb316]{color:#fff\n}\n.add-module-button small[data-v-e00fb316]{color:#c2dbd2\n}\n.add-module-button>.icon[data-v-e00fb316]{color:#d8e9e3\n}\n.add-module-button[data-v-e00fb316]:hover{background:rgba(255,255,255,.16);border-color:#fff\n}\n.menu-preview-panel footer[data-v-e00fb316]{background:rgba(7,31,25,.38);border-top-color:rgba(255,255,255,.12);color:#bdd7ce\n}\n.menu-preview-panel footer .icon[data-v-e00fb316]{color:#fff\n}\n.menu-preview-panel[data-v-e00fb316]{background:-webkit-gradient(linear, left top, left bottom, from(#1A4338), color-stop(52%, #153A31), to(#102F28));background:linear-gradient(180deg, #1A4338 0%, #153A31 52%, #102F28 100%);-webkit-box-shadow:10px 0 28px rgba(7,31,25,.22);box-shadow:10px 0 28px rgba(7,31,25,.22)\n}\n.menu-preview-header[data-v-e00fb316]{background:rgba(0,0,0,0);min-height:68px;padding:10px 16px\n}\n.menu-preview-header small[data-v-e00fb316]{color:rgba(205,226,219,.7);font-size:8px\n}\n.menu-preview-header h3[data-v-e00fb316]{font-size:16px;font-weight:600\n}\n.menu-preview-icon[data-v-e00fb316]{background:rgba(255,255,255,.1);border-color:rgba(255,255,255,.16);border-radius:10px;height:38px;width:38px\n}\n.menu-preview-icon .icon[data-v-e00fb316]{color:#fff !important;font-size:20px\n}\n.menu-preview-context[data-v-e00fb316]{background:rgba(255,255,255,.035);min-height:48px;padding:7px 16px\n}\n.menu-preview-context>.icon[data-v-e00fb316]{color:#cbe2da !important;font-size:17px\n}\n.menu-preview-context small[data-v-e00fb316]{color:rgba(211,231,224,.62)\n}\n.menu-preview-context strong[data-v-e00fb316]{font-size:11px;font-weight:600\n}\n.menu-preview-context>span[data-v-e00fb316]{color:rgba(218,235,229,.72)\n}\n.menu-preview-list[data-v-e00fb316]{gap:4px;padding:8px\n}\n.menu-preview-group[data-v-e00fb316]{background:rgba(0,0,0,0);border-color:rgba(0,0,0,0);border-radius:9px;-webkit-box-shadow:none;box-shadow:none\n}\n.menu-preview-group[data-v-e00fb316]:hover{background:rgba(255,255,255,.065);border-color:rgba(0,0,0,0);-webkit-box-shadow:none;box-shadow:none\n}\n.menu-preview-group.is-current[data-v-e00fb316]{background:rgba(46,107,89,.48);border-color:rgba(139,194,175,.48);-webkit-box-shadow:inset 3px 0 0 #8bc2af;box-shadow:inset 3px 0 0 #8bc2af\n}\n.menu-preview-group.is-current .menu-preview-position[data-v-e00fb316]{background:#fff;border-color:#fff;color:#245b4c\n}\n.menu-preview-group.is-current .menu-preview-item>.icon[data-v-e00fb316]{color:#fff !important\n}\n.menu-preview-item[data-v-e00fb316]{gap:8px;min-height:46px;padding:5px 9px\n}\n.menu-preview-item>.icon[data-v-e00fb316]{color:rgba(226,240,235,.75) !important;font-size:17px\n}\n.menu-preview-position[data-v-e00fb316]{background:rgba(255,255,255,.1);border-color:rgba(0,0,0,0);border-radius:7px;font-size:10px;height:27px;min-width:27px\n}\n.module-menu-icon[data-v-e00fb316]{background:rgba(0,0,0,0);border:0;height:28px;width:28px\n}\n.module-menu-icon .icon[data-v-e00fb316]{color:#fff !important;font-size:18px\n}\n.module-menu-icon img[data-v-e00fb316]{height:88%;width:88%\n}\n.menu-preview-name strong[data-v-e00fb316]{font-size:11px;font-weight:600\n}\n.menu-preview-name small[data-v-e00fb316]{color:rgba(211,231,224,.62);font-size:8px\n}\n.menu-preview-submenu[data-v-e00fb316]{border-left:1px solid rgba(159,194,182,.25);border-top:0;gap:1px;margin:0 8px 6px 50px;padding:1px 0 2px 9px\n}\n.menu-preview-submenu button[data-v-e00fb316]{min-height:27px;padding:2px 4px\n}\n.menu-preview-submenu button>span[data-v-e00fb316]:first-child{color:rgba(194,219,210,.62);min-width:11px\n}\n.menu-preview-submenu button strong[data-v-e00fb316]{font-size:9px;font-weight:500\n}\n.resource-menu-icon[data-v-e00fb316]{background:rgba(0,0,0,0) !important;border:0 !important;border-radius:0;-webkit-box-shadow:none;box-shadow:none;height:20px;overflow:visible;width:20px\n}\n.resource-menu-icon .icon[data-v-e00fb316]{color:#fff !important;font-size:13px !important\n}\n.resource-menu-icon img[data-v-e00fb316]{background:rgba(0,0,0,0) !important;border:0;border-radius:0;-webkit-box-shadow:none;box-shadow:none;-webkit-filter:grayscale(1) brightness(0) invert(1);filter:grayscale(1) brightness(0) invert(1);height:16px;width:16px\n}\n.add-module-button[data-v-e00fb316]{background:rgba(255,255,255,.045);border-color:rgba(178,208,198,.42);border-radius:9px;margin:7px 9px;min-height:44px\n}\n.add-module-button>span[data-v-e00fb316]{background:rgba(255,255,255,.12);height:29px;width:29px\n}\n.add-module-button>span .icon[data-v-e00fb316]{color:#fff !important\n}\n.add-module-button>.icon[data-v-e00fb316]{color:rgba(225,239,234,.75) !important\n}\n.add-module-button[data-v-e00fb316]:hover{background:rgba(255,255,255,.09)\n}\n.menu-preview-panel footer[data-v-e00fb316]{background:rgba(6,27,22,.24);color:rgba(208,228,221,.7)\n}\n.menu-preview-panel footer .icon[data-v-e00fb316]{color:rgba(226,240,235,.78) !important\n}\n.menu-preview-slide-enter-active[data-v-e00fb316],.menu-preview-slide-leave-active[data-v-e00fb316],.menu-preview-fade-enter-active[data-v-e00fb316],.menu-preview-fade-leave-active[data-v-e00fb316]{-webkit-transition:all .2s ease;transition:all .2s ease\n}\n.menu-preview-slide-enter[data-v-e00fb316],.menu-preview-slide-leave-to[data-v-e00fb316]{-webkit-transform:translateX(-100%);transform:translateX(-100%)\n}\n.menu-preview-fade-enter[data-v-e00fb316],.menu-preview-fade-leave-to[data-v-e00fb316]{opacity:0\n}\n.resource-languages-cell[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;gap:6px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center\n}\n.language-chip[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#f0f2f5;border:1px solid #dde3ea;border-radius:11px;color:#8495a5;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;font-size:11px;font-weight:700;gap:3px;line-height:1;padding:3px 8px 3px 6px\n}\n.language-chip .icon[data-v-e00fb316]{color:#b4bfca;font-size:14px\n}\n.language-chip-filled[data-v-e00fb316]{background:#dff3e6;border-color:#bde3cb;color:#23834a\n}\n.language-chip-filled .icon[data-v-e00fb316]{color:#2eaa64\n}\n.resource-icon-preview[data-v-e00fb316]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:#dfe5eb;background-image:linear-gradient(45deg, #cbd3da 25%, transparent 25%),linear-gradient(-45deg, #cbd3da 25%, transparent 25%),linear-gradient(45deg, transparent 75%, #cbd3da 75%),linear-gradient(-45deg, transparent 75%, #cbd3da 75%);background-position:0 0,0 4px,4px -4px,-4px 0;background-size:8px 8px;border:1px solid #bcc6cf;border-radius:4px;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;height:34px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;position:relative;width:34px\n}\n.resource-icon-preview img[data-v-e00fb316]{height:28px;-o-object-fit:contain;object-fit:contain;position:absolute;width:28px\n}\n.resource-icon-preview img.is-hidden[data-v-e00fb316]{display:none\n}\n.resource-icon-empty[data-v-e00fb316]{color:#667684;font-size:16px;font-weight:bold\n}\n.resource-position-cell[data-v-e00fb316]{padding-bottom:3px !important;padding-top:3px !important\n}\n@media(max-width: 1100px){\n.resources-assignment-page.has-menu-builder[data-v-e00fb316]{padding-left:0\n}\n.menu-preview-panel[data-v-e00fb316]{-webkit-transform:translateX(-105%);transform:translateX(-105%);-webkit-transition:-webkit-transform .2s ease;transition:-webkit-transform .2s ease;transition:transform .2s ease;transition:transform .2s ease, -webkit-transform .2s ease;width:min(84vw,240px)\n}\n.menu-preview-panel.is-open[data-v-e00fb316]{-webkit-transform:translateX(0);transform:translateX(0)\n}\n.menu-preview-backdrop[data-v-e00fb316]{display:block\n}\n.menu-preview-header>button[data-v-e00fb316]{display:-webkit-box;display:-ms-flexbox;display:flex\n}\n.menu-preview-mobile-trigger[data-v-e00fb316]{display:-webkit-box;display:-ms-flexbox;display:flex\n}\n}\n@media(max-width: 700px){\n.resources-assignment-page[data-v-e00fb316]{height:calc(100vh - 133px);padding-bottom:66px\n}\n.assignment-toolbar[data-v-e00fb316]{-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:8px;padding-left:12px !important;padding-right:12px !important\n}\n.assignment-toolbar .flex[data-v-e00fb316]{margin-right:0 !important;width:100%\n}\n.role-picker[data-v-e00fb316],.role-create-action[data-v-e00fb316]{max-width:100%\n}\n.assignment-empty-state[data-v-e00fb316]{min-height:calc(100vh - 310px);padding-bottom:40px\n}\n.assignment-empty-steps[data-v-e00fb316]{-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center\n}\n.assignment-panel[data-v-e00fb316]{margin-left:12px !important;margin-right:12px !important\n}\n.assignment-progress[data-v-e00fb316]{overflow-x:auto;padding-left:12px !important;padding-right:12px !important;white-space:nowrap\n}\n.selection-path[data-v-e00fb316]{-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin-left:12px !important;margin-right:12px !important\n}\n.selection-path-item[data-v-e00fb316]{width:100%\n}\n.path-divider[data-v-e00fb316]{-ms-flex-item-align:center;align-self:center;-webkit-transform:rotate(90deg);transform:rotate(90deg)\n}\n.assignment-section-header[data-v-e00fb316]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:8px\n}\n.responsive-grid[data-v-e00fb316]{grid-template-columns:1fr\n}\n.resource-table-guide[data-v-e00fb316]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column\n}\n.resource-table-toolbar[data-v-e00fb316]{-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column\n}\n.resource-search[data-v-e00fb316]{max-width:none\n}\n.menu-preview-backdrop[data-v-e00fb316],.menu-preview-panel[data-v-e00fb316]{bottom:0;top:56px\n}\n.menu-preview-panel[data-v-e00fb316]{width:min(92vw,340px)\n}\n.menu-preview-trigger span[data-v-e00fb316]{display:none\n}\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1008:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1009);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(516)("6eafba0e", content, true, {});

/***/ }),

/***/ 1009:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(515)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.resources-assignment-page .resources-table tbody>tr.row-checked>td:first-child{-webkit-box-shadow:inset 3px 0 0 #2eaa64;box-shadow:inset 3px 0 0 #2eaa64}.resources-assignment-page .resource-position-cell{height:38px!important;padding:2px 6px!important}.resources-assignment-page .resource-position-cell .input-group,.resources-assignment-page .resource-position-cell .v-input,.resources-assignment-page .resource-position-cell .v-text-field{height:30px!important;margin:0 auto!important;max-height:30px!important;max-width:68px;min-height:30px!important;padding:0!important}.resources-assignment-page .resource-position-cell .input-group__input,.resources-assignment-page .resource-position-cell .v-input__control,.resources-assignment-page .resource-position-cell .v-input__slot{border-radius:6px;height:30px!important;margin:0!important;max-height:30px!important;min-height:30px!important;padding:0 8px!important}.resources-assignment-page .resource-position-cell .input-group__input,.resources-assignment-page .resource-position-cell .v-text-field__slot{-webkit-box-align:center;-ms-flex-align:center;align-items:center}.resources-assignment-page .resource-position-cell .input-group__input input,.resources-assignment-page .resource-position-cell .v-text-field__slot input{font-size:11px;height:26px!important;line-height:26px;margin:0!important;padding:0!important}", "", {"version":3,"sources":["/opt/build/repo/src/pages/template/page-resources-assignment.vue"],"names":[],"mappings":"AACA,WAAW,yBAA2B,0CAA0C,gBAAmB,iBAAiB,CACnH,AACD,WAAW,sBAAwB,uCAAuC,gBAAmB,iBAAiB,CAC7G,AACD,WAAW,uBAAyB,wCAAwC,gBAAmB,iBAAiB,CAC/G,AACD,WAAW,0BAA4B,8CAA8C,gBAAmB,iBAAiB,CACxH,AACD,WAAW,uBAAyB,2CAA2C,gBAAmB,iBAAiB,CAClH,AACD,WAAW,2BAA6B,+CAA+C,gBAAmB,iBAAiB,CAC1H,AACD,WAAW,wBAA0B,4CAA4C,gBAAmB,iBAAiB,CACpH,AACD,gFAAgF,yCAAyC,gCAAgC,CACxJ,AACD,mDAAmD,sBAAuB,yBAA0B,CACnG,AACD,6LAA6L,sBAAuB,wBAAyB,0BAA2B,eAAe,0BAA2B,mBAAoB,CACrU,AACD,8MAA8M,kBAAkB,sBAAuB,mBAAoB,0BAA2B,0BAA2B,uBAAwB,CACxV,AACD,8IAA8I,yBAAyB,sBAAsB,kBAAkB,CAC9M,AACD,0JAA0J,eAAe,sBAAuB,iBAAiB,mBAAoB,mBAAoB,CACxP","file":"page-resources-assignment.vue","sourcesContent":["\n@font-face{font-family:\"Lato_regular\";src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_bold\";src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_light\";src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_regular\";src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_bold\";src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_semibold\";src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_light\";src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:normal;font-style:normal\n}\n.resources-assignment-page .resources-table tbody>tr.row-checked>td:first-child{-webkit-box-shadow:inset 3px 0 0 #2eaa64;box-shadow:inset 3px 0 0 #2eaa64\n}\n.resources-assignment-page .resource-position-cell{height:38px !important;padding:2px 6px !important\n}\n.resources-assignment-page .resource-position-cell .v-text-field,.resources-assignment-page .resource-position-cell .v-input,.resources-assignment-page .resource-position-cell .input-group{height:30px !important;margin:0 auto !important;max-height:30px !important;max-width:68px;min-height:30px !important;padding:0 !important\n}\n.resources-assignment-page .resource-position-cell .v-input__control,.resources-assignment-page .resource-position-cell .v-input__slot,.resources-assignment-page .resource-position-cell .input-group__input{border-radius:6px;height:30px !important;margin:0 !important;max-height:30px !important;min-height:30px !important;padding:0 8px !important\n}\n.resources-assignment-page .resource-position-cell .v-text-field__slot,.resources-assignment-page .resource-position-cell .input-group__input{-webkit-box-align:center;-ms-flex-align:center;align-items:center\n}\n.resources-assignment-page .resource-position-cell .v-text-field__slot input,.resources-assignment-page .resource-position-cell .input-group__input input{font-size:11px;height:26px !important;line-height:26px;margin:0 !important;padding:0 !important\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1010:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1011), __esModule: true };

/***/ }),

/***/ 1011:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1012);
module.exports = __webpack_require__(5).Number.isFinite;


/***/ }),

/***/ 1012:
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(14);
var _isFinite = __webpack_require__(10).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),

/***/ 1013:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1014), __esModule: true };

/***/ }),

/***/ 1014:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1015);
module.exports = 0x1fffffffffffff;


/***/ }),

/***/ 1015:
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(14);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),

/***/ 1016:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_button_vue__ = __webpack_require__(828);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2796a35e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_button_vue__ = __webpack_require__(1019);
function injectStyle (ssrContext) {
  __webpack_require__(1017)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2796a35e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2796a35e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1017:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1018);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(516)("b60ffff2", content, true, {});

/***/ }),

/***/ 1018:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(515)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.app-button[data-v-2796a35e]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#fff;border:1px solid #e2e9f0;border-radius:10px;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;gap:10px;min-height:54px;min-width:0;outline:none;padding:8px 8px 8px 10px;-webkit-transition:border-color .15s ease,-webkit-box-shadow .15s ease,-webkit-transform .15s ease;transition:border-color .15s ease,-webkit-box-shadow .15s ease,-webkit-transform .15s ease;transition:border-color .15s ease,box-shadow .15s ease,transform .15s ease;transition:border-color .15s ease,box-shadow .15s ease,transform .15s ease,-webkit-box-shadow .15s ease,-webkit-transform .15s ease}.app-button[data-v-2796a35e]:hover{border-color:#c2d4e4;-webkit-box-shadow:0 4px 12px rgba(31,57,85,.08);box-shadow:0 4px 12px rgba(31,57,85,.08);-webkit-transform:translateY(-1px);transform:translateY(-1px)}.app-button[data-v-2796a35e]:focus{border-color:#1a4338;-webkit-box-shadow:0 0 0 3px rgba(26,67,56,.12);box-shadow:0 0 0 3px rgba(26,67,56,.12)}.app-button__icon[data-v-2796a35e]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:linear-gradient(135deg,#2b435b,#3f6187);border-radius:9px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;height:34px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;position:relative;width:34px}.app-button__icon img[data-v-2796a35e]{height:21px;-o-object-fit:contain;object-fit:contain;width:21px}.app-button__initials[data-v-2796a35e]{color:hsla(0,0%,100%,.9);font-size:12px;font-weight:700;letter-spacing:.5px}.app-button__check[data-v-2796a35e]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#2eaa64;border:2px solid #fff;border-radius:50%;bottom:-4px;display:-webkit-box;display:-ms-flexbox;display:flex;height:16px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;position:absolute;right:-5px;width:16px}.app-button__check .icon[data-v-2796a35e]{color:#fff;font-size:10px}.app-button__copy[data-v-2796a35e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;min-width:0;text-align:left}.app-button__copy strong[data-v-2796a35e]{color:#2b435b;font-size:13px;font-weight:600;line-height:1.25;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.app-button__copy small[data-v-2796a35e]{color:#8495a5;font-size:10px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.app-button__actions[data-v-2796a35e]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}.app-button__chevron[data-v-2796a35e]{color:#c2ccd6;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;font-size:19px}.app-button--configured[data-v-2796a35e]{background:#f5faf7;border-color:#b9dccb}.app-button--configured .app-button__copy strong[data-v-2796a35e]{color:#1f4c3b}.app-button--active[data-v-2796a35e]{background:linear-gradient(135deg,#1f5546,#1a4338);border-color:#1a4338;-webkit-box-shadow:0 6px 16px rgba(26,67,56,.24);box-shadow:0 6px 16px rgba(26,67,56,.24)}.app-button--active .app-button__icon[data-v-2796a35e]{background:hsla(0,0%,100%,.16)}.app-button--active .app-button__check[data-v-2796a35e]{background:#6fd39b;border-color:#1a4338}.app-button--active .app-button__copy strong[data-v-2796a35e]{color:#fff}.app-button--active .app-button__copy small[data-v-2796a35e]{color:hsla(0,0%,100%,.66)}.app-button--active .app-button__chevron[data-v-2796a35e]{color:hsla(0,0%,100%,.7)}.app-button--active[data-v-2796a35e]:hover{border-color:#2e6b59}@media(max-width:700px){.app-button[data-v-2796a35e]{min-height:50px;padding:7px}.app-button__chevron[data-v-2796a35e]{display:none}}", "", {"version":3,"sources":["/opt/build/repo/src/components/shared/app-button.vue"],"names":[],"mappings":"AACA,WAAW,yBAA2B,0CAA0C,gBAAmB,iBAAiB,CACnH,AACD,WAAW,sBAAwB,uCAAuC,gBAAmB,iBAAiB,CAC7G,AACD,WAAW,uBAAyB,wCAAwC,gBAAmB,iBAAiB,CAC/G,AACD,WAAW,0BAA4B,8CAA8C,gBAAmB,iBAAiB,CACxH,AACD,WAAW,uBAAyB,2CAA2C,gBAAmB,iBAAiB,CAClH,AACD,WAAW,2BAA6B,+CAA+C,gBAAmB,iBAAiB,CAC1H,AACD,WAAW,wBAA0B,4CAA4C,gBAAmB,iBAAiB,CACpH,AACD,6BAA6B,yBAAyB,sBAAsB,mBAAmB,gBAAgB,yBAAyB,mBAAmB,eAAe,oBAAoB,oBAAoB,aAAa,SAAS,gBAAgB,YAAY,aAAa,yBAAyB,mGAAmG,2FAA2F,2EAA2E,mIAAmI,CACrrB,AACD,mCAAmC,qBAAqB,iDAAiD,yCAAyC,mCAAmC,0BAA0B,CAC9M,AACD,mCAAmC,qBAAqB,gDAAgD,uCAAuC,CAC9I,AACD,mCAAmC,yBAAyB,sBAAsB,mBAAmB,mDAA6D,kBAAkB,oBAAoB,oBAAoB,aAAa,mBAAmB,kBAAkB,cAAc,YAAY,wBAAwB,qBAAqB,uBAAuB,kBAAkB,UAAU,CACvY,AACD,uCAAuC,YAAY,sBAAsB,mBAAmB,UAAU,CACrG,AACD,uCAAuC,yBAA2B,eAAe,gBAAgB,mBAAmB,CACnH,AACD,oCAAoC,yBAAyB,sBAAsB,mBAAmB,mBAAmB,sBAAsB,kBAAkB,YAAY,oBAAoB,oBAAoB,aAAa,YAAY,wBAAwB,qBAAqB,uBAAuB,kBAAkB,WAAW,UAAU,CACxV,AACD,0CAA0C,WAAW,cAAc,CAClE,AACD,mCAAmC,oBAAoB,oBAAoB,aAAa,mBAAmB,kBAAkB,cAAc,4BAA4B,6BAA6B,0BAA0B,sBAAsB,YAAY,eAAe,CAC9Q,AACD,0CAA0C,cAAc,eAAe,gBAAgB,iBAAiB,gBAAgB,uBAAuB,kBAAkB,CAChK,AACD,yCAAyC,cAAc,eAAe,gBAAgB,uBAAuB,kBAAkB,CAC9H,AACD,sCAAsC,yBAAyB,sBAAsB,mBAAmB,oBAAoB,oBAAoB,aAAa,mBAAmB,kBAAkB,aAAa,CAC9M,AACD,sCAAsC,cAAc,mBAAmB,kBAAkB,cAAc,cAAc,CACpH,AACD,yCAAyC,mBAAmB,oBAAoB,CAC/E,AACD,kEAAkE,aAAa,CAC9E,AACD,qCAAqC,mDAA6D,qBAAqB,iDAAiD,wCAAwC,CAC/M,AACD,uDAAuD,8BAAgC,CACtF,AACD,wDAAwD,mBAAmB,oBAAoB,CAC9F,AACD,8DAA8D,UAAU,CACvE,AACD,6DAA6D,yBAA2B,CACvF,AACD,0DAA0D,wBAA0B,CACnF,AACD,2CAA2C,oBAAoB,CAC9D,AACD,wBACA,6BAA6B,gBAAgB,WAAW,CACvD,AACD,sCAAsC,YAAY,CACjD,CACA","file":"app-button.vue","sourcesContent":["\n@font-face{font-family:\"Lato_regular\";src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_bold\";src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_light\";src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_regular\";src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_bold\";src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_semibold\";src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_light\";src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:normal;font-style:normal\n}\n.app-button[data-v-2796a35e]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#fff;border:1px solid #e2e9f0;border-radius:10px;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;gap:10px;min-height:54px;min-width:0;outline:none;padding:8px 8px 8px 10px;-webkit-transition:border-color .15s ease,-webkit-box-shadow .15s ease,-webkit-transform .15s ease;transition:border-color .15s ease,-webkit-box-shadow .15s ease,-webkit-transform .15s ease;transition:border-color .15s ease,box-shadow .15s ease,transform .15s ease;transition:border-color .15s ease,box-shadow .15s ease,transform .15s ease,-webkit-box-shadow .15s ease,-webkit-transform .15s ease\n}\n.app-button[data-v-2796a35e]:hover{border-color:#c2d4e4;-webkit-box-shadow:0 4px 12px rgba(31,57,85,.08);box-shadow:0 4px 12px rgba(31,57,85,.08);-webkit-transform:translateY(-1px);transform:translateY(-1px)\n}\n.app-button[data-v-2796a35e]:focus{border-color:#1a4338;-webkit-box-shadow:0 0 0 3px rgba(26,67,56,.12);box-shadow:0 0 0 3px rgba(26,67,56,.12)\n}\n.app-button__icon[data-v-2796a35e]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:linear-gradient(135deg, #2b435b 0%, #3f6187 100%);border-radius:9px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;height:34px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;position:relative;width:34px\n}\n.app-button__icon img[data-v-2796a35e]{height:21px;-o-object-fit:contain;object-fit:contain;width:21px\n}\n.app-button__initials[data-v-2796a35e]{color:rgba(255,255,255,.9);font-size:12px;font-weight:700;letter-spacing:.5px\n}\n.app-button__check[data-v-2796a35e]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#2eaa64;border:2px solid #fff;border-radius:50%;bottom:-4px;display:-webkit-box;display:-ms-flexbox;display:flex;height:16px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;position:absolute;right:-5px;width:16px\n}\n.app-button__check .icon[data-v-2796a35e]{color:#fff;font-size:10px\n}\n.app-button__copy[data-v-2796a35e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;min-width:0;text-align:left\n}\n.app-button__copy strong[data-v-2796a35e]{color:#2b435b;font-size:13px;font-weight:600;line-height:1.25;overflow:hidden;text-overflow:ellipsis;white-space:nowrap\n}\n.app-button__copy small[data-v-2796a35e]{color:#8495a5;font-size:10px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap\n}\n.app-button__actions[data-v-2796a35e]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto\n}\n.app-button__chevron[data-v-2796a35e]{color:#c2ccd6;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;font-size:19px\n}\n.app-button--configured[data-v-2796a35e]{background:#f5faf7;border-color:#b9dccb\n}\n.app-button--configured .app-button__copy strong[data-v-2796a35e]{color:#1f4c3b\n}\n.app-button--active[data-v-2796a35e]{background:linear-gradient(135deg, #1f5546 0%, #1a4338 100%);border-color:#1a4338;-webkit-box-shadow:0 6px 16px rgba(26,67,56,.24);box-shadow:0 6px 16px rgba(26,67,56,.24)\n}\n.app-button--active .app-button__icon[data-v-2796a35e]{background:rgba(255,255,255,.16)\n}\n.app-button--active .app-button__check[data-v-2796a35e]{background:#6fd39b;border-color:#1a4338\n}\n.app-button--active .app-button__copy strong[data-v-2796a35e]{color:#fff\n}\n.app-button--active .app-button__copy small[data-v-2796a35e]{color:rgba(255,255,255,.66)\n}\n.app-button--active .app-button__chevron[data-v-2796a35e]{color:rgba(255,255,255,.7)\n}\n.app-button--active[data-v-2796a35e]:hover{border-color:#2e6b59\n}\n@media(max-width: 700px){\n.app-button[data-v-2796a35e]{min-height:50px;padding:7px\n}\n.app-button__chevron[data-v-2796a35e]{display:none\n}\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1019:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-button",class:{
		'app-button--active': _vm.active,
		'app-button--configured': _vm.configured && !_vm.active,
	},attrs:{"role":"button","tabindex":"0","title":_vm.tooltip},on:{"click":_vm.buttonClicked,"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.buttonClicked.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();return _vm.buttonClicked.apply(null, arguments)}]}},[_c('span',{staticClass:"app-button__icon"},[(_vm.showIcon)?_c('img',{attrs:{"src":_vm.iconPath,"alt":("Ícono de " + (_vm.item.name))},on:{"error":_vm.markIconAsBroken}}):_c('span',{staticClass:"app-button__initials"},[_vm._v(_vm._s(_vm.initials))]),_vm._v(" "),(_vm.configured)?_c('i',{staticClass:"app-button__check",attrs:{"title":_vm.stateText}},[_c('v-icon',[_vm._v("check")])],1):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"app-button__copy"},[_c('strong',[_vm._v(_vm._s(_vm.item.name))]),_vm._v(" "),(_vm.subtitle)?_c('small',[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()]),_vm._v(" "),(_vm.filterIcons.length)?_c('span',{staticClass:"app-button__actions",on:{"click":function($event){$event.stopPropagation();}}},_vm._l((_vm.filterIcons),function(icon,indexIcon){return _c('app-tooltip-button',{key:indexIcon,attrs:{"icon":icon.name,"color":_vm.dinamicColor(icon),"text":icon.text},on:{"click-icon":function($event){return _vm.iconAction(icon)}}})}),1):_vm._e(),_vm._v(" "),_c('v-icon',{staticClass:"app-button__chevron"},[_vm._v("chevron_right")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1020:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_resource_configuration_vue__ = __webpack_require__(829);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51421c4d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_resource_configuration_vue__ = __webpack_require__(1023);
function injectStyle (ssrContext) {
  __webpack_require__(1021)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-51421c4d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_resource_configuration_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51421c4d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_resource_configuration_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1021:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1022);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(516)("0818535a", content, true, {});

/***/ }),

/***/ 1022:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(515)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.resource-configuration[data-v-51421c4d]{padding:16px 14px 20px}.name-row[data-v-51421c4d]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;gap:10px;margin-bottom:9px}.name-row[data-v-51421c4d]:last-child{margin-bottom:0}.name-row__code[data-v-51421c4d]{background:#1a4338;border-radius:7px;color:#fff;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;font-size:11px;font-weight:700;letter-spacing:.08em;padding:4px 9px;text-transform:uppercase;width:44px;text-align:center}.icon-row[data-v-51421c4d]{gap:10px}.icon-path-field[data-v-51421c4d]{min-width:160px}.resource-icon-preview[data-v-51421c4d]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:linear-gradient(135deg,#2b435b,#3f6187);border-radius:10px;-webkit-box-shadow:0 3px 8px rgba(43,67,91,.22);box-shadow:0 3px 8px rgba(43,67,91,.22);display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;height:48px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;overflow:hidden;width:48px}.resource-icon-preview img[data-v-51421c4d]{height:30px;-o-object-fit:contain;object-fit:contain;width:30px}.resource-icon-preview .icon[data-v-51421c4d]{color:hsla(0,0%,100%,.55);font-size:22px}.recommended-name-button[data-v-51421c4d]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#eaf4fe;border:1px solid #cce2f6;border-radius:7px;color:#176fc1;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;font-size:10px;font-weight:600;height:30px;outline:none;padding:0 10px;white-space:nowrap}.recommended-name-button .icon[data-v-51421c4d]{color:#e19a18;font-size:17px;margin-right:5px}.recommended-name-button[data-v-51421c4d]:hover{background:#dceefe}@media(max-width:520px){.resource-configuration[data-v-51421c4d]{padding:12px 10px 16px}.name-row[data-v-51421c4d]{-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:5px}.name-row__code[data-v-51421c4d]{-ms-flex-item-align:start;align-self:flex-start}}", "", {"version":3,"sources":["/opt/build/repo/src/components/resources/resource-configuration.vue"],"names":[],"mappings":"AACA,WAAW,yBAA2B,0CAA0C,gBAAmB,iBAAiB,CACnH,AACD,WAAW,sBAAwB,uCAAuC,gBAAmB,iBAAiB,CAC7G,AACD,WAAW,uBAAyB,wCAAwC,gBAAmB,iBAAiB,CAC/G,AACD,WAAW,0BAA4B,8CAA8C,gBAAmB,iBAAiB,CACxH,AACD,WAAW,uBAAyB,2CAA2C,gBAAmB,iBAAiB,CAClH,AACD,WAAW,2BAA6B,+CAA+C,gBAAmB,iBAAiB,CAC1H,AACD,WAAW,wBAA0B,4CAA4C,gBAAmB,iBAAiB,CACpH,AACD,yCAAyC,sBAAsB,CAC9D,AACD,2BAA2B,yBAAyB,sBAAsB,mBAAmB,oBAAoB,oBAAoB,aAAa,SAAS,iBAAiB,CAC3K,AACD,sCAAsC,eAAe,CACpD,AACD,iCAAiC,mBAAmB,kBAAkB,WAAW,mBAAmB,kBAAkB,cAAc,eAAe,gBAAgB,qBAAqB,gBAAgB,yBAAyB,WAAW,iBAAiB,CAC5P,AACD,2BAA2B,QAAQ,CAClC,AACD,kCAAkC,eAAe,CAChD,AACD,wCAAwC,yBAAyB,sBAAsB,mBAAmB,mDAA6D,mBAAmB,gDAAgD,wCAAwC,2BAA2B,2BAA2B,oBAAoB,mBAAmB,kBAAkB,cAAc,YAAY,wBAAwB,qBAAqB,uBAAuB,gBAAgB,UAAU,CACxf,AACD,4CAA4C,YAAY,sBAAsB,mBAAmB,UAAU,CAC1G,AACD,8CAA8C,0BAA4B,cAAc,CACvF,AACD,0CAA0C,yBAAyB,sBAAsB,mBAAmB,mBAAmB,yBAAyB,kBAAkB,cAAc,eAAe,oBAAoB,oBAAoB,aAAa,mBAAmB,kBAAkB,cAAc,eAAe,gBAAgB,YAAY,aAAa,eAAe,kBAAkB,CACvY,AACD,gDAAgD,cAAc,eAAe,gBAAgB,CAC5F,AACD,gDAAgD,kBAAkB,CACjE,AACD,wBACA,yCAAyC,sBAAsB,CAC9D,AACD,2BAA2B,0BAA0B,uBAAuB,oBAAoB,4BAA4B,6BAA6B,0BAA0B,sBAAsB,OAAO,CAC/M,AACD,iCAAiC,0BAA0B,qBAAqB,CAC/E,CACA","file":"resource-configuration.vue","sourcesContent":["\n@font-face{font-family:\"Lato_regular\";src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_bold\";src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_light\";src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_regular\";src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_bold\";src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_semibold\";src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_light\";src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:normal;font-style:normal\n}\n.resource-configuration[data-v-51421c4d]{padding:16px 14px 20px\n}\n.name-row[data-v-51421c4d]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;gap:10px;margin-bottom:9px\n}\n.name-row[data-v-51421c4d]:last-child{margin-bottom:0\n}\n.name-row__code[data-v-51421c4d]{background:#1a4338;border-radius:7px;color:#fff;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;font-size:11px;font-weight:700;letter-spacing:.08em;padding:4px 9px;text-transform:uppercase;width:44px;text-align:center\n}\n.icon-row[data-v-51421c4d]{gap:10px\n}\n.icon-path-field[data-v-51421c4d]{min-width:160px\n}\n.resource-icon-preview[data-v-51421c4d]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:linear-gradient(135deg, #2b435b 0%, #3f6187 100%);border-radius:10px;-webkit-box-shadow:0 3px 8px rgba(43,67,91,.22);box-shadow:0 3px 8px rgba(43,67,91,.22);display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;height:48px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;overflow:hidden;width:48px\n}\n.resource-icon-preview img[data-v-51421c4d]{height:30px;-o-object-fit:contain;object-fit:contain;width:30px\n}\n.resource-icon-preview .icon[data-v-51421c4d]{color:rgba(255,255,255,.55);font-size:22px\n}\n.recommended-name-button[data-v-51421c4d]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#eaf4fe;border:1px solid #cce2f6;border-radius:7px;color:#176fc1;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;font-size:10px;font-weight:600;height:30px;outline:none;padding:0 10px;white-space:nowrap\n}\n.recommended-name-button .icon[data-v-51421c4d]{color:#e19a18;font-size:17px;margin-right:5px\n}\n.recommended-name-button[data-v-51421c4d]:hover{background:#dceefe\n}\n@media(max-width: 520px){\n.resource-configuration[data-v-51421c4d]{padding:12px 10px 16px\n}\n.name-row[data-v-51421c4d]{-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:5px\n}\n.name-row__code[data-v-51421c4d]{-ms-flex-item-align:start;align-self:flex-start\n}\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1023:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"resource-configuration"},[_c('form-section',{attrs:{"icon":"format_list_numbered","eyebrow":"Orden","title":"Posición","description":"Define el lugar que ocupa dentro del menú.","tight":""}},[(_vm.resource.templateLanguages)?_c('v-text-field',{attrs:{"type":"number","solo":"","hide-details":""},on:{"input":_vm.itWasUpdated},model:{value:(_vm.resource.templateLanguages.position),callback:function ($$v) {_vm.$set(_vm.resource.templateLanguages, "position", $$v)},expression:"resource.templateLanguages.position"}}):_c('v-text-field',{attrs:{"type":"number","solo":"","hide-details":""},model:{value:(_vm.newPosition),callback:function ($$v) {_vm.newPosition=$$v},expression:"newPosition"}})],1),_vm._v(" "),_c('form-section',{attrs:{"icon":"translate","eyebrow":"Idiomas","title":"Nombre","description":"Puedes usar el nombre recomendado o escribir uno diferente.","badge":_vm.namesBadge}},[_c('template',{slot:"aside"},[(_vm.hasRecommendedName)?_c('button',{staticClass:"recommended-name-button",attrs:{"type":"button"},on:{"click":_vm.useRecommendedName}},[_c('v-icon',[_vm._v("lightbulb_outline")]),_vm._v("\n\t\t\t\tUsar “"+_vm._s(_vm.recommendedName)+"”\n\t\t\t")],1):_vm._e()]),_vm._v(" "),_vm._l((_vm.resource.templateLanguagesArray),function(lang,indexLang){return _c('div',{key:indexLang,staticClass:"name-row"},[_c('span',{staticClass:"name-row__code"},[_vm._v(_vm._s(lang.id))]),_vm._v(" "),_c('v-text-field',{attrs:{"solo":"","hide-details":"","placeholder":"Nombre que verá el usuario"},on:{"input":_vm.itWasUpdated},model:{value:(lang.name),callback:function ($$v) {_vm.$set(lang, "name", $$v)},expression:"lang.name"}})],1)})],2),_vm._v(" "),_c('form-section',{attrs:{"icon":"image","eyebrow":"Identidad","title":"Ícono","description":_vm.requireIcon ?
			'Se muestra junto al nombre en el menú.' :
			'Opcional: si no cargas uno, el menú usa el ícono por defecto.',"tone":"info"}},[_c('v-layout',{staticClass:"icon-row",attrs:{"wrap":"","align-center":""}},[_c('div',{staticClass:"resource-icon-preview",attrs:{"title":_vm.resource.pathIcon || 'Sin ícono'}},[(_vm.showIconPreview)?_c('img',{attrs:{"src":_vm.resource.pathIcon,"alt":"Ícono del recurso"},on:{"error":_vm.markIconAsBroken}}):_c('v-icon',[_vm._v("broken_image")])],1),_vm._v(" "),_c('upload-image',{attrs:{"label-ref":"up","label-for":"image","input-id":"image"},on:{"send-image":_vm.getImage}}),_vm._v(" "),_c('v-flex',{staticClass:"icon-path-field"},[_c('v-text-field',{attrs:{"solo":"","hide-details":"","placeholder":"URL del ícono"},on:{"input":_vm.itWasUpdated},model:{value:(_vm.resource.pathIcon),callback:function ($$v) {_vm.$set(_vm.resource, "pathIcon", $$v)},expression:"resource.pathIcon"}})],1)],1)],1),_vm._v(" "),_c('section',{staticClass:"modal-filter-footer"},[_c('modal-sidebar-button',{attrs:{"is-loading":_vm.$v.$invalid,"helper-text":_vm.footerHelper},on:{"accept-button-clicked":function($event){return _vm.$emit('save-data', _vm.resource, _vm.newPosition)},"cancel-button-clicked":function($event){return _vm.$emit('close-modal')}}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1024:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_new_rol_component_vue__ = __webpack_require__(830);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25066d3b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_new_rol_component_vue__ = __webpack_require__(1025);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_new_rol_component_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25066d3b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_new_rol_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1025:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-5 pt-5"},[_c('label',[_vm._v("\n\t\tTipo de Rol\n\t\t"),_c('v-select',{attrs:{"solo":"","return-object":"","placeholder":"Tipo de rol","item-text":"name","item-value":"id","items":_vm.globalRoles},model:{value:(_vm.globalRoleSelected),callback:function ($$v) {_vm.globalRoleSelected=$$v},expression:"globalRoleSelected"}})],1),_vm._v(" "),_c('label',[_vm._v("\n\t\tNombre del Rol\n\t\t"),_c('v-text-field',{staticClass:"mb-3",attrs:{"solo":"","hide-details":"","label":"Nombre del rol"},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})],1),_vm._v(" "),_c('label',[_vm._v("\n\t\tCódigo del rol\n\t\t"),_c('v-text-field',{staticClass:"mb-3",attrs:{"solo":"","hide-details":"","label":"Código del rol"},model:{value:(_vm.code),callback:function ($$v) {_vm.code=$$v},expression:"code"}})],1),_vm._v(" "),_c('v-switch',{attrs:{"label":"Administrador"},model:{value:(_vm.flagAdmin),callback:function ($$v) {_vm.flagAdmin=$$v},expression:"flagAdmin"}}),_vm._v(" "),_c('section',{staticClass:"modal-filter-footer"},[_c('modal-sidebar-button',{attrs:{"is-loading":_vm.$v.$invalid},on:{"accept-button-clicked":_vm.createNewRole,"cancel-button-clicked":function($event){return _vm.closeModal(false)}}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1026:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_actions_bar_vue__ = __webpack_require__(831);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b376e30_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_actions_bar_vue__ = __webpack_require__(1029);
function injectStyle (ssrContext) {
  __webpack_require__(1027)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_actions_bar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b376e30_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_actions_bar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1027:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1028);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(516)("3bf17d04", content, true, {});

/***/ }),

/***/ 1028:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(515)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.actions-bar-container{padding:6px 10px 0!important}.actions-bar-table.app-table-wrapper{max-height:calc(100vh - 150px)!important;overflow-x:auto!important;overflow-y:auto!important}.actions-bar-table .table-list{table-layout:auto}.actions-bar-table .table-list>thead{position:sticky!important;top:0;z-index:4}.actions-bar-table .table-list>tbody>tr,.actions-bar-table .table-list>tbody>tr>td{height:34px!important;min-height:34px!important}.actions-bar-table .table-list>tbody>tr>td{font-size:10px!important;padding:2px 7px!important}.actions-bar-table .table-list .action-input-cell{padding-left:5px!important;padding-right:5px!important}.actions-bar-table .table-list .action-text-cell{white-space:nowrap}.actions-bar-table .table-list>tbody>tr>td:not(:first-child),.actions-bar-table .table-list>thead>tr:last-child>th:not(:first-child){padding-left:6px!important;padding-right:6px!important}.action-inline-input{background:#fff!important;border:1px solid #d6e1ea!important;border-radius:6px;-webkit-box-shadow:none;box-shadow:none;color:#314a60;font-size:11px;height:27px;outline:none;padding:0 8px;text-align:left;width:52px}.action-inline-input:focus{border-color:#1a4338!important;-webkit-box-shadow:0 0 0 2px rgba(33,150,243,.1);box-shadow:0 0 0 2px rgba(33,150,243,.1)}.action-position-input{text-align:center;width:60px}.action-number-input{text-align:center}.action-input-cell{text-align:center!important}", "", {"version":3,"sources":["/opt/build/repo/src/components/actions/actions-bar.vue"],"names":[],"mappings":"AACA,WAAW,yBAA2B,0CAA0C,gBAAmB,iBAAiB,CACnH,AACD,WAAW,sBAAwB,uCAAuC,gBAAmB,iBAAiB,CAC7G,AACD,WAAW,uBAAyB,wCAAwC,gBAAmB,iBAAiB,CAC/G,AACD,WAAW,0BAA4B,8CAA8C,gBAAmB,iBAAiB,CACxH,AACD,WAAW,uBAAyB,2CAA2C,gBAAmB,iBAAiB,CAClH,AACD,WAAW,2BAA6B,+CAA+C,gBAAmB,iBAAiB,CAC1H,AACD,WAAW,wBAA0B,4CAA4C,gBAAmB,iBAAiB,CACpH,AACD,uBAAuB,4BAA6B,CACnD,AACD,qCAAqC,yCAA0C,0BAA2B,yBAA0B,CACnI,AACD,+BAA+B,iBAAiB,CAC/C,AACD,qCAAqC,0BAA2B,MAAM,SAAS,CAC9E,AACD,mFAAmF,sBAAuB,yBAA0B,CACnI,AACD,2CAA2C,yBAA0B,yBAA0B,CAC9F,AACD,kDAAkD,2BAA4B,2BAA4B,CACzG,AACD,iDAAiD,kBAAkB,CAClE,AACD,qIAAqI,2BAA4B,2BAA4B,CAC5L,AACD,qBAAqB,0BAA2B,mCAAoC,kBAAkB,wBAAwB,gBAAgB,cAAc,eAAe,YAAY,aAAa,cAAc,gBAAgB,UAAU,CAC3O,AACD,2BAA2B,+BAAgC,iDAAiD,wCAAwC,CACnJ,AACD,uBAAuB,kBAAkB,UAAU,CAClD,AACD,qBAAqB,iBAAiB,CACrC,AACD,mBAAmB,2BAA4B,CAC9C","file":"actions-bar.vue","sourcesContent":["\n@font-face{font-family:\"Lato_regular\";src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_bold\";src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_light\";src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_regular\";src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_bold\";src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_semibold\";src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_light\";src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:normal;font-style:normal\n}\n.actions-bar-container{padding:6px 10px 0 !important\n}\n.actions-bar-table.app-table-wrapper{max-height:calc(100vh - 150px) !important;overflow-x:auto !important;overflow-y:auto !important\n}\n.actions-bar-table .table-list{table-layout:auto\n}\n.actions-bar-table .table-list>thead{position:sticky !important;top:0;z-index:4\n}\n.actions-bar-table .table-list>tbody>tr,.actions-bar-table .table-list>tbody>tr>td{height:34px !important;min-height:34px !important\n}\n.actions-bar-table .table-list>tbody>tr>td{font-size:10px !important;padding:2px 7px !important\n}\n.actions-bar-table .table-list .action-input-cell{padding-left:5px !important;padding-right:5px !important\n}\n.actions-bar-table .table-list .action-text-cell{white-space:nowrap\n}\n.actions-bar-table .table-list>thead>tr:last-child>th:not(:first-child),.actions-bar-table .table-list>tbody>tr>td:not(:first-child){padding-left:6px !important;padding-right:6px !important\n}\n.action-inline-input{background:#fff !important;border:1px solid #d6e1ea !important;border-radius:6px;-webkit-box-shadow:none;box-shadow:none;color:#314a60;font-size:11px;height:27px;outline:none;padding:0 8px;text-align:left;width:52px\n}\n.action-inline-input:focus{border-color:#1a4338 !important;-webkit-box-shadow:0 0 0 2px rgba(33,150,243,.1);box-shadow:0 0 0 2px rgba(33,150,243,.1)\n}\n.action-position-input{text-align:center;width:60px\n}\n.action-number-input{text-align:center\n}\n.action-input-cell{text-align:center !important\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1029:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{staticClass:"actions-bar-container",attrs:{"fluid":""}},[_c('app-table',{staticClass:"actions-bar-table is-not-selectable",attrs:{"selectable":"","compact":"","contained":"","sticky-header":"","name":"resources","columns":_vm.columns,"column-widths":{ 1: '190px', 2: '145px', 3: '185px', 4: '70px', 5: '65px' },"rows":_vm.actions,"check-all":_vm.checkAll},on:{"on-selected-all":_vm.allIsSelected,"row-is-selected":_vm.rowIsSelected},scopedSlots:_vm._u([{key:"rows",fn:function(props){return [_c('td',{staticClass:"action-text-cell",attrs:{"title":_vm.getName(props.row)}},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.getName(props.row))+"\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"action-text-cell",attrs:{"title":props.row.code}},[_vm._v("\n\t\t\t\t\t"+_vm._s(props.row.code)+"\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"action-text-cell",attrs:{"title":props.row.codeWeb}},[_vm._v("\n\t\t\t\t\t"+_vm._s(props.row.codeWeb || '—')+"\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"action-input-cell"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(props.row.numFragment),expression:"props.row.numFragment"}],staticClass:"action-inline-input action-number-input",attrs:{"type":"number","min":"0","aria-label":"Fragment móvil"},domProps:{"value":(props.row.numFragment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(props.row, "numFragment", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"action-input-cell"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(props.row.position),expression:"props.row.position"}],staticClass:"action-inline-input action-position-input",attrs:{"type":"number","min":"0","max":"20","aria-label":"Posición"},domProps:{"value":(props.row.position)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(props.row, "position", $event.target.value)}}})])]}}])})],1),_vm._v(" "),_c('section',{staticClass:"modal-filter-footer"},[_c('modal-sidebar-button',{attrs:{"is-loading":!_vm.hasChanges},on:{"accept-button-clicked":_vm.saveChanges,"cancel-button-clicked":function($event){return _vm.$emit('close-modal')}}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1030:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_resource_web_service_vue__ = __webpack_require__(832);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b775118a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_resource_web_service_vue__ = __webpack_require__(1031);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_resource_web_service_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b775118a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_resource_web_service_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1031:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-table',{staticClass:"is-not-selectable pa-4",attrs:{"selectable":"","name":"action-list","columns":_vm.columns,"current-page":_vm.currentPage,"rows":_vm.webServices,"last-page":_vm.lastPage,"check-all":_vm.checkAll},on:{"on-selected-all":_vm.allIsSelected,"row-is-selected":_vm.rowIsSelected},scopedSlots:_vm._u([{key:"rows",fn:function(props){return [_c('td',{staticClass:"is-not-selectable"},[_vm._v("\n\t\t\t\t"+_vm._s(props.row.domain)+"\n\t\t\t")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.row.method))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.row.path))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.row.name))]),_vm._v(" "),_c('td',[_c('v-checkbox',{staticClass:"mt-0 pl-2",attrs:{"color":"success","hide-details":"","disabled":!props.row.isSelected},model:{value:(props.row.authorize),callback:function ($$v) {_vm.$set(props.row, "authorize", $$v)},expression:"props.row.authorize"}})],1)]}}])}),_vm._v(" "),_c('section',{staticClass:"modal-filter-footer"},[_c('modal-sidebar-button',{attrs:{"is-loading":false},on:{"accept-button-clicked":function($event){return _vm.$emit('save-web-service', _vm.webServices)},"cancel-button-clicked":function($event){return _vm.$emit('close')}}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1032:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"resources-assignment-page has-menu-builder",class:{ 'menu-builder-empty': !_vm.hasSelectedApplication }},[_c('v-layout',{staticClass:"rol-section assignment-toolbar px-5"},[_c('v-flex',{staticClass:"role-picker",attrs:{"xs12":""}},[_c('v-select',{attrs:{"solo":"","hide-details":"","return-object":"","label":"Roles","item-text":"name","items":_vm.roles},on:{"input":function($event){return _vm.getData($event, 'rolSelected', 'codeRole', 'apps')}}})],1),_vm._v(" "),_c('v-flex',{staticClass:"role-create-action",attrs:{"xs12":""}},[(_vm.canFinishConfiguration)?_c('v-btn',{staticClass:"btn-action caption assignment-finish-button",attrs:{"type":"button","color":"primary","disabled":_vm.finalizing,"loading":_vm.finalizing},on:{"click":function($event){$event.stopPropagation();return _vm.finishConfiguration.apply(null, arguments)}}},[_vm._v("\n\t\t\t\tFinalizar configuración\n\t\t\t\t"),_c('v-icon',{staticClass:"ml-2",attrs:{"size":"18"}},[_vm._v("done_all")])],1):_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"create-role-button",attrs:{"type":"button","color":"primary"},on:{"click":_vm.newRol}},[_vm._v("\n\t\t\t\tCrear rol\n\t\t\t\t"),_c('v-icon',{attrs:{"color":"white"}},[_vm._v("add")])],1)],1)],1),_vm._v(" "),(!_vm.appsExist)?_c('section',{staticClass:"assignment-empty-state"},[_c('span',{staticClass:"assignment-empty-icon"},[_c('v-icon',[_vm._v("device_hub")])],1),_vm._v(" "),_c('small',[_vm._v("CONFIGURACIÓN GUIADA")]),_vm._v(" "),_c('h2',[_vm._v("Construye el menú de acceso")]),_vm._v(" "),_c('p',[_vm._v("Selecciona un rol para comenzar a organizar sus aplicaciones, módulos y recursos.")]),_vm._v(" "),_c('div',{staticClass:"assignment-empty-steps"},[_vm._m(0),_vm._v(" "),_c('v-icon',[_vm._v("chevron_right")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('v-icon',[_vm._v("chevron_right")]),_vm._v(" "),_vm._m(2)],1)]):_vm._e(),_vm._v(" "),(_vm.appsExist)?_c('nav',{staticClass:"assignment-progress px-5",attrs:{"aria-label":"Flujo de asignación"}},[_c('span',{staticClass:"progress-step",class:{ 'is-complete': _vm.hasSelectedApplication, 'is-active': !_vm.hasSelectedApplication }},[_c('i',[_vm._v("1")]),_vm._v(" Aplicación")]),_vm._v(" "),_c('v-icon',[_vm._v("chevron_right")]),_vm._v(" "),_c('span',{staticClass:"progress-step",class:{ 'is-complete': _vm.hasSelectedModule, 'is-active': _vm.hasSelectedApplication && !_vm.hasSelectedModule }},[_c('i',[_vm._v("2")]),_vm._v(" Módulo")]),_vm._v(" "),_c('v-icon',[_vm._v("chevron_right")]),_vm._v(" "),_c('span',{staticClass:"progress-step",class:{ 'is-active': _vm.hasSelectedModule }},[_c('i',[_vm._v("3")]),_vm._v(" Recursos")])],1):_vm._e(),_vm._v(" "),(_vm.hasSelectedApplication)?_c('div',{staticClass:"selection-path mx-5"},[_c('div',{staticClass:"selection-path-item"},[_c('span',{staticClass:"path-icon app-selection"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("apps")])],1),_vm._v(" "),_c('div',{staticClass:"selection-path-copy"},[_c('small',[_vm._v("Aplicación · "+_vm._s(_vm.enabledAppsCount)+" de "+_vm._s(_vm.apps.length)+" habilitadas")]),_c('strong',[_vm._v(_vm._s(_vm.getAppName))])]),_vm._v(" "),_c('div',{staticClass:"path-actions"},[(_vm.configured(_vm.app))?_c('span',{staticClass:"path-status"},[_vm._v("Habilitada")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"menu-preview-mobile-trigger",attrs:{"type":"button","title":"Ver menú"},on:{"click":function($event){return _vm.openMenuPreview()}}},[_c('v-icon',[_vm._v("format_list_numbered")])],1),_vm._v(" "),_c('button',{staticClass:"change-selection-button",attrs:{"type":"button","title":"Cambiar aplicación"},on:{"click":_vm.changeApplication}},[_c('v-icon',[_vm._v("swap_horiz")])],1)])]),_vm._v(" "),(_vm.hasSelectedModule)?_c('v-icon',{staticClass:"path-divider"},[_vm._v("chevron_right")]):_vm._e(),_vm._v(" "),(_vm.hasSelectedModule)?_c('div',{staticClass:"selection-path-item"},[_c('span',{staticClass:"path-icon module-selection"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("view_module")])],1),_vm._v(" "),_c('div',{staticClass:"selection-path-copy"},[_c('small',[_vm._v("Módulo · "+_vm._s(_vm.enabledModulesCount)+" de "+_vm._s(_vm.modules.length)+" habilitados")]),_c('strong',[_vm._v(_vm._s(_vm.getModuleName))])]),_vm._v(" "),_c('div',{staticClass:"path-actions"},[(_vm.configured(_vm.module))?_c('span',{staticClass:"path-status"},[_vm._v("Habilitado")]):_vm._e(),_vm._v(" "),_c('app-tooltip-button',{attrs:{"color":"success","icon":"settings","text":"Configurar módulo"},on:{"click-icon":function($event){return _vm.openModuleAndResourceConfiguration('module', _vm.module)}}})],1)]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"fade-down","mode":"out-in"}},[(_vm.appsExist && !_vm.hasSelectedApplication)?_c('div',{staticClass:"assignment-panel mx-5"},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"assignment-section-header"},[_c('div',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("apps")]),_c('h3',[_vm._v("Aplicaciones")])],1),_vm._v(" "),_c('div',{staticClass:"assignment-summary"},[_c('span',{staticClass:"enabled-count"},[_vm._v(_vm._s(_vm.enabledAppsCount)+" habilitadas")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.apps.length)+" en total")])])]),_vm._v(" "),_c('div',{staticClass:"responsive-grid"},_vm._l((_vm.sortedApps),function(app){return _c('app-button',{key:app.id || app.codeApp,attrs:{"active":Boolean(app.isActive),"configured":_vm.configured(app),"icon-path":_vm.assignmentIcon(app),"icons-to-use":_vm.appUseIcon(app),"item":app,"subtitle":_vm.assignmentSubtitle(app),"state-text":"Habilitada"},on:{"erase-configuration":_vm.deleteApplicationConfiguration,"button-clicked":function($event){return _vm.getData($event, 'app', 'codeApp', 'modules')}}})}),1)])],1)],1):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"fade-down","mode":"out-in"}},[(_vm.modulesExist && !_vm.hasSelectedModule)?_c('v-layout',{staticClass:"module-section assignment-panel mx-5"},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"assignment-section-header"},[_c('div',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("view_module")]),_c('h3',[_vm._v(_vm._s(_vm.getAppName)+" · Módulos")])],1),_vm._v(" "),_c('div',{staticClass:"assignment-summary"},[_c('span',{staticClass:"enabled-count"},[_vm._v(_vm._s(_vm.enabledModulesCount)+" habilitados")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.modules.length)+" en total")])])]),_vm._v(" "),_c('div',{staticClass:"responsive-grid"},_vm._l((_vm.sortedModules),function(mod){return _c('app-button',{key:mod.id || mod.idModule,attrs:{"active":Boolean(mod.isActive),"configured":_vm.configured(mod),"icon-path":_vm.assignmentIcon(mod),"icons-to-use":_vm.moduleUseIcon(mod),"item":mod,"subtitle":_vm.moduleSubtitle(mod),"state-text":"Habilitado"},on:{"erase-configuration":function($event){return _vm.deleteConfiguration('moduleIds', $event)},"button-clicked":function($event){return _vm.getData($event, 'module', 'idModule', 'resources')},"edit-button":function($event){return _vm.openModuleAndResourceConfiguration('module', $event)}}})}),1)])],1):_vm._e()],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade-down","mode":"out-in"}},[(_vm.resourcesExist)?_c('div',{staticClass:"assignment-panel resource-assignment-panel mx-5"},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"assignment-section-header"},[_c('div',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("device_hub")]),_c('h3',[_vm._v(_vm._s(_vm.getAppName)+" · "+_vm._s(_vm.getModuleName))])],1)]),_vm._v(" "),_c('div',{staticClass:"resource-table-card"},[_c('div',{staticClass:"resource-table-toolbar"},[_c('div',{staticClass:"resource-search",class:{ 'is-filled': _vm.resourceSearch }},[_c('v-icon',[_vm._v("search")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.resourceSearch),expression:"resourceSearch"}],attrs:{"type":"text","placeholder":"Buscar por nombre, URL o recurso padre…"},domProps:{"value":(_vm.resourceSearch)},on:{"input":function($event){if($event.target.composing){ return; }_vm.resourceSearch=$event.target.value}}}),_vm._v(" "),(_vm.resourceSearch)?_c('button',{attrs:{"type":"button","title":"Limpiar búsqueda"},on:{"click":function($event){_vm.resourceSearch = ''}}},[_c('v-icon',[_vm._v("close")])],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"resource-filter-chips"},_vm._l((_vm.resourceFilters),function(filter){return _c('button',{key:filter.code,staticClass:"resource-filter-chip",class:[
										("resource-filter-chip--" + (filter.code)),
										{ 'is-active': _vm.resourceFilter === filter.code } ],attrs:{"type":"button","title":filter.hint},on:{"click":function($event){_vm.resourceFilter = filter.code}}},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(filter.label)),_c('strong',[_vm._v(_vm._s(filter.count))])])}),0)]),_vm._v(" "),_c('div',{staticClass:"resource-table-guide"},[_c('div',{staticClass:"resource-table-guide-text"},[_c('v-icon',{attrs:{"color":"primary","size":"20"}},[_vm._v("info_outline")]),_vm._v(" "),_c('span',[_vm._v("Marca el checkbox para activar un recurso, ordena con las flechas y configura su nombre.")])],1),_vm._v(" "),_c('div',{staticClass:"resource-table-summary"},[(_vm.pendingChangesCount)?_c('span',{staticClass:"summary-chip summary-chip-pending"},[_c('v-icon',[_vm._v("cloud_upload")]),_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.pendingChangesCount)+" sin guardar\n\t\t\t\t\t\t\t\t")],1):_vm._e(),_vm._v(" "),_c('span',{staticClass:"summary-chip summary-chip-active"},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.activeResourcesCount)+" activos\n\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('span',{staticClass:"summary-chip"},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.inactiveResourcesCount)+" inactivos\n\t\t\t\t\t\t\t\t")])])]),_vm._v(" "),(_vm.noResourcesForFilter)?_c('div',{staticClass:"resource-filter-empty"},[_c('v-icon',[_vm._v("filter_list")]),_vm._v(" "),_c('div',[_c('strong',[_vm._v("Ningún recurso coincide con el filtro")]),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.resources.length)+" recursos disponibles en este módulo.")])]),_vm._v(" "),_c('button',{attrs:{"type":"button"},on:{"click":_vm.clearResourceFilters}},[_vm._v("Limpiar filtros")])],1):_vm._e(),_vm._v(" "),_c('app-table',{staticClass:"resources-table is-not-selectable",attrs:{"selectable":"","name":"resources","input-search":false,"columns":_vm.columns,"check-all":_vm.checkAllResources,"rows":_vm.resourcesComputed},on:{"on-selected-all":_vm.selectAllResources,"row-is-selected":_vm.resourceSelectAction},scopedSlots:_vm._u([{key:"rows",fn:function(props){return [_c('td',[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(props.row.name)+"\n\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('td',[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(props.row.uri)+"\n\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('td',[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.getResourceName(props.row))+"\n\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('td',[_c('div',{staticClass:"resource-languages-cell"},_vm._l((_vm.resourceLanguagesStatus(props.row)),function(languageStatus){return _c('span',{key:((props.row.id) + "-" + (languageStatus.code)),staticClass:"language-chip",class:{ 'language-chip-filled': languageStatus.filled },attrs:{"title":languageStatus.filled ?
												languageStatus.name : 'Sin nombre configurado'}},[_c('v-icon',[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(languageStatus.filled ? 'check_circle' : 'error_outline')+"\n\t\t\t\t\t\t\t\t\t\t\t")]),_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(languageStatus.code)+"\n\t\t\t\t\t\t\t\t\t\t")],1)}),0)]),_vm._v(" "),_c('td',{staticClass:"resource-position-cell"},[_c('div',{staticClass:"position-control"},[_c('v-text-field',{attrs:{"solo":"","hide-details":"","type":"number","min":"1","disabled":!props.row.isSelected,"value":props.row.position},on:{"change":function($event){return _vm.changeResourcePosition(props.row, $event)}}}),_vm._v(" "),_c('div',{staticClass:"position-steppers"},[_c('button',{attrs:{"type":"button","title":"Subir","disabled":!_vm.canMoveResource(props.row, -1)},on:{"click":function($event){return _vm.moveResource(props.row, -1)}}},[_c('v-icon',[_vm._v("keyboard_arrow_up")])],1),_vm._v(" "),_c('button',{attrs:{"type":"button","title":"Bajar","disabled":!_vm.canMoveResource(props.row, 1)},on:{"click":function($event){return _vm.moveResource(props.row, 1)}}},[_c('v-icon',[_vm._v("keyboard_arrow_down")])],1)])],1)]),_vm._v(" "),_c('td',[_c('div',{staticClass:"resource-icon-preview"},[_c('span',{staticClass:"resource-icon-empty"},[_vm._v("—")]),_vm._v(" "),(_vm.resourceIcon(props.row))?_c('img',{attrs:{"src":_vm.resourceIcon(props.row),"alt":("Ícono de " + (props.row.name))},on:{"error":_vm.hideBrokenImage}}):_vm._e()])]),_vm._v(" "),_c('td',[_c('app-tooltip-button',{attrs:{"color":"green","icon":"settings","text":"Conf. de Recursos"},on:{"click-icon":function($event){return _vm.openModuleAndResourceConfiguration(
											'resource',
											props.row
										)}}}),_vm._v(" "),_c('app-tooltip-button',{attrs:{"disabled":props.row.disabled,"color":"primary","icon":"timeline","text":"Barra de acciones"},on:{"click-icon":function($event){return _vm.openActionsBarModal(props.row)}}}),_vm._v(" "),_c('app-tooltip-button',{attrs:{"color":"primary","icon":"cloud_queue","text":"Servicios web"},on:{"click-icon":function($event){return _vm.loadServices(props.row)}}})],1)]}}],null,false,2269522064)})],1)])],1)],1):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"menu-preview-fade"}},[(_vm.showMenuPreview)?_c('button',{staticClass:"menu-preview-backdrop",attrs:{"type":"button","aria-label":"Cerrar vista del menú"},on:{"click":function($event){_vm.showMenuPreview = false}}}):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"menu-preview-slide"}},[_c('aside',{staticClass:"menu-preview-panel",class:{ 'is-open': _vm.showMenuPreview },attrs:{"aria-label":"Vista del menú configurado"}},[_c('header',{staticClass:"menu-preview-header"},[_c('div',[_c('span',{staticClass:"menu-preview-icon"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("format_list_numbered")])],1),_vm._v(" "),_c('div',[_c('small',[_vm._v("ORDEN CONFIGURADO")]),_c('h3',[_vm._v("Vista del menú")])])]),_vm._v(" "),_c('button',{attrs:{"type":"button","aria-label":"Cerrar"},on:{"click":function($event){_vm.showMenuPreview = false}}},[_c('v-icon',[_vm._v("close")])],1)]),_vm._v(" "),(_vm.hasSelectedApplication)?_c('div',{staticClass:"menu-preview-context"},[_c('v-icon',[_vm._v("apps")]),_vm._v(" "),_c('div',[_c('small',[_vm._v("Aplicación")]),_c('strong',[_vm._v(_vm._s(_vm.getAppName))])]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.configuredModulesPreview.length)+" módulos")])],1):_vm._e(),_vm._v(" "),(_vm.hasSelectedApplication && _vm.configuredModulesPreview.length)?_c('div',{staticClass:"menu-preview-list"},_vm._l((_vm.configuredModulesPreview),function(mod){return _c('section',{key:mod.id || mod.idModule,staticClass:"menu-preview-group",class:{ 'is-current': _vm.isCurrentModule(mod) }},[_c('div',{staticClass:"menu-preview-module-row"},[_c('button',{staticClass:"menu-preview-item",attrs:{"type":"button"},on:{"click":function($event){return _vm.selectModuleFromPreview(mod)}}},[_c('span',{staticClass:"menu-preview-position"},[_vm._v(_vm._s(_vm.modulePositionLabel(mod)))]),_vm._v(" "),_c('span',{staticClass:"menu-entry-icon module-menu-icon"},[_c('v-icon',[_vm._v("view_module")]),_vm._v(" "),(_vm.moduleIcon(mod))?_c('img',{attrs:{"src":_vm.moduleIcon(mod),"alt":("Ícono de " + (_vm.moduleDisplayName(mod)))},on:{"error":_vm.hideBrokenImage}}):_vm._e()],1),_vm._v(" "),_c('span',{staticClass:"menu-preview-name"},[_c('strong',[_vm._v(_vm._s(_vm.moduleDisplayName(mod)))]),_c('small',[_vm._v(_vm._s(_vm.isCurrentModule(mod) ? ((_vm.moduleResourcesForPreview(mod).length) + " submenús activos") : 'Módulo configurado'))])]),_vm._v(" "),_c('v-icon',[_vm._v(_vm._s(_vm.isCurrentModule(mod) ? 'expand_more' : 'chevron_right'))])],1),_vm._v(" "),_c('button',{staticClass:"menu-preview-delete-module",attrs:{"type":"button","title":"Eliminar módulo"},on:{"click":function($event){return _vm.deleteConfiguration('moduleIds', mod)}}},[_c('v-icon',[_vm._v("delete_outline")])],1)]),_vm._v(" "),(_vm.isCurrentModule(mod) && _vm.moduleResourcesForPreview(mod).length)?_c('div',{staticClass:"menu-preview-submenu"},_vm._l((_vm.moduleResourcesForPreview(mod)),function(resourceItem){return _c('button',{key:resourceItem.id,attrs:{"type":"button"},on:{"click":function($event){return _vm.selectModuleFromPreview(mod)}}},[_c('span',[_vm._v(_vm._s(_vm.resourcePositionLabel(resourceItem)))]),_vm._v(" "),_c('span',{staticClass:"menu-entry-icon resource-menu-icon"},[_c('v-icon',[_vm._v("insert_drive_file")]),_vm._v(" "),(_vm.resourceIcon(resourceItem))?_c('img',{attrs:{"src":_vm.resourceIcon(resourceItem),"alt":("Ícono de " + (_vm.resourceDisplayName(resourceItem)))},on:{"error":_vm.hideBrokenImage}}):_vm._e()],1),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.resourceDisplayName(resourceItem)))])])}),0):(_vm.isCurrentModule(mod))?_c('div',{staticClass:"menu-preview-no-submenu"},[_vm._v("Sin submenús activos")]):_vm._e()])}),0):(_vm.hasSelectedApplication)?_c('div',{staticClass:"menu-preview-empty"},[_c('v-icon',[_vm._v("playlist_add")]),_vm._v(" "),_c('strong',[_vm._v("Aún no hay módulos configurados")]),_vm._v(" "),_c('span',[_vm._v("Selecciona un módulo para comenzar a construir el menú.")])],1):_c('div',{staticClass:"menu-preview-empty"},[_c('v-icon',[_vm._v("touch_app")]),_vm._v(" "),_c('strong',[_vm._v("Elige una aplicación")]),_vm._v(" "),_c('span',[_vm._v("Aquí se irá armando el menú: los módulos y sus submenús, en el orden que definas.")])],1),_vm._v(" "),(_vm.hasSelectedApplication)?_c('button',{staticClass:"add-module-button",attrs:{"type":"button"},on:{"click":_vm.showModulePicker}},[_c('span',[_c('v-icon',[_vm._v("add")])],1),_vm._v(" "),_c('div',[_c('strong',[_vm._v("Agregar módulo")]),_c('small',[_vm._v("Ver módulos disponibles")])]),_vm._v(" "),_c('v-icon',[_vm._v("chevron_right")])],1):_vm._e(),_vm._v(" "),(_vm.hasSelectedApplication)?_c('footer',[_c('v-icon',[_vm._v("info_outline")]),_vm._v(" El orden se actualiza al guardar cada módulo.")],1):_vm._e()])]),_vm._v(" "),_c('action-sidebar',{attrs:{"title":_vm.action.title,"value":_vm.action.open,"width":_vm.action.code === 'bar-actions' ? 780 : 600,"is-selected":_vm.action.IsSelected},on:{"close-modal":_vm.closeAssignmentSidebar}},[(_vm.action.code === 'bar-actions')?_c('bar-actions',{attrs:{"actions":_vm.actions},on:{"close-modal":_vm.clearTemporalSelected,"save-data":_vm.saveBarActionData,"select-all":_vm.selectAll,"row-is-selected":_vm.rowIsSelected}}):_vm._e(),_vm._v(" "),(_vm.action.code === 'rol')?_c('new-rol-component',{on:{"close-modal":_vm.closeRolModal}}):_vm._e(),_vm._v(" "),(_vm.chooseAction)?_c('resource-configuration',{attrs:{"resource":_vm.chooseResource,"require-icon":_vm.action.code === 'module',"suggested-position":_vm.suggestedPosition},on:{"set-image":_vm.setImageResource,"close-modal":_vm.closeConfiguration,"save-data":_vm.saveData}}):_vm._e(),_vm._v(" "),(_vm.action.code === 'list-service')?_c('resource-web-service',{attrs:{"web-services":_vm.webServices,"check-all":_vm.checkAllServices},on:{"close":_vm.clearTemporalSelected,"select-all":_vm.selectAllServices,"save-web-service":_vm.saveWebServices,"row-is-selected":_vm.rowIsSelectedServices}}):_vm._e()],1),_vm._v(" "),_c('section',{staticClass:"modal-filter-footer"},[_c('modal-sidebar-button',{attrs:{"is-loading":_vm.modelEmpty},on:{"accept-button-clicked":_vm.saveAssignmentChanges,"cancel-button-clicked":_vm.cancelAction}})],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"520"},model:{value:(_vm.distributionQuestion),callback:function ($$v) {_vm.distributionQuestion=$$v},expression:"distributionQuestion"}},[_c('v-card',{staticClass:"distribution-question-card"},[_c('div',{staticClass:"distribution-question-accent"}),_vm._v(" "),_c('v-card-title',{staticClass:"distribution-question-title"},[_c('span',{staticClass:"distribution-question-icon"},[_c('v-icon',[_vm._v("cloud_done")])],1),_vm._v(" "),_c('div',{staticClass:"distribution-question-heading"},[_c('small',[_vm._v("PROCESO COMPLETADO")]),_vm._v(" "),_c('strong',[_vm._v("Configuración guardada")])]),_vm._v(" "),_c('button',{staticClass:"distribution-question-close",attrs:{"type":"button","aria-label":"Cerrar"},on:{"click":_vm.stayOnAssignment}},[_c('v-icon',[_vm._v("close")])],1)]),_vm._v(" "),_c('v-card-text',{staticClass:"distribution-question-content"},[_c('h3',[_vm._v("¿Deseas distribuir los recursos ahora?")]),_vm._v(" "),_c('p',[_vm._v("La configuración quedó guardada. Puedes continuar editándola o avanzar a la distribución del template.")]),_vm._v(" "),_c('div',{staticClass:"distribution-question-note"},[_c('v-icon',[_vm._v("info_outline")]),_vm._v(" "),_c('span',[_vm._v("La distribución aplicará esta configuración a las compañías que selecciones.")])],1)]),_vm._v(" "),_c('v-card-actions',{staticClass:"distribution-question-actions"},[_c('v-btn',{staticClass:"distribution-secondary-action",attrs:{"type":"button","flat":""},on:{"click":_vm.stayOnAssignment}},[_vm._v("\n\t\t\t\t\tSeguir configurando\n\t\t\t\t")]),_vm._v(" "),_c('v-btn',{staticClass:"distribution-primary-action",attrs:{"type":"button","color":"primary"},on:{"click":_vm.goToDistribution}},[_vm._v("\n\t\t\t\t\tDistribuir ahora\n\t\t\t\t\t"),_c('v-icon',{staticClass:"ml-2",attrs:{"size":"18"}},[_vm._v("arrow_forward")])],1)],1)],1)],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',[_vm._v("1")]),_vm._v(" Elige un rol")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',[_vm._v("2")]),_vm._v(" Selecciona la aplicación")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',[_vm._v("3")]),_vm._v(" Ordena el menú")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 540:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_resources_assignment_vue__ = __webpack_require__(827);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e00fb316_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_resources_assignment_vue__ = __webpack_require__(1032);
function injectStyle (ssrContext) {
  __webpack_require__(1006)
  __webpack_require__(1008)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e00fb316"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_resources_assignment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e00fb316_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_resources_assignment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 558:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "withParams", {
  enumerable: true,
  get: function get() {
    return _withParams.default;
  }
});
exports.regex = exports.ref = exports.len = exports.req = void 0;

var _withParams = _interopRequireDefault(__webpack_require__(566));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var req = function req(value) {
  if (Array.isArray(value)) return !!value.length;

  if (value === undefined || value === null) {
    return false;
  }

  if (value === false) {
    return true;
  }

  if (value instanceof Date) {
    return !isNaN(value.getTime());
  }

  if (_typeof(value) === 'object') {
    for (var _ in value) {
      return true;
    }

    return false;
  }

  return !!String(value).length;
};

exports.req = req;

var len = function len(value) {
  if (Array.isArray(value)) return value.length;

  if (_typeof(value) === 'object') {
    return Object.keys(value).length;
  }

  return String(value).length;
};

exports.len = len;

var ref = function ref(reference, vm, parentVm) {
  return typeof reference === 'function' ? reference.call(vm, parentVm) : parentVm[reference];
};

exports.ref = ref;

var regex = function regex(type, expr) {
  return (0, _withParams.default)({
    type: type
  }, function (value) {
    return !req(value) || expr.test(value);
  });
};

exports.regex = regex;

/***/ }),

/***/ 559:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function clickIcon() {
	this.$emit('click-icon');
}

function isListAll() {
	return this.icon === 'list_all' ? 'height:24px;width:24px' : '';
}

function buttonColor() {
	return this.isEditAction ? '#3B82C4' : this.color;
}

function isEditAction() {
	return ['edit', 'create'].includes(this.icon);
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-tooltip-button',
	computed: {
		buttonColor: buttonColor,
		isEditAction: isEditAction,
		isListAll: isListAll
	},
	props: {
		disabled: {
			type: Boolean,
			default: false
		},
		color: {
			type: String,
			default: 'green'
		},
		icon: {
			type: String,
			required: true
		},
		text: {
			type: String,
			required: true
		}
	},
	methods: {
		clickIcon: clickIcon
	}
});

/***/ }),

/***/ 560:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_tooltip_button_vue__ = __webpack_require__(559);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01775c3c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_tooltip_button_vue__ = __webpack_require__(564);
function injectStyle (ssrContext) {
  __webpack_require__(562)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-01775c3c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_tooltip_button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01775c3c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_tooltip_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 561:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "alpha", {
  enumerable: true,
  get: function get() {
    return _alpha.default;
  }
});
Object.defineProperty(exports, "alphaNum", {
  enumerable: true,
  get: function get() {
    return _alphaNum.default;
  }
});
Object.defineProperty(exports, "numeric", {
  enumerable: true,
  get: function get() {
    return _numeric.default;
  }
});
Object.defineProperty(exports, "between", {
  enumerable: true,
  get: function get() {
    return _between.default;
  }
});
Object.defineProperty(exports, "email", {
  enumerable: true,
  get: function get() {
    return _email.default;
  }
});
Object.defineProperty(exports, "ipAddress", {
  enumerable: true,
  get: function get() {
    return _ipAddress.default;
  }
});
Object.defineProperty(exports, "macAddress", {
  enumerable: true,
  get: function get() {
    return _macAddress.default;
  }
});
Object.defineProperty(exports, "maxLength", {
  enumerable: true,
  get: function get() {
    return _maxLength.default;
  }
});
Object.defineProperty(exports, "minLength", {
  enumerable: true,
  get: function get() {
    return _minLength.default;
  }
});
Object.defineProperty(exports, "required", {
  enumerable: true,
  get: function get() {
    return _required.default;
  }
});
Object.defineProperty(exports, "requiredIf", {
  enumerable: true,
  get: function get() {
    return _requiredIf.default;
  }
});
Object.defineProperty(exports, "requiredUnless", {
  enumerable: true,
  get: function get() {
    return _requiredUnless.default;
  }
});
Object.defineProperty(exports, "sameAs", {
  enumerable: true,
  get: function get() {
    return _sameAs.default;
  }
});
Object.defineProperty(exports, "url", {
  enumerable: true,
  get: function get() {
    return _url.default;
  }
});
Object.defineProperty(exports, "or", {
  enumerable: true,
  get: function get() {
    return _or.default;
  }
});
Object.defineProperty(exports, "and", {
  enumerable: true,
  get: function get() {
    return _and.default;
  }
});
Object.defineProperty(exports, "not", {
  enumerable: true,
  get: function get() {
    return _not.default;
  }
});
Object.defineProperty(exports, "minValue", {
  enumerable: true,
  get: function get() {
    return _minValue.default;
  }
});
Object.defineProperty(exports, "maxValue", {
  enumerable: true,
  get: function get() {
    return _maxValue.default;
  }
});
Object.defineProperty(exports, "integer", {
  enumerable: true,
  get: function get() {
    return _integer.default;
  }
});
Object.defineProperty(exports, "decimal", {
  enumerable: true,
  get: function get() {
    return _decimal.default;
  }
});
exports.helpers = void 0;

var _alpha = _interopRequireDefault(__webpack_require__(565));

var _alphaNum = _interopRequireDefault(__webpack_require__(568));

var _numeric = _interopRequireDefault(__webpack_require__(569));

var _between = _interopRequireDefault(__webpack_require__(570));

var _email = _interopRequireDefault(__webpack_require__(571));

var _ipAddress = _interopRequireDefault(__webpack_require__(572));

var _macAddress = _interopRequireDefault(__webpack_require__(573));

var _maxLength = _interopRequireDefault(__webpack_require__(574));

var _minLength = _interopRequireDefault(__webpack_require__(575));

var _required = _interopRequireDefault(__webpack_require__(576));

var _requiredIf = _interopRequireDefault(__webpack_require__(577));

var _requiredUnless = _interopRequireDefault(__webpack_require__(578));

var _sameAs = _interopRequireDefault(__webpack_require__(579));

var _url = _interopRequireDefault(__webpack_require__(580));

var _or = _interopRequireDefault(__webpack_require__(581));

var _and = _interopRequireDefault(__webpack_require__(582));

var _not = _interopRequireDefault(__webpack_require__(583));

var _minValue = _interopRequireDefault(__webpack_require__(584));

var _maxValue = _interopRequireDefault(__webpack_require__(585));

var _integer = _interopRequireDefault(__webpack_require__(586));

var _decimal = _interopRequireDefault(__webpack_require__(587));

var helpers = _interopRequireWildcard(__webpack_require__(558));

exports.helpers = helpers;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 562:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(563);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(516)("673c19a2", content, true, {});

/***/ }),

/***/ 563:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(515)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.action-icon-button[data-v-01775c3c]{background:#f2f6f9!important;border:1px solid transparent;border-radius:7px;height:28px;min-width:28px;-webkit-transition:background .16s ease,border-color .16s ease,-webkit-transform .16s ease;transition:background .16s ease,border-color .16s ease,-webkit-transform .16s ease;transition:background .16s ease,border-color .16s ease,transform .16s ease;transition:background .16s ease,border-color .16s ease,transform .16s ease,-webkit-transform .16s ease;width:28px}.action-icon-button .icon[data-v-01775c3c]{font-size:17px}.action-icon-button[data-v-01775c3c]:hover{background:#eaf3ef!important;border-color:#c8ddd5;-webkit-transform:translateY(-1px);transform:translateY(-1px)}.action-icon-button.is-edit-action[data-v-01775c3c]:hover{background:#eaf3fa!important;border-color:#bed8ea}", "", {"version":3,"sources":["/opt/build/repo/src/components/shared/app-tooltip-button.vue"],"names":[],"mappings":"AACA,WAAW,yBAA2B,0CAA0C,gBAAmB,iBAAiB,CACnH,AACD,WAAW,sBAAwB,uCAAuC,gBAAmB,iBAAiB,CAC7G,AACD,WAAW,uBAAyB,wCAAwC,gBAAmB,iBAAiB,CAC/G,AACD,WAAW,0BAA4B,8CAA8C,gBAAmB,iBAAiB,CACxH,AACD,WAAW,uBAAyB,2CAA2C,gBAAmB,iBAAiB,CAClH,AACD,WAAW,2BAA6B,+CAA+C,gBAAmB,iBAAiB,CAC1H,AACD,WAAW,wBAA0B,4CAA4C,gBAAmB,iBAAiB,CACpH,AACD,qCAAqC,6BAA8B,6BAA+B,kBAAkB,YAAY,eAAe,2FAA2F,mFAAmF,2EAA2E,uGAAuG,UAAU,CACxf,AACD,2CAA2C,cAAc,CACxD,AACD,2CAA2C,6BAA8B,qBAAqB,mCAAmC,0BAA0B,CAC1J,AACD,0DAA0D,6BAA8B,oBAAoB,CAC3G","file":"app-tooltip-button.vue","sourcesContent":["\n@font-face{font-family:\"Lato_regular\";src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_bold\";src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_light\";src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_regular\";src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_bold\";src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_semibold\";src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_light\";src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:normal;font-style:normal\n}\n.action-icon-button[data-v-01775c3c]{background:#f2f6f9 !important;border:1px solid rgba(0,0,0,0);border-radius:7px;height:28px;min-width:28px;-webkit-transition:background .16s ease,border-color .16s ease,-webkit-transform .16s ease;transition:background .16s ease,border-color .16s ease,-webkit-transform .16s ease;transition:background .16s ease,border-color .16s ease,transform .16s ease;transition:background .16s ease,border-color .16s ease,transform .16s ease,-webkit-transform .16s ease;width:28px\n}\n.action-icon-button .icon[data-v-01775c3c]{font-size:17px\n}\n.action-icon-button[data-v-01775c3c]:hover{background:#eaf3ef !important;border-color:#c8ddd5;-webkit-transform:translateY(-1px);transform:translateY(-1px)\n}\n.action-icon-button.is-edit-action[data-v-01775c3c]:hover{background:#eaf3fa !important;border-color:#bed8ea\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 564:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"action-icon-button ma-0",class:{ 'is-edit-action': _vm.isEditAction },attrs:{"slot":"activator","flat":"","icon":"","aria-label":_vm.text,"small":"","color":_vm.buttonColor,"disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();return _vm.clickIcon.apply(null, arguments)}},slot:"activator"},[_c('v-icon',{style:(_vm.isListAll)},[_vm._v(_vm._s(_vm.icon))])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 565:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = (0, _common.regex)('alpha', /^[a-zA-Z]*$/);

exports.default = _default;

/***/ }),

/***/ 566:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var withParams = Object({"NODE_ENV":"production","APP_CODE":'ACL001',"APP_NAME":'"ACL"',"QUIPU_URL":'https://ec-motor.makipos.la',"MOCK_URL":'https://jsonplaceholder.typicode.com',"ACL_URL":'https://ec-acl.makipos.la/api',"SALES_URL":'https://ec-sales.makipos.la',"STORAGE_USER_KEY":"acl","S3_IMAGES_URL":'//s3.amazonaws.com/apprunn-acl',"COMPANY_LOGIN_TITLE":'ACL',"COMPANY_LOGIN_BACKGROUND":'https://maki-acl.s3.amazonaws.com/ACL/fenix.png',"ACCEPT_SERVICE_V2":'application/vnd.apiacl.v2+json'}).BUILD === 'web' ? __webpack_require__(567).withParams : __webpack_require__(165).withParams;
var _default = withParams;
exports.default = _default;

/***/ }),

/***/ 567:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withParams = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var root = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};

var fakeWithParams = function fakeWithParams(paramsOrClosure, maybeValidator) {
  if (_typeof(paramsOrClosure) === 'object' && maybeValidator !== undefined) {
    return maybeValidator;
  }

  return paramsOrClosure(function () {});
};

var withParams = root.vuelidate ? root.vuelidate.withParams : fakeWithParams;
exports.withParams = withParams;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(54)))

/***/ }),

/***/ 568:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = (0, _common.regex)('alphaNum', /^[a-zA-Z0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 569:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = (0, _common.regex)('numeric', /^[0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 570:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = function _default(min, max) {
  return (0, _common.withParams)({
    type: 'between',
    min: min,
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +min <= +value && +max >= +value;
  });
};

exports.default = _default;

/***/ }),

/***/ 571:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var emailRegex = /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/;

var _default = (0, _common.regex)('email', emailRegex);

exports.default = _default;

/***/ }),

/***/ 572:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = (0, _common.withParams)({
  type: 'ipAddress'
}, function (value) {
  if (!(0, _common.req)(value)) {
    return true;
  }

  if (typeof value !== 'string') {
    return false;
  }

  var nibbles = value.split('.');
  return nibbles.length === 4 && nibbles.every(nibbleValid);
});

exports.default = _default;

var nibbleValid = function nibbleValid(nibble) {
  if (nibble.length > 3 || nibble.length === 0) {
    return false;
  }

  if (nibble[0] === '0' && nibble !== '0') {
    return false;
  }

  if (!nibble.match(/^\d+$/)) {
    return false;
  }

  var numeric = +nibble | 0;
  return numeric >= 0 && numeric <= 255;
};

/***/ }),

/***/ 573:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = function _default() {
  var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ':';
  return (0, _common.withParams)({
    type: 'macAddress'
  }, function (value) {
    if (!(0, _common.req)(value)) {
      return true;
    }

    if (typeof value !== 'string') {
      return false;
    }

    var parts = typeof separator === 'string' && separator !== '' ? value.split(separator) : value.length === 12 || value.length === 16 ? value.match(/.{2}/g) : null;
    return parts !== null && (parts.length === 6 || parts.length === 8) && parts.every(hexValid);
  });
};

exports.default = _default;

var hexValid = function hexValid(hex) {
  return hex.toLowerCase().match(/^[0-9a-f]{2}$/);
};

/***/ }),

/***/ 574:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'maxLength',
    max: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) <= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 575:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'minLength',
    min: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) >= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 576:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = (0, _common.withParams)({
  type: 'required'
}, _common.req);

exports.default = _default;

/***/ }),

/***/ 577:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredIf',
    prop: prop
  }, function (value, parentVm) {
    return (0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 578:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredUnless',
    prop: prop
  }, function (value, parentVm) {
    return !(0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 579:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = function _default(equalTo) {
  return (0, _common.withParams)({
    type: 'sameAs',
    eq: equalTo
  }, function (value, parentVm) {
    return value === (0, _common.ref)(equalTo, this, parentVm);
  });
};

exports.default = _default;

/***/ }),

/***/ 580:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var urlRegex = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;

var _default = (0, _common.regex)('url', urlRegex);

exports.default = _default;

/***/ }),

/***/ 581:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'or'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid || fn.apply(_this, args);
    }, false);
  });
};

exports.default = _default;

/***/ }),

/***/ 582:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'and'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid && fn.apply(_this, args);
    }, true);
  });
};

exports.default = _default;

/***/ }),

/***/ 583:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = function _default(validator) {
  return (0, _common.withParams)({
    type: 'not'
  }, function (value, vm) {
    return !(0, _common.req)(value) || !validator.call(this, value, vm);
  });
};

exports.default = _default;

/***/ }),

/***/ 584:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = function _default(min) {
  return (0, _common.withParams)({
    type: 'minValue',
    min: min
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value >= +min;
  });
};

exports.default = _default;

/***/ }),

/***/ 585:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = function _default(max) {
  return (0, _common.withParams)({
    type: 'maxValue',
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value <= +max;
  });
};

exports.default = _default;

/***/ }),

/***/ 586:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = (0, _common.regex)('integer', /^-?[0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 587:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = (0, _common.regex)('decimal', /^[-]?\d*(\.\d+)?$/);

exports.default = _default;

/***/ }),

/***/ 594:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(167);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),

/***/ 595:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_six_four__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_six_four___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_six_four__);



var getFile = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(fileInfo) {
		var _this = this;

		var newFile, words, lastItem, extension, _ref2, response, newImage;

		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						this.isLoadingImage = true;
						newFile = {
							name: fileInfo.name.replace(/\s/g, '-'),
							type: fileInfo.type,
							image: fileInfo.sixFour
						};
						_context.prev = 2;
						words = newFile.name.split('.');
						lastItem = words.length;
						extension = words[lastItem - 1];

						if (!(this.allowedFiles.indexOf(extension) > -1)) {
							_context.next = 14;
							break;
						}

						_context.next = 9;
						return this.$http.post('image/one-upload', newFile);

					case 9:
						_ref2 = _context.sent;
						response = _ref2.data;

						if (extension === 'pdf') {
							this.$emit('send-file', { file: response.data.url_image });
							this.isLoadingImage = false;
						} else {
							newImage = new Image();

							newImage.onload = function () {
								if (newImage.naturalWidth <= _this.allowedMaxSize) {
									var model = {
										urlImage: response.data.url_image
									};
									if (_this.itemUpdate) {
										model.item = _this.itemUpdate;
									}
									_this.$emit('send-image', model);
									_this.isLoadingImage = false;
								} else {
									_this.showNotification('El tama\xF1o m\xE1ximo permitido es ' + _this.allowedMaxSize + ' x ' + _this.allowedMaxSize, 'warning');
									_this.isLoadingImage = false;
								}
							};
							newImage.src = response.data.url_image;
						}
						_context.next = 15;
						break;

					case 14:
						this.showNotification('Archivo no v\xE1lido, solo se permite ' + this.allowedFiles.join(','), 'warning');

					case 15:
						_context.next = 20;
						break;

					case 17:
						_context.prev = 17;
						_context.t0 = _context['catch'](2);

						this.showError();

					case 20:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[2, 17]]);
	}));

	return function getFile(_x) {
		return _ref.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function actionUploadImage() {
	this.$refs[this.labelRef].click();
}

function data() {
	return {
		allowedFiles: ['jpg', 'jpeg', 'png', 'svg', 'pdf'],
		allowedMaxSize: 25,
		isLoadingImage: false,
		newImage: ''
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'upload-image',
	components: {
		VueSixFour: __WEBPACK_IMPORTED_MODULE_2_vue_six_four___default.a
	},
	data: data,
	methods: {
		actionUploadImage: actionUploadImage,
		getFile: getFile
	},
	props: {
		buttonTitle: {
			default: 'Cambiar de icono',
			type: String
		},
		inputId: {
			type: [Number, String]
		},
		itemUpdate: {
			type: Object,
			default: function _default() {}
		},
		labelFor: {
			type: [Number, String]
		},
		labelRef: {
			type: [Number, String]
		}
	}
});

/***/ }),

/***/ 602:
/***/ (function(module, exports, __webpack_require__) {

module.exports=function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="/",t(t.s=0)}([function(e,t,n){e.exports=n(1)},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=n(3),o=n(5),i=n(2),l=i(r.a,o.a,!1,null,null,null);t.default=l.exports},function(e,t){e.exports=function(e,t,n,r,o,i){var l,u=e=e||{},s=typeof e.default;"object"!==s&&"function"!==s||(l=e,u=e.default);var a="function"==typeof u?u.options:u;t&&(a.render=t.render,a.staticRenderFns=t.staticRenderFns,a._compiled=!0),n&&(a.functional=!0),o&&(a._scopeId=o);var c;if(i?(c=function(e){e=e||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext,e||"undefined"==typeof __VUE_SSR_CONTEXT__||(e=__VUE_SSR_CONTEXT__),r&&r.call(this,e),e&&e._registeredComponents&&e._registeredComponents.add(i)},a._ssrRegister=c):r&&(c=r),c){var f=a.functional,p=f?a.render:a.beforeCreate;f?(a._injectStyles=c,a.render=function(e,t){return c.call(t),p(e,t)}):a.beforeCreate=p?[].concat(p,c):[c]}return{esModule:l,exports:u,options:a}}},function(e,t,n){"use strict";function r(){return{multipleFiles:[]}}function o(e){for(var t=this,n=e.target.files,r=n.length,o=0;o<r;o+=1)(function(e){var o=n[e],i=new FileReader;i.readAsDataURL(o),i.addEventListener("load",function(){var e=l()(o,{sixFour:i.result});t.multipleFiles.push(e),r===t.multipleFiles.length&&(t.$emit("vue-six-four",t.allowMultiple?t.multipleFiles:t.multipleFiles[0]),t.multipleFiles=[]),i=null})})(o)}var i=n(4),l=n.n(i);t.a={data:r,name:"vue-six-four",methods:{readFile:o},props:{allowMultiple:{type:Boolean,default:!1}}}},function(e,t){e.exports=__webpack_require__(56)},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement;return(e._self._c||t)("input",{attrs:{type:"file",multiple:e.allowMultiple},on:{change:e.readFile}})},o=[],i={render:r,staticRenderFns:o};t.a=i}]);

/***/ }),

/***/ 603:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(604);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(169);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),

/***/ 604:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(605), __esModule: true };

/***/ }),

/***/ 605:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(58);
__webpack_require__(37);
module.exports = __webpack_require__(606);


/***/ }),

/***/ 606:
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(89);
var ITERATOR = __webpack_require__(9)('iterator');
var Iterators = __webpack_require__(28);
module.exports = __webpack_require__(5).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),

/***/ 607:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_upload_image_vue__ = __webpack_require__(595);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3bdc05e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_upload_image_vue__ = __webpack_require__(608);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_upload_image_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3bdc05e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_upload_image_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 608:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{ref:_vm.labelRef,attrs:{"for":_vm.labelFor}},[_c('vue-six-four',{attrs:{"id":_vm.inputId,"hidden":""},on:{"vue-six-four":_vm.getFile}}),_vm._v(" "),_c('v-btn',{staticClass:"btn-action caption",attrs:{"color":"primary"},on:{"click":_vm.actionUploadImage}},[_vm._v("\n\t\t\t"+_vm._s(_vm.buttonTitle)+"\n\t\t")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 622:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);



/* eslint-disable max-len */
var compose = function compose() {
	for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
		fns[_key] = arguments[_key];
	}

	return function () {
		for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
			args[_key2] = arguments[_key2];
		}

		return fns.reduceRight(function (res, fn) {
			return [fn.call.apply(fn, [null].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(res)))];
		}, args)[0];
	};
};

/* eslint-disable prefer-const */
function equality() {
	for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
		args[_key3] = arguments[_key3];
	}

	var prop1 = args[0],
	    prop2 = args[1];

	if (!prop2) {
		prop2 = prop1;
	}
	return function inner(item) {
		return item[prop1] === prop2;
	};
}

function find(fn, col) {
	return col.find(fn);
}

function matchBetweenArrays(collection1, collection2) {
	var _collection = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(collection1, 2),
	    arr1 = _collection[0],
	    prop1 = _collection[1];

	var _collection2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(collection2, 2),
	    arr2 = _collection2[0],
	    prop2 = _collection2[1];

	var list = [];
	if (prop2) {
		arr1.forEach(function (a) {
			var val = prop1 ? a[prop1] : a;
			var match = find(equality(prop2, val), arr2);
			list = list.concat(match);
		});
	}
	if (arr1.every(function (a) {
		return typeof a === 'string' || typeof a === 'number';
	}) && arr2.every(function (a) {
		return typeof a === 'string' || typeof a === 'number';
	})) {
		arr1.forEach(function (a) {
			var match = arr2.find(function (b) {
				return a === b;
			});
			list = match ? list.concat(match) : list;
		});
	}
	return list;
}

function getDeeper() {
	for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
		args[_key4] = arguments[_key4];
	}

	return function inner(item) {
		var newItem = null;
		if (item.length) {
			var _item = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(item, 1);

			newItem = _item[0];
		} else {
			newItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item);
		}
		args.forEach(function (el) {
			newItem = (newItem || {})[el];
		});
		return newItem;
	};
}

function setNewProperty(property, value) {
	return function p(obj) {
		var newObj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, obj);
		newObj[property] = value;
		return newObj;
	};
}

function updateItemInCollection(matchProp, ele, collection) {
	return collection.reduce(function (list, item) {
		if (ele[matchProp] === item[matchProp]) {
			return list.concat(ele);
		}
		return list.concat(item);
	}, []);
}

function getPropertysValue(prop) {
	return function inner(obj) {
		return (obj || {})[prop];
	};
}

function createPropertyByOtherOne() {
	for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
		args[_key5] = arguments[_key5];
	}

	var prop1 = args[0],
	    prop2 = args[1];

	return function inner(item) {
		var newItem = null;
		if (item.length) {
			var _item2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(item, 1);

			newItem = _item2[0];
		} else {
			newItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item);
		}
		newItem[prop1] = getPropertysValue(prop2)(newItem);
		return newItem;
	};
}

function filter(fn, collection) {
	return collection.filter(fn);
}

function setNewPropertyByFunction(prop, fn) {
	var flag = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

	return function inner(item, index) {
		if (index === null || index === undefined) {
			if (item.length) {
				var _item3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(item, 2),
				    newItem = _item3[0],
				    newIndex = _item3[1];

				return [setNewProperty(prop, fn(newItem, newIndex))(newItem), newIndex];
			}
			return setNewProperty(prop, fn(item, index))(item);
		}
		if (flag) {
			return [setNewProperty(prop, fn(item, index))(item), index];
		}
		return setNewProperty(prop, fn(item, index))(item);
	};
}

function removeItemFromArray(prop, propValue) {
	return function inner(arr) {
		var newArr = arr || [];
		return newArr.reduce(function (list, item) {
			var newList = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(list));
			if (propValue === item[prop]) {
				return newList;
			}
			return newList.concat(item);
		}, []);
	};
}

function removeItemFromArrayByIndex(index, arr) {
	return arr.reduce(function (list, item, ind) {
		var newList = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(list));
		if (index === ind) {
			return newList;
		}
		return newList.concat(item);
	}, []);
}

/* harmony default export */ __webpack_exports__["a"] = ({
	compose: compose,
	createPropertyByOtherOne: createPropertyByOtherOne,
	equality: equality,
	filter: filter,
	find: find,
	getDeeper: getDeeper,
	getPropertysValue: getPropertysValue,
	matchBetweenArrays: matchBetweenArrays,
	removeItemFromArray: removeItemFromArray,
	removeItemFromArrayByIndex: removeItemFromArrayByIndex,
	setNewProperty: setNewProperty,
	setNewPropertyByFunction: setNewPropertyByFunction,
	updateItemInCollection: updateItemInCollection
});

/***/ }),

/***/ 623:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(624);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),

/***/ 624:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(625), __esModule: true };

/***/ }),

/***/ 625:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(626);
var $Object = __webpack_require__(5).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),

/***/ 626:
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(14);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(18), 'Object', { defineProperty: __webpack_require__(16).f });


/***/ }),

/***/ 827:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_finite__ = __webpack_require__(1010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_max_safe_integer__ = __webpack_require__(1013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_max_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_max_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_shared_app_button__ = __webpack_require__(1016);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_shared_app_tooltip_button__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_shared_action_sidebar__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_resources_resource_configuration__ = __webpack_require__(1020);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_roles_new_rol_component__ = __webpack_require__(1024);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_actions_actions_bar__ = __webpack_require__(1026);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_resource_service_resource_web_service__ = __webpack_require__(1030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lib__ = __webpack_require__(622);










var loadResources = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee(flag) {
		var _this = this;

		var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		var headers, url, _ref2, response;

		return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						headers = {
							Accept: '' + 'application/vnd.apiacl.v2+json'
						};
						url = '/project/' + this.codeProject + '/template/' + this.idTemplate + '/' + flag;
						_context.next = 4;
						return this.$http.get(url, { headers: headers, params: this.params });

					case 4:
						_ref2 = _context.sent;
						response = _ref2.data;
						this[flag] = response.data;

						if (flag === 'modules') {
							this.syncCurrentAppConfiguration(this.modules.some(assignmentEnabled));
						} else if (flag === 'resources') {
							this.updateResources();
							if (this.resources.some(function (resource) {
								return resource.isSelected;
							})) {
								this.syncCurrentAppConfiguration(true);
							}
						} else if (flag === 'actions') {
							if (this.temporalSelected.length > 0 && this.model.roleIds) {
								this.actions = this.actions.map(function (a) {
									var newRow = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, a);
									var newFlag = _this.model.roleIds[0].resources.filter(function (r) {
										return r.id === action.id;
									});
									var flagIndex = newFlag.length && newFlag[0].actions ? newFlag[0].actions.findIndex(function (f) {
										return f === a.id;
									}) : -1;
									newRow.isSelected = flagIndex > -1 || a.isSelected;
									return newRow;
								});
							}
							this.dataSelected = this.actions.filter(function (a) {
								return a.isSelected;
							});
						}

					case 8:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function loadResources(_x) {
		return _ref.apply(this, arguments);
	};
}();

var loadLanguages = function () {
	var _ref3 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee2() {
		var headers, _ref4, project, projectLanguages, self;

		return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						headers = {
							Accept: '' + 'application/vnd.apiacl.v2+json'
						};
						_context2.prev = 1;
						_context2.next = 4;
						return this.$http.get('projects/' + this.codeProject, { headers: headers });

					case 4:
						_ref4 = _context2.sent;
						project = _ref4.data;
						projectLanguages = project.data.languages;
						self = this;

						__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(projectLanguages).forEach(function (pLangKey) {
							var currentLanguage = projectLanguages[pLangKey];
							self.languages = self.languages.concat(currentLanguage);
						});
						_context2.next = 14;
						break;

					case 11:
						_context2.prev = 11;
						_context2.t0 = _context2['catch'](1);

						this.showError();

					case 14:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this, [[1, 11]]);
	}));

	return function loadLanguages() {
		return _ref3.apply(this, arguments);
	};
}();

var saveInfo = function () {
	var _ref9 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee3(body, flagDelete, vueArray) {
		var _this8 = this;

		var newBody, hasPayload, url, headers;
		return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						newBody = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, body);
						hasPayload = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(newBody).some(function (key) {
							var value = newBody[key];
							return Array.isArray(value) ? value.length > 0 : value !== null && value !== undefined;
						});

						if (hasPayload) {
							_context3.next = 4;
							break;
						}

						return _context3.abrupt('return', false);

					case 4:
						if (newBody.resourceIds) {
							newBody.resourceIds = body.resourceIds.map(function (resource) {
								var newResource = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, resource);
								var keys = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(resource.languages);
								newResource.languages = keys.reduce(function (acum, k) {
									var newAcum = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, acum);
									var newKey = k.toLowerCase();
									newAcum[newKey] = resource.languages[k];
									return newAcum;
								}, {});
								return newResource;
							});
						}
						if (newBody.roleIds) {
							newBody.roleIds = newBody.roleIds.map(function (roleId) {
								var newRoleId = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, roleId);
								newRoleId.typeRoleId = _this8.rolSelected.typeRoleId;
								return newRoleId;
							});
						}
						url = 'distribution-template/' + this.idTemplate;
						headers = {
							Accept: '' + 'application/vnd.apiacl.v2+json'
						};
						_context3.prev = 8;
						_context3.next = 11;
						return this.$http.patch(url, newBody, { headers: headers });

					case 11:
						this.showNotification('Actualización exitosa');

						if (!vueArray) {
							_context3.next = 15;
							break;
						}

						_context3.next = 15;
						return this.loadResources(vueArray);

					case 15:
						_context3.next = 21;
						break;

					case 17:
						_context3.prev = 17;
						_context3.t0 = _context3['catch'](8);

						this.showError('Los cambios no se guardaron', 'info');
						return _context3.abrupt('return', false);

					case 21:
						if (!flagDelete) {
							this.resources.forEach(function (resource) {
								var key = _this8.resourceSelectionKey(resource);
								_this8.$set(_this8.resourceSelectionBaseline, key, Boolean(resource.isSelected));
							});
							this.resourceSelectionUndo = {};
							this.model = {};
						}
						return _context3.abrupt('return', true);

					case 23:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this, [[8, 17]]);
	}));

	return function saveInfo(_x6, _x7, _x8) {
		return _ref9.apply(this, arguments);
	};
}();

var finishConfiguration = function () {
	var _ref10 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee4() {
		var saved, headers, _ref11, response, template;

		return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
			while (1) {
				switch (_context4.prev = _context4.next) {
					case 0:
						this.finalizing = true;
						_context4.prev = 1;

						if (!this.modelEmpty) {
							_context4.next = 6;
							break;
						}

						_context4.t0 = true;
						_context4.next = 9;
						break;

					case 6:
						_context4.next = 8;
						return this.saveInfo(this.model);

					case 8:
						_context4.t0 = _context4.sent;

					case 9:
						saved = _context4.t0;

						if (saved) {
							_context4.next = 12;
							break;
						}

						return _context4.abrupt('return');

					case 12:
						if (this.templateCode) {
							_context4.next = 20;
							break;
						}

						headers = { Accept: '' + 'application/vnd.apiacl.v2+json' };
						_context4.next = 16;
						return this.$http.get('template/' + this.idTemplate, { headers: headers });

					case 16:
						_ref11 = _context4.sent;
						response = _ref11.data;
						template = response.data || response;

						this.templateCode = template.codeTemplate;

					case 20:
						if (this.templateCode) {
							_context4.next = 23;
							break;
						}

						this.showError('No se pudo identificar el código del template', 'info');
						return _context4.abrupt('return');

					case 23:
						this.distributionQuestion = true;
						_context4.next = 29;
						break;

					case 26:
						_context4.prev = 26;
						_context4.t1 = _context4['catch'](1);

						this.showError('No se pudo preparar la distribución', 'info');

					case 29:
						_context4.prev = 29;

						this.finalizing = false;
						return _context4.finish(29);

					case 32:
					case 'end':
						return _context4.stop();
				}
			}
		}, _callee4, this, [[1, 26, 29, 32]]);
	}));

	return function finishConfiguration() {
		return _ref10.apply(this, arguments);
	};
}();

var saveAssignmentChanges = function () {
	var _ref12 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee5() {
		var hadChanges, saved;
		return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
			while (1) {
				switch (_context5.prev = _context5.next) {
					case 0:
						this.distributionQuestion = false;
						this.prepareCurrentResourcesForSave();

						if (!this.modelEmpty) {
							_context5.next = 4;
							break;
						}

						return _context5.abrupt('return', false);

					case 4:
						hadChanges = !this.modelEmpty;
						_context5.next = 7;
						return this.saveInfo(this.model);

					case 7:
						saved = _context5.sent;

						if (!(saved && hadChanges)) {
							_context5.next = 18;
							break;
						}

						this.hasSavedConfigurationChanges = true;

						if (!this.hasSelectedModule) {
							_context5.next = 15;
							break;
						}

						_context5.next = 13;
						return this.loadResources('resources', this.module);

					case 13:
						_context5.next = 18;
						break;

					case 15:
						if (!this.hasSelectedApplication) {
							_context5.next = 18;
							break;
						}

						_context5.next = 18;
						return this.loadResources('modules', this.app);

					case 18:
						return _context5.abrupt('return', saved);

					case 19:
					case 'end':
						return _context5.stop();
				}
			}
		}, _callee5, this);
	}));

	return function saveAssignmentChanges() {
		return _ref12.apply(this, arguments);
	};
}();

var deleteApplicationConfiguration = function () {
	var _ref14 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee6(item) {
		var headers, params, url, _ref15, response, hasActiveModules;

		return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
			while (1) {
				switch (_context6.prev = _context6.next) {
					case 0:
						headers = { Accept: '' + 'application/vnd.apiacl.v2+json' };
						params = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, this.params, {
							codeApp: item.codeApp || item.code,
							idModule: null
						});
						_context6.prev = 2;
						url = '/project/' + this.codeProject + '/template/' + this.idTemplate + '/modules';
						_context6.next = 6;
						return this.$http.get(url, { headers: headers, params: params });

					case 6:
						_ref15 = _context6.sent;
						response = _ref15.data;
						hasActiveModules = (response.data || []).some(assignmentEnabled);

						if (!hasActiveModules) {
							_context6.next = 12;
							break;
						}

						this.showError('Primero elimina los módulos activos de esta aplicación', 'info');
						return _context6.abrupt('return');

					case 12:
						_context6.next = 14;
						return this.deleteConfiguration('appIds', item);

					case 14:
						_context6.next = 19;
						break;

					case 16:
						_context6.prev = 16;
						_context6.t0 = _context6['catch'](2);

						this.showError('No se pudo comprobar la configuración de la aplicación', 'info');

					case 19:
					case 'end':
						return _context6.stop();
				}
			}
		}, _callee6, this, [[2, 16]]);
	}));

	return function deleteApplicationConfiguration(_x9) {
		return _ref14.apply(this, arguments);
	};
}();

var deleteConfiguration = function () {
	var _ref16 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee7(flag, item) {
		var opt, body, vueArray;
		return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
			while (1) {
				switch (_context7.prev = _context7.next) {
					case 0:
						if (!(flag === 'moduleIds')) {
							_context7.next = 4;
							break;
						}

						_context7.next = 3;
						return this.deleteModuleOnly(item);

					case 3:
						return _context7.abrupt('return');

					case 4:
						opt = {
							appIds: [compose(setNewProperty('flagStatus', true), setNewProperty('flagActions', false), setNewProperty('isSelected', false), setNewProperty('flagDelete', true)), 'apps']
						};
						body = {};

						body[flag] = [opt[flag][0].call(null, item)];
						vueArray = opt[flag][1];
						_context7.next = 10;
						return this.saveInfo(body, 'delete', vueArray);

					case 10:
					case 'end':
						return _context7.stop();
				}
			}
		}, _callee7, this);
	}));

	return function deleteConfiguration(_x10, _x11) {
		return _ref16.apply(this, arguments);
	};
}();

var deleteModuleOnly = function () {
	var _ref17 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee8(item) {
		var moduleToDelete;
		return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
			while (1) {
				switch (_context8.prev = _context8.next) {
					case 0:
						moduleToDelete = this.deleteModuleConfiguration(item);
						_context8.next = 3;
						return this.saveInfo({ moduleIds: [moduleToDelete] }, 'delete', 'modules');

					case 3:
					case 'end':
						return _context8.stop();
				}
			}
		}, _callee8, this);
	}));

	return function deleteModuleOnly(_x12) {
		return _ref17.apply(this, arguments);
	};
}();

var loadServices = function () {
	var _ref18 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee9(row) {
		var _this13 = this;

		var headers, params, url, _ref19, response, exitServices;

		return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
			while (1) {
				switch (_context9.prev = _context9.next) {
					case 0:
						this.openModuleAndResourceConfiguration('list-service', row);
						_context9.prev = 1;
						headers = {
							Accept: '' + 'application/vnd.apiacl.v2+json'
						};
						params = {
							codeApp: this.app.codeApp,
							codeRole: this.rolSelected.code,
							idModule: row.moduleId,
							idResource: row.id
						};
						url = '/project/' + this.codeProject + '/template/' + this.idTemplate + '/web-services';
						_context9.next = 7;
						return this.$http.get(url, { headers: headers, params: params });

					case 7:
						_ref19 = _context9.sent;
						response = _ref19.data;

						if (this.resource.permission) {
							exitServices = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.resource.permission);

							this.webServices = response.data.map(function (d) {
								var newService = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, d);
								var index = exitServices.findIndex(function (s) {
									return Number(s) === d.id;
								});
								newService.isSelected = index > -1;
								newService.authorize = index > -1 ? _this13.resource.permission[d.id] : d.authorize;
								return newService;
							});
						} else {
							this.webServices = response.data;
						}
						this.action = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, this.actionListService);
						this.action.title = row.name;
						_context9.next = 17;
						break;

					case 14:
						_context9.prev = 14;
						_context9.t0 = _context9['catch'](1);

						this.showError();

					case 17:
					case 'end':
						return _context9.stop();
				}
			}
		}, _callee9, this, [[1, 14]]);
	}));

	return function loadServices(_x15) {
		return _ref18.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var compose = __WEBPACK_IMPORTED_MODULE_16__lib__["a" /* default */].compose,
    createPropertyByOtherOne = __WEBPACK_IMPORTED_MODULE_16__lib__["a" /* default */].createPropertyByOtherOne,
    equality = __WEBPACK_IMPORTED_MODULE_16__lib__["a" /* default */].equality,
    find = __WEBPACK_IMPORTED_MODULE_16__lib__["a" /* default */].find,
    getDeeper = __WEBPACK_IMPORTED_MODULE_16__lib__["a" /* default */].getDeeper,
    setNewProperty = __WEBPACK_IMPORTED_MODULE_16__lib__["a" /* default */].setNewProperty,
    setNewPropertyByFunction = __WEBPACK_IMPORTED_MODULE_16__lib__["a" /* default */].setNewPropertyByFunction,
    updateItemInCollection = __WEBPACK_IMPORTED_MODULE_16__lib__["a" /* default */].updateItemInCollection;


function created() {
	var _$route$params = this.$route.params;
	this.codeProject = _$route$params.codeProject;
	this.idTemplate = _$route$params.idTemplate;

	this.templateCode = this.$route.query.codeTemplate || null;
	this.loadResources('roles');
	this.loadLanguages();
}

function assignmentEnabled(item) {
	if (typeof item.hasConfiguredChildren === 'boolean') return item.hasConfiguredChildren;
	if (typeof item.isSelected === 'boolean') return item.isSelected;
	return Boolean(item.flagStatus || item.flagActions);
}

function evaluateTemplateLanguages(item) {
	var exist = getDeeper('templateLanguages')(item);
	return !exist;
}

function updateResources() {
	var _this2 = this;

	this.resources = this.resources.map(setNewProperty('disabled', false));
	this.normalizeResourcePositions(null, false);
	this.resources.forEach(function (resource) {
		var key = _this2.resourceSelectionKey(resource);
		_this2.$set(_this2.resourceSelectionBaseline, key, Boolean(resource.isSelected));
	});
}

function resourceSelectionKey(resource) {
	var selectionRole = this.rolSelected.code || this.params.codeRole || 'role';
	var moduleId = this.module.id || this.params.idModule || 'module';
	return selectionRole + ':' + moduleId + ':' + resource.id;
}

function clonePendingModel(model) {
	return JSON.parse(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(model || {}));
}

function resourcePosition(resource) {
	return Number(getDeeper('templateLanguages', 'position')(resource) || resource.position) || __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_max_safe_integer___default.a;
}

function normalizeResourcePositions() {
	var _this3 = this;

	var preferredResource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	var queueChanges = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

	var preferredId = preferredResource ? preferredResource.id : null;
	var requestedPosition = preferredResource ? Number(preferredResource.position) : null;
	var byPosition = function byPosition(first, second) {
		return _this3.resourcePosition(first) - _this3.resourcePosition(second);
	};
	var active = this.resources.filter(function (resource) {
		return resource.isSelected;
	}).sort(byPosition);
	var inactive = this.resources.filter(function (resource) {
		return !resource.isSelected;
	}).sort(byPosition);

	if (preferredId && requestedPosition) {
		var currentIndex = active.findIndex(function (resource) {
			return resource.id === preferredId;
		});
		if (currentIndex > -1) {
			var selected = active.splice(currentIndex, 1)[0];
			var destination = Math.max(0, Math.min(requestedPosition - 1, active.length));
			active.splice(destination, 0, selected);
		}
	}

	this.resources = active.concat(inactive).map(function (resource, index) {
		var updated = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, resource, { position: index + 1 });
		if (updated.templateLanguages) {
			updated.templateLanguages = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, updated.templateLanguages, { position: index + 1 });
			if (queueChanges && updated.isSelected) {
				_this3.queueResourcePosition(updated);
			}
		}
		return updated;
	});
}

function queueResourcePosition(resource) {
	var languages = this.resourceLanguages(resource);
	var configuredResource = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, resource, {
		flagStatus: true,
		flagActions: true,
		flagDelete: false,
		languages: languages
	});
	var currentResources = this.model.resourceIds || [];
	var index = currentResources.findIndex(function (item) {
		return item.id === resource.id;
	});
	if (index > -1) {
		this.model.resourceIds.splice(index, 1, configuredResource);
	} else {
		this.$set(this.model, 'resourceIds', currentResources.concat(configuredResource));
	}
}

function resourceLanguages(resource) {
	var configuredLanguages = getDeeper('templateLanguages', 'languages')(resource) || resource.languages;
	if (configuredLanguages && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(configuredLanguages).length) {
		return configuredLanguages;
	}
	return this.languages.reduce(function (result, language) {
		var key = String(language.id || '').toLowerCase();
		if (!key) return result;
		return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, result, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, key, __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, language, {
			name: resource.name || resource.title || '',
			isSelected: true
		})));
	}, {});
}

function prepareCurrentResourcesForSave() {
	var _this4 = this;

	if (!this.hasSelectedModule) return;
	this.resources.filter(function (resource) {
		return resource.isSelected;
	}).forEach(function (resource) {
		var languages = _this4.resourceLanguages(resource);
		var configuredResource = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, resource, {
			position: _this4.resourcePosition(resource),
			flagStatus: true,
			flagActions: true,
			flagDelete: false,
			languages: languages
		});
		_this4.queueConfigurationItem('resourceIds', configuredResource);
		_this4.updateRoleAndResources(configuredResource);
	});
}

function changeResourcePosition(resource, position) {
	this.normalizeResourcePositions(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, resource, { position: Number(position) }));
}

function getData(obj, vueVariable, flagParam, flag) {
	this.setDefaultValues(flagParam);
	this[vueVariable] = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, obj);
	this.updateIsActiveProperty(flagParam, obj);
	var moduleConfigured = assignmentEnabled(obj);
	if (flag === 'resources' && !moduleConfigured) {
		this.params[flagParam] = obj.id;
		this.module.position = this.nextModulePosition;
		this.openModuleAndResourceConfiguration('module', this.module, true);
		return;
	}
	this.params[flagParam] = flag === 'resources' ? obj.id : obj.code || obj[flagParam] || obj.id;
	this.loadResources(flag, obj);
}

function updateIsActiveProperty(flagParam, obj) {
	var opt = {
		codeApp: 'apps',
		idModule: 'modules'
	};
	var varSelected = opt[flagParam];
	if (varSelected) {
		this[varSelected] = this[varSelected].reduce(function (list, item) {
			var newItem = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, item);
			newItem.isActive = false;
			if (obj.id === item.id) {
				newItem.isActive = true;
			}
			return list.concat(newItem);
		}, []);
	}
}

function setDefaultValues(flag) {
	var opt = {
		codeRole: this.clearData,
		codeApp: this.clearIdModuleAnResources
	};
	if (opt[flag]) {
		opt[flag].call();
	}
}

function clearIdModuleAnResources() {
	this.actions = [];
	this.barActionSelected = {};
	this.module = {};
	this.modules = [];
	this.params.idModule = null;
	this.resource = null;
	this.resources = [];
}

function hasSelectedApplication() {
	return Boolean(this.app.id || this.app.codeApp || this.params.codeApp);
}

function hasSelectedModule() {
	return Boolean(this.module.id || this.module.idModule || this.params.idModule);
}

function changeApplication() {
	this.showMenuPreview = false;
	this.actions = [];
	this.app = {};
	this.module = {};
	this.modules = [];
	this.resource = {};
	this.resources = [];
	this.params.codeApp = null;
	this.params.idModule = null;
	this.params.idResource = null;
	this.apps = this.apps.map(function (app) {
		return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, app, { isActive: false });
	});
}

function changeModule() {
	this.showMenuPreview = false;
	this.actions = [];
	this.module = {};
	this.resource = {};
	this.resources = [];
	this.params.idModule = null;
	this.params.idResource = null;
	this.modules = this.modules.map(function (module) {
		return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, module, { isActive: false });
	});
}

function clearData() {
	this.showMenuPreview = false;
	this.hasSavedConfigurationChanges = false;
	this.actions = [];
	this.app = {};
	this.apps = [];
	this.barActionSelected = {};
	this.module = {};
	this.modules = [];
	this.resource = null;
	this.resources = [];
	this.params = {
		codeApp: null,
		codeRole: null,
		idModule: null,
		idResource: null,
		page: null,
		perPage: null
	};
}

function getAppName() {
	return getDeeper('name')(this.app);
}

function getModuleName() {
	return getDeeper('name')(this.module);
}

function getResourceName(_ref5) {
	var resourceId = _ref5.resourceId;

	var _ref6 = find(equality('id', resourceId), this.resources) || {},
	    name = _ref6.name;

	return name || '--';
}

function assignmentIcon(item) {
	return item.pathIcon || getDeeper('templateLanguages', 'pathIcon')(item) || '';
}

function assignmentSubtitle(app) {
	return String(app.code || app.codeApp || '').trim();
}

function moduleSubtitle(mod) {
	var position = this.modulePositionLabel(mod);
	return assignmentEnabled(mod) && position !== '—' ? 'Posici\xF3n ' + position : '';
}

function moduleIcon(mod) {
	return mod.pathIcon || getDeeper('templateLanguages', 'pathIcon')(mod) || '';
}

function resourceIcon(resource) {
	return resource.pathIcon || getDeeper('templateLanguages', 'pathIcon')(resource) || '';
}

function hideBrokenImage(_ref7) {
	var target = _ref7.target;

	target.classList.add('is-hidden');
}

function resourcesExist() {
	return this.resources.length > 0;
}

function modulesExist() {
	return this.modules.length > 0;
}

function appsExist() {
	return this.apps.length > 0;
}

function activeResourcesCount() {
	return this.resources.filter(function (resource) {
		return resource.isSelected;
	}).length;
}

function inactiveResourcesCount() {
	return this.resources.length - this.activeResourcesCount;
}

function nextPosition(items) {
	var positions = items.filter(assignmentEnabled).map(function (item) {
		return Number(getDeeper('templateLanguages', 'position')(item) || item.position);
	}).filter(function (position) {
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_finite___default()(position) && position > 0;
	});
	return positions.length ? Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(positions)) + 1 : 1;
}

function nextModulePosition() {
	return nextPosition(this.modules);
}

function suggestedPosition() {
	return this.action.code === 'module' ? this.nextModulePosition : nextPosition(this.resources);
}

function openModuleAndResourceConfiguration(flag, reso) {
	var required = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

	this.updateCurrentModuleOrResource(flag, reso);
	if (flag !== 'list-service') {
		var opt = {
			module: this.actionModule,
			resource: this.actionResource
		};
		this.action = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, opt[flag]);
		this.configurationRequired = required;
	}
}

function closeConfiguration() {
	var pendingResource = this.pendingResourceConfiguration;
	this.defaultAction();
	if (pendingResource) {
		this.cancelResourceActivation(pendingResource);
	}
	if (this.configurationRequired) {
		this.configurationRequired = false;
		this.changeModule();
	}
}

function cancelResourceActivation(pendingResource) {
	var storedResource = find(equality('id', pendingResource.id), this.resources) || pendingResource;
	if (!storedResource.isSelected) return;
	this.resourceSelectAction(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, storedResource, { isSelected: false }), true, false);
}

function closeAssignmentSidebar() {
	if (this.chooseAction) {
		this.closeConfiguration();
	} else {
		this.clearTemporalSelected();
	}
}

function defaultAction() {
	this.pendingResourceConfiguration = null;
	this.action = {
		code: null,
		open: false,
		title: '',
		templateLanguagesArray: []
	};
}

function clearTemporalSelected() {
	this.action = {
		code: null,
		open: false,
		title: ''
	};
	if (this.dataSelected.length > 0) {
		this.dataSelected = [];
	}
}

function updateCurrentModuleOrResource(flag, reso) {
	var templateLanguages = reso.templateLanguages;

	var newFlag = flag;
	if (flag === 'list-service') {
		newFlag = 'resource';
	}
	if (templateLanguages) {
		var languages = this.getLanguages(templateLanguages);
		this[newFlag] = setNewProperty('templateLanguagesArray', languages)(reso);
	} else {
		var _languages = this.languages.map(setNewProperty('name', ''));
		this[newFlag] = setNewProperty('templateLanguagesArray', _languages)(reso);
	}
}

function getLanguages(_ref8) {
	var languages = _ref8.languages;

	var currentLanguages = languages || {};
	return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(currentLanguages).map(function (lan) {
		return currentLanguages[lan];
	});
}

function itemLanguages(item) {
	return getDeeper('templateLanguages', 'languages')(item) || item.languages || null;
}

function resourceLanguagesStatus(resource) {
	var languages = this.itemLanguages(resource) || {};
	var namesByCode = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(languages).reduce(function (result, key) {
		return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, result, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, String(key).toLowerCase(), String((languages[key] || {}).name || '').trim()));
	}, {});
	var codes = this.languages.length ? this.languages.map(function (language) {
		return String(language.id || '');
	}) : ['En', 'Es'];
	return codes.filter(function (code) {
		return code;
	}).map(function (code) {
		var name = namesByCode[code.toLowerCase()] || '';
		return { code: code.toUpperCase(), filled: Boolean(name), name: name };
	});
}

function isConfigured(item) {
	var languages = this.itemLanguages(item);
	if (!languages) return false;
	var names = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(languages).map(function (key) {
		return (languages[key] || {}).name;
	});
	return Boolean(names.length) && names.every(function (name) {
		return String(name || '').trim();
	});
}

function setImageResource(img) {
	var flag = this.action.code;
	if (flag === 'module' || flag === 'resource') {
		this[flag].pathIcon = img.urlImage;
	}
}

function newRol() {
	this.action = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, this.actionNewRol);
}

function openActionsBarModal(action) {
	this.actions = [];
	this.resource = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, action);
	this.getData(action, 'resource', 'idResource', 'actions');
	this.action = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, this.actionBarActions);
}

function appUseIcon(app) {
	return assignmentEnabled(app) || app.isActive ? ['close'] : [];
}

function syncCurrentAppConfiguration(hasConfiguration) {
	var _this5 = this;

	if (!this.app || !this.app.id && !this.app.codeApp) return;
	this.app = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, this.app, { hasConfiguredChildren: hasConfiguration });
	this.apps = this.apps.map(function (app) {
		var isCurrent = _this5.app.id ? app.id === _this5.app.id : app.codeApp === _this5.app.codeApp;
		return isCurrent ? __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, app, { hasConfiguredChildren: hasConfiguration }) : app;
	});
}

function moduleUseIcon() {
	return ['edit'];
}

function sortAssignmentItems(first, second) {
	var enabledDifference = Number(assignmentEnabled(second)) - Number(assignmentEnabled(first));
	if (enabledDifference !== 0) {
		return enabledDifference;
	}
	var activeDifference = Number(Boolean(second.isActive)) - Number(Boolean(first.isActive));
	if (activeDifference !== 0) {
		return activeDifference;
	}
	return String(first.name || '').localeCompare(String(second.name || ''), 'es');
}

function sortedApps() {
	return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.apps)).sort(sortAssignmentItems);
}

function sortedModules() {
	return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.modules)).sort(sortAssignmentItems);
}

function modulePosition(mod) {
	var position = Number(getDeeper('templateLanguages', 'position')(mod) || mod.position);
	return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_finite___default()(position) && position > 0 ? position : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_max_safe_integer___default.a;
}

function configuredModulesPreview() {
	var _this6 = this;

	return this.modules.filter(assignmentEnabled).sort(function (first, second) {
		var positionDifference = modulePosition(first) - modulePosition(second);
		if (positionDifference !== 0) {
			return positionDifference;
		}
		return _this6.moduleDisplayName(first).localeCompare(_this6.moduleDisplayName(second), 'es');
	});
}

function moduleDisplayName(mod) {
	var languages = getDeeper('templateLanguages', 'languages')(mod) || mod.languages || {};
	var spanish = languages.es || languages.Es || {};
	var english = languages.en || languages.En || {};
	return spanish.name || english.name || mod.name || 'Módulo sin nombre';
}

function modulePositionLabel(mod) {
	var position = modulePosition(mod);
	return position === __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_max_safe_integer___default.a ? '—' : position;
}

function isCurrentModule(mod) {
	var currentId = this.module.id || this.module.idModule;
	var moduleId = mod.id || mod.idModule;
	return Boolean(currentId && moduleId && String(currentId) === String(moduleId));
}

function selectModuleFromPreview(mod) {
	if (!this.isCurrentModule(mod)) {
		this.getData(mod, 'module', 'idModule', 'resources');
	}
	this.showMenuPreview = false;
}

function showModulePicker() {
	this.changeModule();
	this.showMenuPreview = false;
}

function resourceDisplayName(resourceItem) {
	var languages = getDeeper('templateLanguages', 'languages')(resourceItem) || resourceItem.languages || {};
	var spanish = languages.es || languages.Es || {};
	var english = languages.en || languages.En || {};
	return spanish.name || english.name || resourceItem.name || 'Submenú sin nombre';
}

function resourcePositionLabel(resourceItem) {
	var position = this.resourcePosition(resourceItem);
	return position === __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_max_safe_integer___default.a ? '—' : position;
}

function moduleResourcesForPreview(mod) {
	var _this7 = this;

	if (!this.isCurrentModule(mod)) {
		return [];
	}
	return this.resources.filter(function (resourceItem) {
		return resourceItem.isSelected && !resourceItem.flagDelete;
	}).sort(function (first, second) {
		var positionDifference = _this7.resourcePosition(first) - _this7.resourcePosition(second);
		if (positionDifference !== 0) {
			return positionDifference;
		}
		return _this7.resourceDisplayName(first).localeCompare(_this7.resourceDisplayName(second), 'es');
	});
}

function openMenuPreview() {
	this.showMenuPreview = true;
}

function enabledAppsCount() {
	return this.apps.filter(assignmentEnabled).length;
}

function enabledModulesCount() {
	return this.modules.filter(assignmentEnabled).length;
}

function chooseAction() {
	return this.action.code === 'module' || this.action.code === 'resource';
}

function chooseResource() {
	var returnedObj = {};
	if (this.action.code === 'module') {
		returnedObj = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, this.module);
	} else if (this.action.code === 'resource') {
		returnedObj = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, this.resource);
	}
	return returnedObj;
}

function updateRoleIdsInfo(resource) {
	var newResource = compose(setNewProperty('flagActions', true), setNewProperty('flagStatus', true), setNewProperty('isSelected', true))(resource);
	this.updateRoleAndResources(newResource);
	this.resources = updateItemInCollection('id', newResource, this.resources);
}

function configured(mod) {
	return assignmentEnabled(mod);
}

function cancelAction() {
	this.$router.go(-1);
}

function stayOnAssignment() {
	this.distributionQuestion = false;
}

function goToDistribution() {
	this.distributionQuestion = false;
	this.goTo('page-distribution-of-resources', {
		params: { idDistribution: this.templateCode }
	});
}

function closeRolModal(_ref13) {
	var reCharge = _ref13.reCharge;

	this.defaultAction();
	if (reCharge) {
		this.loadResources('roles');
	}
}

function selectAll(value) {
	this.actions = this.actions.map(setNewProperty('isSelected', value));
}

function rowIsSelected(row) {
	this.actions = updateItemInCollection('id', row, this.actions);
	if (row.isSelected) {
		this.dataSelected.push(row);
	} else {
		var index = this.dataSelected.findIndex(function (r) {
			return r.id === row.id;
		});
		if (index > -1) this.dataSelected.splice(index, 1);
	}
}

function getActionsSelected(actions) {
	return actions.reduce(function (list, item) {
		if (item.isSelected) {
			return list.concat(item.id);
		}
		return list;
	}, []);
}

function deleteModuleConfiguration(item) {
	var templateLanguages = item.templateLanguages;
	var languages = templateLanguages.languages;

	return compose(setNewProperty('flagStatus', false), setNewProperty('isSelected', false), setNewProperty('flagActions', false), setNewProperty('flagDelete', true), setNewProperty('languages', languages), setNewProperty('codeRole', this.roleCode))(item);
}

function createTemplateLanguages(flag) {
	var _this9 = this;

	this[flag].templateLanguages = { languages: {} };
	this[flag].templateLanguagesArray.forEach(function (lan) {
		_this9[flag].templateLanguages.languages[lan.id] = lan;
	});
}

function queueConfigurationItem(collection, item) {
	var items = this.model[collection] || [];
	var index = items.findIndex(function (current) {
		return current.id === item.id;
	});
	if (index > -1) {
		this.model[collection].splice(index, 1, item);
	} else {
		this.$set(this.model, collection, items.concat(item));
	}
}

function saveData(resource, newPosition) {
	var resour = resource;
	var flag = this.action.code;
	this[flag].pathIcon = resour.pathIcon;
	this.createTemplateLanguages(flag);
	var languages = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, this[flag].templateLanguages.languages);
	var newLanguages = {};
	newLanguages.es = languages.Es || languages.es;
	newLanguages.en = languages.En || languages.en;
	this[flag] = compose(setNewProperty('disabled', false), setNewProperty('isSelected', true), setNewProperty('flagStatus', true), setNewProperty('flagActions', true), setNewProperty('flagDelete', false), setNewProperty('languages', newLanguages), setNewProperty('codeRole', this.roleCode))(this[flag]);
	var keys = {
		resource: 'resourceIds',
		module: 'moduleIds'
	};
	this.queueConfigurationItem(keys[flag], this[flag]);
	if (flag === 'resource') {
		this.updateRoleIdsInfo(this[flag]);
		var index = this.resources.findIndex(function (r) {
			return r.id === resour.id;
		});
		var position = Number(newPosition || getDeeper('templateLanguages', 'position')(resour) || resour.position) || 1;
		this[flag].position = position;
		if (index > -1) {
			var currentResource = this.resources[index];
			if (!currentResource.templateLanguages) {
				this.$set(currentResource, 'templateLanguages', { languages: {} });
			}
			this.$set(currentResource.templateLanguages, 'position', position);
			this.$set(currentResource, 'position', position);
		}
	} else {
		var indexMo = this.modules.findIndex(function (r) {
			return r.id === resour.id;
		});
		this.modules[indexMo].position = Number(newPosition || resour.templateLanguages.position);
		this[flag].position = Number(newPosition || resour.templateLanguages.position);
		var array = flag + 's';
		this[array] = updateItemInCollection('id', this[flag], this[array]);
	}
	this.defaultAction();
	if (flag === 'module') {
		this.configurationRequired = false;
		this.loadResources('resources', this.module);
	}
}

function modelEmpty() {
	return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.model).length === 0;
}

function hasSelectedRole() {
	return Boolean(this.rolSelected && (this.rolSelected.code || this.rolSelected.id));
}

function canFinishConfiguration() {
	return this.hasSelectedRole && (!this.modelEmpty || this.hasSavedConfigurationChanges);
}

function inverseValue(prop) {
	return function inner(item) {
		return !item[prop];
	};
}

function resourceSelectAction(resource) {
	var normalizePositions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	var askConfiguration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

	var selectionKey = this.resourceSelectionKey(resource);
	var currentSelection = Boolean(resource.isSelected);
	var hasBaseline = Object.prototype.hasOwnProperty.call(this.resourceSelectionBaseline, selectionKey);
	var baselineSelection = hasBaseline ? this.resourceSelectionBaseline[selectionKey] : !currentSelection;
	var undoState = this.resourceSelectionUndo[selectionKey];
	if (currentSelection === baselineSelection && undoState) {
		var currentModel = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(this.model || {});
		if (currentModel === undoState.after) {
			this.model = clonePendingModel(undoState.before);
			this.resources = updateItemInCollection('id', resource, this.resources);
			this.normalizeResourcePositions(null, false);
			this.syncCheckAllResources();
			this.$delete(this.resourceSelectionUndo, selectionKey);
			return;
		}
	}
	if (!undoState && currentSelection !== baselineSelection) {
		this.$set(this.resourceSelectionUndo, selectionKey, {
			before: clonePendingModel(this.model),
			after: ''
		});
	}
	var newResource = compose(setNewPropertyByFunction('flagDelete', this.inverseValue('isSelected')), setNewProperty('flagStatus', true), setNewProperty('flagActions', true))(resource);
	this.updateRoleAndResources(newResource);
	this.resources = updateItemInCollection('id', newResource, this.resources);
	if (normalizePositions) {
		this.normalizeResourcePositions();
	}
	this.syncCheckAllResources();
	if (this.resourceSelectionUndo[selectionKey]) {
		this.resourceSelectionUndo[selectionKey].after = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(this.model || {});
	}
	if (askConfiguration && newResource.isSelected && !this.isConfigured(newResource)) {
		var storedResource = find(equality('id', newResource.id), this.resources) || newResource;
		this.openModuleAndResourceConfiguration('resource', storedResource);
		this.pendingResourceConfiguration = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, storedResource);
	}
}

function selectAllResources(value) {
	var _this10 = this;

	var resources = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.resourcesComputed));
	resources.forEach(function (resource) {
		if (Boolean(resource.isSelected) !== value) {
			_this10.resourceSelectAction(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, resource, { isSelected: value }), false, false);
		}
	});
	this.normalizeResourcePositions();
	this.syncCheckAllResources();
}

function updateRoleAndResources(newResource) {
	if (getDeeper('roleIds')(this.model)) {
		var code = this.rolSelected.code;

		var index = this.model.roleIds.findIndex(function (role) {
			return role.code === code;
		});
		if (index > -1) {
			var resume = this.model.roleIds[index].resources;
			var resourceId = newResource.id;

			var i = this.model.roleIds[index].resources.findIndex(function (re) {
				return re.id === resourceId;
			});
			if (i > -1) {
				this.model.roleIds[index].resources.splice(i, 1, newResource);
			} else {
				this.model.roleIds[index].resources = resume.concat(newResource);
			}
		} else {
			var roleSelected = setNewProperty('resources', [newResource])(this.rolSelected);
			this.model.roleIds = this.model.roleIds.concat([roleSelected]);
		}
	} else {
		var _roleSelected = this.setNewRole([newResource]);
		this.model.roleIds = [].concat([_roleSelected]);
	}
}

function matchesResourceSearch(resource, term) {
	if (!term) return true;
	return [resource.name, resource.uri, this.getResourceName(resource)].some(function (value) {
		return String(value || '').toLowerCase().indexOf(term) > -1;
	});
}

function matchesResourceFilter(resource) {
	if (this.resourceFilter === 'active') return Boolean(resource.isSelected);
	if (this.resourceFilter === 'inactive') return !resource.isSelected;
	if (this.resourceFilter === 'pending') return !this.isConfigured(resource);
	return true;
}

function resourcesComputed() {
	var _this11 = this;

	var term = String(this.resourceSearch || '').trim().toLowerCase();
	return this.resources.filter(function (resource) {
		return _this11.matchesResourceFilter(resource) && _this11.matchesResourceSearch(resource, term);
	});
}

function pendingResourcesCount() {
	var _this12 = this;

	return this.resources.filter(function (resource) {
		return !_this12.isConfigured(resource);
	}).length;
}

function pendingChangesCount() {
	return (this.model.resourceIds || []).length;
}

function resourceFilters() {
	return [{
		code: 'all',
		count: this.resources.length,
		hint: 'Todos los recursos del módulo',
		label: 'Todos'
	}, {
		code: 'active',
		count: this.activeResourcesCount,
		hint: 'Recursos ya activados para este rol',
		label: 'Activos'
	}, {
		code: 'inactive',
		count: this.inactiveResourcesCount,
		hint: 'Recursos que aún no se activan',
		label: 'Inactivos'
	}, {
		code: 'pending',
		count: this.pendingResourcesCount,
		hint: 'Recursos sin nombre configurado en algún idioma',
		label: 'Sin nombre'
	}];
}

function noResourcesForFilter() {
	return Boolean(this.resources.length) && !this.resourcesComputed.length;
}

function clearResourceFilters() {
	this.resourceSearch = '';
	this.resourceFilter = 'all';
}

function canMoveResource(resource, delta) {
	if (!resource.isSelected) return false;
	var position = Number(resource.position);
	if (!__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_finite___default()(position)) return false;
	return delta < 0 ? position > 1 : position < this.activeResourcesCount;
}

function moveResource(resource, delta) {
	if (!this.canMoveResource(resource, delta)) return;
	this.normalizeResourcePositions(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, resource, {
		position: Number(resource.position) + delta
	}));
}

function syncCheckAllResources() {
	var visible = this.resourcesComputed;
	this.checkAllResources = Boolean(visible.length) && visible.every(function (row) {
		return row.isSelected;
	});
}

function saveBarActionData() {
	var actions = this.getActionsSelected(this.actions);
	var languages = this.resourceLanguages(this.resource);
	var updatedResource = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, this.resource, {
		actions: actions,
		isSelected: true,
		flagStatus: true,
		flagActions: true,
		flagDelete: false,
		languages: languages
	});
	this.queueConfigurationItem('resourceIds', updatedResource);
	this.updateRoleAndResources(updatedResource);
	this.resources = updateItemInCollection('id', updatedResource, this.resources);
	this.temporalSelected = this.actions.filter(function (action) {
		return action.isSelected;
	});
	this.defaultAction();
	this.dataSelected = [];
}

function checkForResourceIds(id, templateLanguages) {
	var languages = templateLanguages.languages;

	var newResource = compose(setNewProperty('languages', languages), setNewProperty('flagStatus', true), setNewProperty('flagActions', true), createPropertyByOtherOne('id_module', 'moduleId'))(this.resource);
	if (this.model.resourceIds) {
		var indexResource = this.model.resourceIds.findIndex(equality('id', id));
		if (indexResource > -1) {
			this.model.resourceIds[indexResource] = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, newResource);
		} else {
			this.model.resourceIds = this.model.resourceIds.concat(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, newResource));
		}
	} else {
		this.model.resourceIds = [newResource];
	}
}

function checkForRoleIds(id, code, resources, actions) {
	if (this.model.roleIds) {
		var indexRol = this.model.roleIds.findIndex(equality('code', code));
		if (indexRol > -1) {
			var index = this.model.roleIds[indexRol].resources.findIndex(equality('id', id));
			if (index > -1) {
				this.model.roleIds[indexRol].resources[index].actions = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(actions));
			} else {
				this.model.roleIds[indexRol].resources = this.model.roleIds[indexRol].resources.concat(resources);
			}
		} else {
			var newRole = this.setNewRole(resources);
			this.model.roleIds = this.model.roleIds.concat(newRole);
		}
	} else {
		var _newRole = this.setNewRole(resources);
		this.model.roleIds = [].concat(_newRole);
	}
}

function roleCode() {
	var code = this.rolSelected.code;

	return code === null || code === undefined ? code : String(code);
}

function setNewRole(resources) {
	return compose(setNewProperty('flagStatus', true), setNewProperty('resources', resources), createPropertyByOtherOne('nameRole', 'name'), setNewProperty('codeRole', this.roleCode))(this.rolSelected);
}

function saveWebServices(rows) {
	var selectRows = rows.filter(function (r) {
		return r.isSelected;
	});
	var permission = {};
	if (selectRows.length) {
		permission = selectRows.reduce(function (acum, item) {
			var newAcum = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, acum);
			newAcum[item.id] = item.authorize;
			return newAcum;
		}, {});
	}
	this.defaultAction();
	this.resource.permission = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, permission);
	this.resource.flagPermission = true;
	this.resource.flagStatus = true;
	this.action.code = 'resource';
	this.saveData(this.resource, this.resource.position);
}

function selectAllServices(value) {
	this.checkAllServices = value;
	this.webServices = this.webServices.map(setNewProperty('isSelected', value));
}

function rowIsSelectedServices(row) {
	this.webServices = this.selectIsRow(this.webServices, 'isSelected', row);
	this.checkAllServices = this.webServices.every(function (s) {
		return s.isSelected;
	});
}
function data() {
	return {
		action: {
			code: null,
			open: false,
			title: ''
		},
		actionNewRol: {
			code: 'rol',
			open: true,
			title: 'Nuevo rol'
		},
		actions: [],
		actionBarActions: {
			code: 'bar-actions',
			open: true,
			title: 'Asignar barra de acciones'
		},
		actionModule: {
			code: 'module',
			open: true,
			title: 'Configuración del módulo'
		},
		actionListService: {
			code: 'list-service',
			open: true,
			title: 'Nombre del recurso'
		},
		actionResource: {
			code: 'resource',
			open: true,
			title: 'Configuración de Recurso'
		},
		app: {},
		apps: [],
		codeProject: null,
		columns: [{ id: 1, name: 'Nombre del Recurso', checked: true, visible: true }, { id: 2, name: 'URL', checked: true, visible: true }, { id: 3, name: 'Recurso Padre', checked: true, visible: true }, { id: 7, name: 'Nombres', checked: true, visible: true }, { id: 4, name: 'Posición', checked: true, visible: true }, { id: 6, name: 'Ícono', checked: true, visible: true }, { id: 5, name: 'Acciones', checked: true, visible: true }],
		checkAllResources: false,
		configurationRequired: false,
		distributionQuestion: false,
		finalizing: false,
		hasSavedConfigurationChanges: false,
		showMenuPreview: false,
		idTemplate: null,
		templateCode: null,
		languages: [],
		model: {},
		module: {},
		modules: [],
		params: {
			codeApp: null,
			codeRole: null,
			idModule: null,
			idResource: null,
			page: null,
			perPage: null
		},
		pendingResourceConfiguration: null,
		resource: {
			pathIcon: null
		},
		resourceFilter: 'all',
		resourceSearch: '',
		resourceSelectionBaseline: {},
		resourceSelectionUndo: {},
		resources: [],
		roles: [],
		rolSelected: {},
		temporalSelected: [],
		dataSelected: [],
		webServices: [],
		dataSelectdServices: [],
		changeResource: {},
		checkAllServices: false
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'page-resources-assignment',
	components: {
		actionSidebar: __WEBPACK_IMPORTED_MODULE_11__components_shared_action_sidebar__["default"],
		appButton: __WEBPACK_IMPORTED_MODULE_9__components_shared_app_button__["a" /* default */],
		appTooltipButton: __WEBPACK_IMPORTED_MODULE_10__components_shared_app_tooltip_button__["a" /* default */],
		barActions: __WEBPACK_IMPORTED_MODULE_14__components_actions_actions_bar__["a" /* default */],
		newRolComponent: __WEBPACK_IMPORTED_MODULE_13__components_roles_new_rol_component__["a" /* default */],
		resourceConfiguration: __WEBPACK_IMPORTED_MODULE_12__components_resources_resource_configuration__["a" /* default */],
		resourceWebService: __WEBPACK_IMPORTED_MODULE_15__components_resource_service_resource_web_service__["a" /* default */]
	},
	computed: {
		activeResourcesCount: activeResourcesCount,
		appsExist: appsExist,
		chooseAction: chooseAction,
		chooseResource: chooseResource,
		configuredModulesPreview: configuredModulesPreview,
		getAppName: getAppName,
		getModuleName: getModuleName,
		hasSelectedApplication: hasSelectedApplication,
		hasSelectedModule: hasSelectedModule,
		hasSelectedRole: hasSelectedRole,
		canFinishConfiguration: canFinishConfiguration,
		enabledAppsCount: enabledAppsCount,
		enabledModulesCount: enabledModulesCount,
		inactiveResourcesCount: inactiveResourcesCount,
		modelEmpty: modelEmpty,
		modulesExist: modulesExist,
		nextModulePosition: nextModulePosition,
		roleCode: roleCode,
		noResourcesForFilter: noResourcesForFilter,
		pendingChangesCount: pendingChangesCount,
		pendingResourcesCount: pendingResourcesCount,
		resourceFilters: resourceFilters,
		resourcesComputed: resourcesComputed,
		resourcesExist: resourcesExist,
		sortedApps: sortedApps,
		sortedModules: sortedModules,
		suggestedPosition: suggestedPosition
	},
	created: created,
	data: data,
	methods: {
		appUseIcon: appUseIcon,
		canMoveResource: canMoveResource,
		cancelAction: cancelAction,
		cancelResourceActivation: cancelResourceActivation,
		clearResourceFilters: clearResourceFilters,
		changeApplication: changeApplication,
		changeModule: changeModule,
		clearData: clearData,
		clearIdModuleAnResources: clearIdModuleAnResources,
		clearTemporalSelected: clearTemporalSelected,
		closeAssignmentSidebar: closeAssignmentSidebar,
		closeConfiguration: closeConfiguration,
		closeRolModal: closeRolModal,
		checkForResourceIds: checkForResourceIds,
		checkForRoleIds: checkForRoleIds,
		changeResourcePosition: changeResourcePosition,
		configured: configured,
		createTemplateLanguages: createTemplateLanguages,
		defaultAction: defaultAction,
		deleteApplicationConfiguration: deleteApplicationConfiguration,
		deleteConfiguration: deleteConfiguration,
		deleteModuleOnly: deleteModuleOnly,
		deleteModuleConfiguration: deleteModuleConfiguration,
		evaluateTemplateLanguages: evaluateTemplateLanguages,
		getActionsSelected: getActionsSelected,
		inverseValue: inverseValue,
		loadLanguages: loadLanguages,
		loadResources: loadResources,
		loadServices: loadServices,
		getData: getData,
		getLanguages: getLanguages,
		isConfigured: isConfigured,
		itemLanguages: itemLanguages,
		matchesResourceFilter: matchesResourceFilter,
		matchesResourceSearch: matchesResourceSearch,
		moveResource: moveResource,
		syncCheckAllResources: syncCheckAllResources,
		resourceLanguagesStatus: resourceLanguagesStatus,
		getResourceName: getResourceName,
		hideBrokenImage: hideBrokenImage,
		newRol: newRol,
		openActionsBarModal: openActionsBarModal,
		openModuleAndResourceConfiguration: openModuleAndResourceConfiguration,
		openMenuPreview: openMenuPreview,
		assignmentIcon: assignmentIcon,
		assignmentSubtitle: assignmentSubtitle,
		moduleSubtitle: moduleSubtitle,
		moduleUseIcon: moduleUseIcon,
		moduleIcon: moduleIcon,
		moduleDisplayName: moduleDisplayName,
		modulePositionLabel: modulePositionLabel,
		moduleResourcesForPreview: moduleResourcesForPreview,
		normalizeResourcePositions: normalizeResourcePositions,
		prepareCurrentResourcesForSave: prepareCurrentResourcesForSave,
		queueResourcePosition: queueResourcePosition,
		queueConfigurationItem: queueConfigurationItem,
		resourceSelectAction: resourceSelectAction,
		resourceIcon: resourceIcon,
		resourceLanguages: resourceLanguages,
		resourcePosition: resourcePosition,
		resourceDisplayName: resourceDisplayName,
		resourcePositionLabel: resourcePositionLabel,
		resourceSelectionKey: resourceSelectionKey,
		rowIsSelected: rowIsSelected,
		saveBarActionData: saveBarActionData,
		saveAssignmentChanges: saveAssignmentChanges,
		saveData: saveData,
		saveInfo: saveInfo,
		selectAll: selectAll,
		selectAllResources: selectAllResources,
		selectModuleFromPreview: selectModuleFromPreview,
		showModulePicker: showModulePicker,
		syncCurrentAppConfiguration: syncCurrentAppConfiguration,
		isCurrentModule: isCurrentModule,
		setDefaultValues: setDefaultValues,
		setImageResource: setImageResource,
		setNewRole: setNewRole,
		updateCurrentModuleOrResource: updateCurrentModuleOrResource,
		updateIsActiveProperty: updateIsActiveProperty,
		updateResources: updateResources,
		updateRoleAndResources: updateRoleAndResources,
		updateRoleIdsInfo: updateRoleIdsInfo,
		saveWebServices: saveWebServices,
		selectAllServices: selectAllServices,
		rowIsSelectedServices: rowIsSelectedServices,
		finishConfiguration: finishConfiguration,
		stayOnAssignment: stayOnAssignment,
		goToDistribution: goToDistribution
	}
});

/***/ }),

/***/ 828:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_app_tooltip_button__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib__ = __webpack_require__(622);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var matchBetweenArrays = __WEBPACK_IMPORTED_MODULE_1__lib__["a" /* default */].matchBetweenArrays;


function filterIcons() {
	return matchBetweenArrays([this.iconsToUse], [this.icons, 'flag']);
}

function dinamicColor(_ref) {
	var color = _ref.color,
	    flag = _ref.flag;

	if (flag === 'edit') {
		return this.active ? 'white' : color;
	}
	return color;
}

function showIcon() {
	return Boolean(this.iconPath) && !this.iconBroken;
}

function initials() {
	var words = String(this.item.name || '').split(/[^a-zA-Z0-9áéíóúñÁÉÍÓÚÑ]+/).filter(function (word) {
		return word;
	});
	if (!words.length) return '?';
	var letters = words.length > 1 ? '' + words[0][0] + words[1][0] : words[0].substring(0, 2);
	return letters.toUpperCase();
}

function tooltip() {
	var name = this.item.name || '';
	return this.subtitle ? name + ' \xB7 ' + this.subtitle : name;
}

function markIconAsBroken() {
	this.iconBroken = true;
}

function buttonClicked() {
	this.$emit('button-clicked', this.item);
}

function iconAction(icon) {
	var name = icon.name;

	var opt = {
		edit: 'edit-button',
		highlight_off: 'erase-configuration'
	};
	this.$emit(opt[name], this.item);
}

function watchIconPath() {
	this.iconBroken = false;
}

function data() {
	return {
		iconBroken: false,
		icons: [{ name: 'edit', color: 'success', text: 'editar', flag: 'edit' }, { name: 'highlight_off', color: 'error', text: 'borrar configuración', flag: 'close' }]
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-button',
	components: {
		appTooltipButton: __WEBPACK_IMPORTED_MODULE_0__components_shared_app_tooltip_button__["a" /* default */]
	},
	computed: {
		filterIcons: filterIcons,
		initials: initials,
		showIcon: showIcon,
		tooltip: tooltip
	},
	data: data,
	methods: {
		buttonClicked: buttonClicked,
		dinamicColor: dinamicColor,
		iconAction: iconAction,
		markIconAsBroken: markIconAsBroken
	},
	props: {
		active: {
			default: false,
			type: Boolean
		},
		configured: {
			default: false,
			type: Boolean
		},
		iconPath: {
			default: '',
			type: String
		},
		item: {
			default: function _default() {
				return {};
			},
			type: Object
		},
		iconsToUse: {
			default: function _default() {
				return [];
			},
			type: Array
		},
		stateText: {
			default: 'Configurado',
			type: String
		},
		subtitle: {
			default: '',
			type: String
		}
	},
	watch: {
		iconPath: watchIconPath
	}
});

/***/ }),

/***/ 829:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_upload_image__ = __webpack_require__(607);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function created() {
	this.codeProject = this.$route.params.codeProject;
	var currentPosition = Number(this.resource.position || this.resource.templateLanguages && this.resource.templateLanguages.position);
	var automaticPosition = currentPosition || this.suggestedPosition;
	this.resource.position = automaticPosition;
	if (this.resource.templateLanguages) {
		if (!this.resource.templateLanguages.position) {
			this.$set(this.resource.templateLanguages, 'position', automaticPosition);
		}
	} else {
		this.newPosition = automaticPosition;
	}
}

function getImage(img) {
	this.iconBroken = false;
	this.resource.pathIcon = img.urlImage;
	this.$emit('set-image', img);
}

function markIconAsBroken() {
	this.iconBroken = true;
}

function showIconPreview() {
	return Boolean(this.resource.pathIcon) && !this.iconBroken;
}

function watchPathIcon() {
	this.iconBroken = false;
}

function languageNames() {
	return this.resource.templateLanguagesArray || [];
}

function namesBadge() {
	var languages = this.languageNames;
	var complete = languages.filter(function (language) {
		return String(language.name || '').trim();
	}).length;
	return languages.length ? complete + '/' + languages.length + ' listos' : '';
}

function footerHelper() {
	if (!this.$v.$invalid) return 'Todo listo para guardar.';
	var pending = this.languageNames.filter(function (language) {
		return !String(language.name || '').trim();
	}).map(function (language) {
		return language.id;
	});
	if (pending.length) return 'Falta el nombre en: ' + pending.join(', ') + '.';
	return this.requireIcon ? 'Falta cargar el ícono.' : 'Completa los datos requeridos.';
}

function itWasUpdated() {
	this.$emit('item-edited');
}

function recommendedName() {
	return this.resource.name || this.resource.title || '';
}

function hasRecommendedName() {
	return Boolean(this.recommendedName);
}

function useRecommendedName() {
	var _this = this;

	if (!this.hasRecommendedName) return;
	(this.resource.templateLanguagesArray || []).forEach(function (language) {
		if (!language.name) {
			_this.$set(language, 'name', _this.recommendedName);
		}
	});
	this.itWasUpdated();
}

function validations() {
	return {
		resource: {
			pathIcon: this.requireIcon ? { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"] } : {},
			position: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"] },
			templateLanguagesArray: {
				$each: {
					name: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"] }
				}
			}
		}
	};
}

function data() {
	return {
		codeProject: '',
		iconBroken: false,
		position: 0,
		newPosition: null
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'resource-configuration',
	components: {
		uploadImage: __WEBPACK_IMPORTED_MODULE_1__components_shared_upload_image__["a" /* default */]
	},
	created: created,
	computed: {
		footerHelper: footerHelper,
		hasRecommendedName: hasRecommendedName,
		languageNames: languageNames,
		namesBadge: namesBadge,
		recommendedName: recommendedName,
		showIconPreview: showIconPreview
	},
	data: data,
	methods: {
		getImage: getImage,
		itWasUpdated: itWasUpdated,
		markIconAsBroken: markIconAsBroken,
		useRecommendedName: useRecommendedName
	},
	props: {
		requireIcon: {
			default: true,
			type: Boolean
		},
		resource: {
			default: function _default() {},
			type: Object
		},
		suggestedPosition: {
			default: 1,
			type: Number
		}
	},
	validations: validations,
	watch: {
		'resource.pathIcon': watchPathIcon
	}
});

/***/ }),

/***/ 830:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);



var loadData = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
		var codeProject, url, _ref2, response;

		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						codeProject = this.$route.params.codeProject;
						url = 'types-roles?codeProject=' + codeProject;
						_context.next = 4;
						return this.$http.get(url);

					case 4:
						_ref2 = _context.sent;
						response = _ref2.data;

						this.globalRoles = response.data;

					case 7:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function loadData() {
		return _ref.apply(this, arguments);
	};
}();

var createNewRole = function () {
	var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
		var idTemplate, url, headers, body;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						idTemplate = this.$route.params.idTemplate;
						url = 'distribution-template/' + idTemplate;
						headers = {
							Accept: '' + 'application/vnd.apiacl.v2+json'
						};
						body = {
							roleIds: [{
								code: this.globalRoleSelected.code,
								codeRole: String(this.code),
								flagStatus: true,
								isAdmin: this.flagAdmin ? 1 : 0,
								name: this.globalRoleSelected.name,
								nameRole: this.name,
								resources: [],
								typeRoleId: this.globalRoleSelected.id
							}]
						};
						_context2.next = 6;
						return this.$http.patch(url, body, { headers: headers });

					case 6:
						this.showNotification('Rol creado exitosamente');
						this.closeModal(true);

					case 8:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this);
	}));

	return function createNewRole() {
		return _ref3.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function created() {
	this.loadData();
}

function closeModal(flag) {
	this.$emit('close-modal', { reCharge: flag });
}

function validations() {
	return {
		code: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] },
		flagAdmin: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] },
		globalRoleSelected: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] },
		name: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] }
	};
}

function data() {
	return {
		code: '',
		flagAdmin: false,
		globalRoles: [{ id: 0, title: 'Role de ejemplo' }],
		globalRoleSelected: null,
		name: ''
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'new-rol-component',
	created: created,
	data: data,
	methods: {
		closeModal: closeModal,
		createNewRole: createNewRole,
		loadData: loadData
	},
	validations: validations
});

/***/ }),

/***/ 831:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib__ = __webpack_require__(622);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var getDeeper = __WEBPACK_IMPORTED_MODULE_1__lib__["a" /* default */].getDeeper;


function getName(row) {
	return getDeeper('languages', 'es', 'name')(row);
}

function allIsSelected(value) {
	this.checkAll = value;
	this.$emit('select-all', value);
}

function rowIsSelected(row) {
	this.$emit('row-is-selected', row);
}

function serializedActions() {
	return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.actions.map(function (action) {
		return {
			id: action.id,
			isSelected: Boolean(action.isSelected),
			numFragment: Number(action.numFragment || 0),
			position: Number(action.position || 0)
		};
	}));
}

function hasChanges() {
	return Boolean(this.selectionBaseline) && this.serializedActions !== this.selectionBaseline;
}

function saveChanges() {
	if (!this.hasChanges) return;
	this.$emit('save-data');
}

function data() {
	return {
		checkAll: false,
		selectionBaseline: '',
		columns: [{ id: 1, name: 'Nombre', checked: true, visible: true }, { id: 2, name: 'Código', checked: true, visible: true }, { id: 3, name: 'URL Web', checked: true, visible: true }, { id: 4, name: 'Frag. Movil', checked: true, visible: true }, { id: 5, name: 'Posición', checked: true, visible: true }]
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'actions-bar',
	computed: {
		hasChanges: hasChanges,
		serializedActions: serializedActions
	},
	data: data,
	methods: {
		allIsSelected: allIsSelected,
		rowIsSelected: rowIsSelected,
		getName: getName,
		saveChanges: saveChanges
	},
	props: {
		actions: {
			default: function _default() {
				return [];
			},
			type: Array
		}
	},
	watch: {
		actions: {
			immediate: true,
			handler: function handler() {
				var _this = this;

				if (this.selectionBaseline || !this.actions.length) return;
				this.$nextTick(function () {
					_this.selectionBaseline = _this.serializedActions;
					_this.checkAll = _this.actions.length > 0 && _this.actions.every(function (action) {
						return action.isSelected;
					});
				});
			}
		}
	}
});

/***/ }),

/***/ 832:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function allIsSelected(value) {
	this.$emit('select-all', value);
}

function rowIsSelected(row) {
	this.$emit('row-is-selected', row);
}

function data() {
	return {
		columns: [{ id: 1, name: 'Dominio', checked: true, visible: true }, { id: 2, name: 'Método', checked: true, visible: true }, { id: 3, name: 'URI', checked: true, visible: true }, { id: 4, name: 'Nombre', checked: true, visible: true }, { id: 5, name: 'Auth', checked: true, visible: true }],
		currentPage: 1,
		lastPage: 0
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'resource-search',
	data: data,
	methods: {
		allIsSelected: allIsSelected,
		rowIsSelected: rowIsSelected
	},
	props: {
		webServices: {
			default: function _default() {
				return [];
			},
			type: Array
		},
		checkAll: {
			default: false,
			type: Boolean
		}
	}
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/14.99f49bf35a20bfec05b8.js